/* tslint:disable */
/* eslint-disable */
/**
 * Curewiki Matching Service
 * The Curewiki matching service API - Collecting user attributes and interacting with the user chat   Don\'t forget to add the prefix (**match**)  Some other useful links:   - [Identity service](../identity/docs)  - [Matching service](../match/docs)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptExistingTeamInviteBody
 */
export interface AcceptExistingTeamInviteBody {
    /**
     * 
     * @type {string}
     * @memberof AcceptExistingTeamInviteBody
     */
    'tokenValue': string;
}
/**
 * 
 * @export
 * @interface AcceptExistingUserInviteBody
 */
export interface AcceptExistingUserInviteBody {
    /**
     * 
     * @type {string}
     * @memberof AcceptExistingUserInviteBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptExistingUserInviteBody
     */
    'teamRole'?: string;
}
/**
 * 
 * @export
 * @interface AcceptNewUserInviteBody
 */
export interface AcceptNewUserInviteBody {
    /**
     * 
     * @type {Language}
     * @memberof AcceptNewUserInviteBody
     */
    'language': Language;
    /**
     * 
     * @type {ThemeType}
     * @memberof AcceptNewUserInviteBody
     */
    'theme': ThemeType;
    /**
     * 
     * @type {Gender}
     * @memberof AcceptNewUserInviteBody
     */
    'gender'?: Gender;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'teamRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'birthDate'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AcceptNewUserInviteBody
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AcceptNewUserInviteBody
     */
    'hospital'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AccessRequestStatus = {
    None: 'none',
    Pending: 'pending',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type AccessRequestStatus = typeof AccessRequestStatus[keyof typeof AccessRequestStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const ActivityType = {
    Create: 'create',
    Deactivate: 'deactivate',
    Feedback: 'feedback',
    Comment: 'comment',
    Validate: 'validate',
    Synced: 'synced',
    Deleted: 'deleted',
    Completed: 'completed',
    Restored: 'restored',
    RequestCriteria: 'requestCriteria',
    AddEffect: 'addEffect',
    RemoveEffect: 'removeEffect'
} as const;

export type ActivityType = typeof ActivityType[keyof typeof ActivityType];


/**
 * 
 * @export
 * @interface AddCategoryDiseaseBody
 */
export interface AddCategoryDiseaseBody {
    /**
     * 
     * @type {string}
     * @memberof AddCategoryDiseaseBody
     */
    'diseaseId': string;
}
/**
 * 
 * @export
 * @interface AddQuestionCategoryBody
 */
export interface AddQuestionCategoryBody {
    /**
     * 
     * @type {string}
     * @memberof AddQuestionCategoryBody
     */
    'categoryId': string;
}
/**
 * 
 * @export
 * @interface AdminOverviewView
 */
export interface AdminOverviewView {
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverviewView
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface AdminTrialAccessListView
 */
export interface AdminTrialAccessListView {
    /**
     * 
     * @type {Array<AdminTrialAccessView>}
     * @memberof AdminTrialAccessListView
     */
    'items': Array<AdminTrialAccessView>;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessListView
     */
    'nextPageToken'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminTrialAccessListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminTrialAccessView
 */
export interface AdminTrialAccessView {
    /**
     * 
     * @type {Language}
     * @memberof AdminTrialAccessView
     */
    'language': Language;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AdminTrialAccessView
     */
    'status': AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'matchingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'teamName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'teamLeadName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'researchSiteName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'requestMessage': string;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'role': AdminTrialAccessViewRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTrialAccessView
     */
    'isExistingTrial': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminTrialAccessView
     */
    'isManaged': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminTrialAccessView
     */
    'createdAt': string;
    /**
     * 
     * @type {TrialAccessLocation}
     * @memberof AdminTrialAccessView
     */
    'location'?: TrialAccessLocation;
}

export const AdminTrialAccessViewRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type AdminTrialAccessViewRoleEnum = typeof AdminTrialAccessViewRoleEnum[keyof typeof AdminTrialAccessViewRoleEnum];

/**
 * 
 * @export
 * @interface AiProcessorView
 */
export interface AiProcessorView {
    /**
     * 
     * @type {string}
     * @memberof AiProcessorView
     */
    'modelName': string;
    /**
     * 
     * @type {string}
     * @memberof AiProcessorView
     */
    'provider': string;
}
/**
 * 
 * @export
 * @interface AnonymousClaimBody
 */
export interface AnonymousClaimBody {
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousClaimBody
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface AnonymousLoginView
 */
export interface AnonymousLoginView {
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof AnonymousLoginView
     */
    'refreshToken': string;
}
/**
 * 
 * @export
 * @interface AnonymousSignUpBody
 */
export interface AnonymousSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof AnonymousSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {ThemeType}
     * @memberof AnonymousSignUpBody
     */
    'theme'?: ThemeType;
}


/**
 * 
 * @export
 * @interface AnswerChatBody
 */
export interface AnswerChatBody {
    /**
     * 
     * @type {Language}
     * @memberof AnswerChatBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof AnswerChatBody
     */
    'value': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AnswerType = {
    Boolean: 'boolean',
    Number: 'number',
    String: 'string',
    Date: 'date',
    Options: 'options',
    MultipleOptions: 'multipleOptions'
} as const;

export type AnswerType = typeof AnswerType[keyof typeof AnswerType];


/**
 * 
 * @export
 * @interface AssignMandateBody
 */
export interface AssignMandateBody {
    /**
     * 
     * @type {string}
     * @memberof AssignMandateBody
     */
    'teamId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AttributeFilter = {
    Hidden: 'hidden',
    Visible: 'visible',
    All: 'all',
    Profile: 'profile'
} as const;

export type AttributeFilter = typeof AttributeFilter[keyof typeof AttributeFilter];


/**
 * 
 * @export
 * @interface AttributeView
 */
export interface AttributeView {
    /**
     * 
     * @type {AnswerType}
     * @memberof AttributeView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'translationKey': string;
    /**
     * 
     * @type {string}
     * @memberof AttributeView
     */
    'answer': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BehalfOf = {
    Myself: 'myself',
    Child: 'child'
} as const;

export type BehalfOf = typeof BehalfOf[keyof typeof BehalfOf];


/**
 * 
 * @export
 * @enum {string}
 */

export const BillingType = {
    Free: 'free',
    Premium: 'premium'
} as const;

export type BillingType = typeof BillingType[keyof typeof BillingType];


/**
 * 
 * @export
 * @interface CategoryContextTranslationView
 */
export interface CategoryContextTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof CategoryContextTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof CategoryContextTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryContextTranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof CategoryContextTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryContextTranslationView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryContextTranslationView
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface CategoryContextTranslationsBody
 */
export interface CategoryContextTranslationsBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof CategoryContextTranslationsBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface CategoryCreateBody
 */
export interface CategoryCreateBody {
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'parentCategoryId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryCreateBody
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'context'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryCreateBody
     */
    'type': CategoryCreateBodyTypeEnum;
}

export const CategoryCreateBodyTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategoryCreateBodyTypeEnum = typeof CategoryCreateBodyTypeEnum[keyof typeof CategoryCreateBodyTypeEnum];

/**
 * 
 * @export
 * @interface CategoryDetailsView
 */
export interface CategoryDetailsView {
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'shortName': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'parentCategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'context'?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryDetailsView
     */
    'contextKey'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryDetailsView
     */
    'type': CategoryDetailsViewTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof CategoryDetailsView
     */
    'priority': number;
}

export const CategoryDetailsViewTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategoryDetailsViewTypeEnum = typeof CategoryDetailsViewTypeEnum[keyof typeof CategoryDetailsViewTypeEnum];

/**
 * 
 * @export
 * @interface CategoryDiseaseView
 */
export interface CategoryDiseaseView {
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'diseaseId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDiseaseView
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CategoryOrderBy = {
    ShortName: 'shortName',
    TrialCount: 'trialCount'
} as const;

export type CategoryOrderBy = typeof CategoryOrderBy[keyof typeof CategoryOrderBy];


/**
 * 
 * @export
 * @interface CategoryQuestionView
 */
export interface CategoryQuestionView {
    /**
     * 
     * @type {AnswerType}
     * @memberof CategoryQuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {QuestionType}
     * @memberof CategoryQuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {string}
     * @memberof CategoryQuestionView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryQuestionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof CategoryQuestionView
     */
    'questionText': string;
}


/**
 * 
 * @export
 * @interface CategorySearchView
 */
export interface CategorySearchView {
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'shortName': string;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'parentCategory'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategorySearchView
     */
    'diseases': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CategorySearchView
     */
    'icdCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CategorySearchView
     */
    'type': CategorySearchViewTypeEnum;
}

export const CategorySearchViewTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategorySearchViewTypeEnum = typeof CategorySearchViewTypeEnum[keyof typeof CategorySearchViewTypeEnum];

/**
 * 
 * @export
 * @interface CategoryTreeView
 */
export interface CategoryTreeView {
    /**
     * 
     * @type {Array<NestedCategoryView>}
     * @memberof CategoryTreeView
     */
    'topLevelCategories': Array<NestedCategoryView>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CategoryType = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type CategoryType = typeof CategoryType[keyof typeof CategoryType];


/**
 * 
 * @export
 * @interface CategoryUpdateBody
 */
export interface CategoryUpdateBody {
    /**
     * 
     * @type {number}
     * @memberof CategoryUpdateBody
     */
    'priority'?: number;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateBody
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryUpdateBody
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChatEntryDestination = {
    MyTrials: 'myTrials',
    Trial: 'trial',
    Support: 'support',
    Volunteers: 'volunteers',
    Collaborators: 'collaborators',
    Survey: 'survey',
    MySurveys: 'mySurveys',
    Research: 'research'
} as const;

export type ChatEntryDestination = typeof ChatEntryDestination[keyof typeof ChatEntryDestination];


/**
 * 
 * @export
 * @interface ChatEntryView
 */
export interface ChatEntryView {
    /**
     * 
     * @type {AnswerType}
     * @memberof ChatEntryView
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {MessageType}
     * @memberof ChatEntryView
     */
    'messageType': MessageType;
    /**
     * 
     * @type {ChatStatus}
     * @memberof ChatEntryView
     */
    'status': ChatStatus;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'chatEntryId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'unit': string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'questionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'text': string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatEntryView
     */
    'isSkippable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatEntryView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatEntryView
     */
    'isPhysician': boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ChatEntryView
     */
    'answer'?: string | null;
    /**
     * 
     * @type {ContextView}
     * @memberof ChatEntryView
     */
    'context'?: ContextView | null;
    /**
     * 
     * @type {Array<OptionView>}
     * @memberof ChatEntryView
     */
    'options'?: Array<OptionView>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ChatStatus = {
    Unseen: 'unseen',
    Seen: 'seen',
    Skipped: 'skipped',
    Answered: 'answered'
} as const;

export type ChatStatus = typeof ChatStatus[keyof typeof ChatStatus];


/**
 * 
 * @export
 * @interface CheckoutView
 */
export interface CheckoutView {
    /**
     * 
     * @type {string}
     * @memberof CheckoutView
     */
    'checkoutUrl': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CommunicationKey = {
    ResetPassword: 'resetPassword',
    SetPassword: 'setPassword',
    VerifyEmail: 'verifyEmail',
    Invite: 'invite',
    AcceptedTrialContact: 'acceptedTrialContact',
    VolunteerAcceptedManagedTrial: 'volunteerAcceptedManagedTrial',
    RequestTrialCriteriaDigest: 'requestTrialCriteriaDigest',
    TrialResponseDigest: 'trialResponseDigest',
    RequestBooster: 'requestBooster',
    ExternalContactMatch: 'externalContactMatch',
    FullMatch: 'fullMatch',
    NoMatch: 'noMatch',
    NewQuestions: 'newQuestions',
    NewTrial: 'newTrial',
    NewSurvey: 'newSurvey',
    NewTrialHealthy: 'newTrialHealthy',
    NewTrialUnhealthy: 'newTrialUnhealthy',
    TrialAccessApproved: 'trialAccessApproved',
    TrialAccessRejected: 'trialAccessRejected',
    CriteriaExplanation: 'criteriaExplanation',
    PatientReachOutMissingAnswers: 'patientReachOutMissingAnswers',
    PatientReachOutVerified: 'patientReachOutVerified',
    AccountClaim: 'accountClaim',
    TrialManagerWelcome: 'trialManagerWelcome',
    AccessRequestConfirmation: 'accessRequestConfirmation',
    NewAccessRequest: 'newAccessRequest',
    PendingPatients: 'pendingPatients',
    PendingLocationPatients: 'pendingLocationPatients',
    AutoApproveOverview: 'autoApproveOverview'
} as const;

export type CommunicationKey = typeof CommunicationKey[keyof typeof CommunicationKey];


/**
 * 
 * @export
 * @interface CompletionPercentageView
 */
export interface CompletionPercentageView {
    /**
     * 
     * @type {number}
     * @memberof CompletionPercentageView
     */
    'completionPercentage': number;
}
/**
 * 
 * @export
 * @interface ConfigurationView
 */
export interface ConfigurationView {
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationView
     */
    'isMaintenanceEnabled': boolean;
}
/**
 * 
 * @export
 * @interface ContactUpdateBody
 */
export interface ContactUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactUpdateBody
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface ContactView
 */
export interface ContactView {
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ContextView
 */
export interface ContextView {
    /**
     * 
     * @type {ChatEntryDestination}
     * @memberof ContextView
     */
    'destination': ChatEntryDestination;
    /**
     * 
     * @type {string}
     * @memberof ContextView
     */
    'id'?: string | null;
}


/**
 * 
 * @export
 * @interface CoordinateView
 */
export interface CoordinateView {
    /**
     * 
     * @type {number}
     * @memberof CoordinateView
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof CoordinateView
     */
    'long': number;
}
/**
 * 
 * @export
 * @interface CriteriaActivityView
 */
export interface CriteriaActivityView {
    /**
     * 
     * @type {ActivityType}
     * @memberof CriteriaActivityView
     */
    'type': ActivityType;
    /**
     * 
     * @type {FeedbackType}
     * @memberof CriteriaActivityView
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaActivityView
     */
    'userId'?: string | null;
}


/**
 * 
 * @export
 * @interface CriteriaCommentBody
 */
export interface CriteriaCommentBody {
    /**
     * 
     * @type {string}
     * @memberof CriteriaCommentBody
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface CriteriaDependencyView
 */
export interface CriteriaDependencyView {
    /**
     * 
     * @type {DependencyType}
     * @memberof CriteriaDependencyView
     */
    'type': DependencyType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaDependencyView
     */
    'questionText': string;
    /**
     * 
     * @type {DependencyValue}
     * @memberof CriteriaDependencyView
     */
    'value'?: DependencyValue;
}


/**
 * 
 * @export
 * @interface CriteriaFeedbackBody
 */
export interface CriteriaFeedbackBody {
    /**
     * 
     * @type {FeedbackType}
     * @memberof CriteriaFeedbackBody
     */
    'feedbackType': FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaFeedbackBody
     */
    'feedback': string;
}


/**
 * 
 * @export
 * @interface CriteriaMoveBody
 */
export interface CriteriaMoveBody {
    /**
     * 
     * @type {number}
     * @memberof CriteriaMoveBody
     */
    'newPosition': number;
}
/**
 * 
 * @export
 * @interface CriteriaRequestBody
 */
export interface CriteriaRequestBody {
    /**
     * 
     * @type {AnswerType}
     * @memberof CriteriaRequestBody
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof CriteriaRequestBody
     */
    'criteriaText': string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaRequestBody
     */
    'questionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaRequestBody
     */
    'value'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CriteriaRequestBody
     */
    'minThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CriteriaRequestBody
     */
    'maxThreshold'?: number;
    /**
     * 
     * @type {string}
     * @memberof CriteriaRequestBody
     */
    'unit'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CriteriaStatus = {
    Proposed: 'proposed',
    Validated: 'validated',
    Static: 'static',
    Denied: 'denied',
    Deleted: 'deleted'
} as const;

export type CriteriaStatus = typeof CriteriaStatus[keyof typeof CriteriaStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CriteriaType = {
    Inclusion: 'inclusion',
    Exclusion: 'exclusion'
} as const;

export type CriteriaType = typeof CriteriaType[keyof typeof CriteriaType];


/**
 * 
 * @export
 * @interface CriteriaUpdateBody
 */
export interface CriteriaUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof CriteriaUpdateBody
     */
    'originalCriteriaText'?: string;
    /**
     * 
     * @type {string}
     * @memberof CriteriaUpdateBody
     */
    'status'?: CriteriaUpdateBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CriteriaUpdateBody
     */
    'questionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaUpdateBody
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof CriteriaUpdateBody
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CriteriaUpdateBody
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CriteriaUpdateBody
     */
    'otherValues'?: Array<string>;
}

export const CriteriaUpdateBodyStatusEnum = {
    Proposed: 'proposed',
    Validated: 'validated',
    Static: 'static',
    Denied: 'denied',
    Deleted: 'deleted'
} as const;

export type CriteriaUpdateBodyStatusEnum = typeof CriteriaUpdateBodyStatusEnum[keyof typeof CriteriaUpdateBodyStatusEnum];

/**
 * 
 * @export
 * @interface CurrentFlowDetails
 */
export interface CurrentFlowDetails {
    /**
     * 
     * @type {ResearchType}
     * @memberof CurrentFlowDetails
     */
    'researchType': ResearchType;
    /**
     * 
     * @type {string}
     * @memberof CurrentFlowDetails
     */
    'id': string;
}


/**
 * 
 * @export
 * @interface CurrentFlowView
 */
export interface CurrentFlowView {
    /**
     * 
     * @type {CurrentFlowDetails}
     * @memberof CurrentFlowView
     */
    'flow'?: CurrentFlowDetails;
}
/**
 * 
 * @export
 * @interface CustomerPortalView
 */
export interface CustomerPortalView {
    /**
     * 
     * @type {string}
     * @memberof CustomerPortalView
     */
    'customerPortalUrl': string;
}
/**
 * 
 * @export
 * @interface DelayIndexView
 */
export interface DelayIndexView {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalDelayInDays': number;
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalTrials': number;
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalDelayedTrials': number;
    /**
     * 
     * @type {number}
     * @memberof DelayIndexView
     */
    'totalDelayedTrialsPercentage': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DependencyType = {
    GreaterThan: 'greaterThan',
    DateToMonths: 'dateToMonths',
    DateToYears: 'dateToYears',
    Address: 'address',
    BmiCalculation: 'bmiCalculation',
    DiseaseProcessor: 'diseaseProcessor',
    HospitalProcessor: 'hospitalProcessor',
    EqualTo: 'equalTo',
    Dependency: 'dependency'
} as const;

export type DependencyType = typeof DependencyType[keyof typeof DependencyType];


/**
 * 
 * @export
 * @interface DependencyUpdateBody
 */
export interface DependencyUpdateBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof DependencyUpdateBody
     */
    'parameters': Array<string>;
}
/**
 * 
 * @export
 * @interface DependencyValue
 */
export interface DependencyValue {
    /**
     * 
     * @type {number}
     * @memberof DependencyValue
     */
    'greaterThan'?: number;
    /**
     * 
     * @type {string}
     * @memberof DependencyValue
     */
    'equalTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof DependencyValue
     */
    'requiredValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof DependencyValue
     */
    'notApplicableValue'?: string;
}
/**
 * 
 * @export
 * @interface DigestBody
 */
export interface DigestBody {
    /**
     * 
     * @type {number}
     * @memberof DigestBody
     */
    'frequencySeconds': number;
}
/**
 * 
 * @export
 * @interface DigestView
 */
export interface DigestView {
    /**
     * 
     * @type {number}
     * @memberof DigestView
     */
    'frequencySeconds': number;
}
/**
 * 
 * @export
 * @interface DiseaseCreateBody
 */
export interface DiseaseCreateBody {
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateBody
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @interface DiseaseCreateView
 */
export interface DiseaseCreateView {
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseCreateView
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @interface DiseaseNameCreate
 */
export interface DiseaseNameCreate {
    /**
     * 
     * @type {Language}
     * @memberof DiseaseNameCreate
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameCreate
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface DiseaseNameUpdateQuery
 */
export interface DiseaseNameUpdateQuery {
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameUpdateQuery
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface DiseaseNameView
 */
export interface DiseaseNameView {
    /**
     * 
     * @type {Language}
     * @memberof DiseaseNameView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseNameView
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface DiseaseTranslationView
 */
export interface DiseaseTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof DiseaseTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof DiseaseTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DiseaseTranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof DiseaseTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseTranslationView
     */
    'diseaseId': string;
}


/**
 * 
 * @export
 * @interface DiseaseTranslationsBody
 */
export interface DiseaseTranslationsBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof DiseaseTranslationsBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface DiseaseTrialsCountView
 */
export interface DiseaseTrialsCountView {
    /**
     * 
     * @type {number}
     * @memberof DiseaseTrialsCountView
     */
    'trialCount': number;
}
/**
 * 
 * @export
 * @interface DiseaseView
 */
export interface DiseaseView {
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'icdId': string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'icdCode': string;
    /**
     * 
     * @type {number}
     * @memberof DiseaseView
     */
    'trialCount': number;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'parentCategoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'parentCategoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'categoryId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiseaseView
     */
    'categoryName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EffectType = {
    AutoApprove: 'autoApprove',
    Redirect: 'redirect',
    ExternalContact: 'externalContact'
} as const;

export type EffectType = typeof EffectType[keyof typeof EffectType];


/**
 * 
 * @export
 * @interface EffectView
 */
export interface EffectView {
    /**
     * 
     * @type {EffectType}
     * @memberof EffectView
     */
    'type': EffectType;
    /**
     * 
     * @type {string}
     * @memberof EffectView
     */
    'url'?: string;
    /**
     * 
     * @type {ContactView}
     * @memberof EffectView
     */
    'contact'?: ContactView;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FeedbackType = {
    WrongCriterion: 'wrongCriterion',
    WrongQuestion: 'wrongQuestion',
    WrongExpectedValue: 'wrongExpectedValue',
    WrongMinThreshold: 'wrongMinThreshold',
    WrongMaxThreshold: 'wrongMaxThreshold',
    WrongUnit: 'wrongUnit',
    Other: 'other'
} as const;

export type FeedbackType = typeof FeedbackType[keyof typeof FeedbackType];


/**
 * 
 * @export
 * @enum {string}
 */

export const Gender = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];


/**
 * 
 * @export
 * @enum {string}
 */

export const GenerationType = {
    Standard: 'standard',
    Researcher: 'researcher',
    AiGenerated: 'aiGenerated',
    Aggregated: 'aggregated'
} as const;

export type GenerationType = typeof GenerationType[keyof typeof GenerationType];


/**
 * 
 * @export
 * @interface GetQuestionsBody
 */
export interface GetQuestionsBody {
    /**
     * 
     * @type {number}
     * @memberof GetQuestionsBody
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetQuestionsBody
     */
    'offset'?: number | null;
    /**
     * 
     * @type {Array<QuestionType>}
     * @memberof GetQuestionsBody
     */
    'questionTypes'?: Array<QuestionType>;
    /**
     * 
     * @type {Array<GenerationType>}
     * @memberof GetQuestionsBody
     */
    'generationTypes'?: Array<GenerationType>;
    /**
     * 
     * @type {Array<VisibilityType>}
     * @memberof GetQuestionsBody
     */
    'visibilityTypes'?: Array<VisibilityType>;
    /**
     * 
     * @type {OrderDirection}
     * @memberof GetQuestionsBody
     */
    'orderDirection'?: OrderDirection;
    /**
     * 
     * @type {QuestionOrderBy}
     * @memberof GetQuestionsBody
     */
    'orderBy'?: QuestionOrderBy;
    /**
     * 
     * @type {Array<AnswerType>}
     * @memberof GetQuestionsBody
     */
    'answerTypes'?: Array<AnswerType>;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionsBody
     */
    'icdCategoryIds'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetQuestionsBody
     */
    'searchString'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionsBody
     */
    'orderByIcdSpecificCount'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQuestionsBody
     */
    'starterCategoryIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQuestionsBody
     */
    'tagCategoryIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GetQuestionsBody
     */
    'currentVersionOnly': boolean | null;
}


/**
 * 
 * @export
 * @interface GetTrialsBody
 */
export interface GetTrialsBody {
    /**
     * 
     * @type {number}
     * @memberof GetTrialsBody
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetTrialsBody
     */
    'offset'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrialsBody
     */
    'searchString'?: string | null;
    /**
     * 
     * @type {OrderDirection}
     * @memberof GetTrialsBody
     */
    'orderDirection'?: OrderDirection;
    /**
     * 
     * @type {TrialOrderBy}
     * @memberof GetTrialsBody
     */
    'orderBy'?: TrialOrderBy;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof GetTrialsBody
     */
    'managedByFilter'?: ManagementStatus;
    /**
     * 
     * @type {string}
     * @memberof GetTrialsBody
     */
    'icdCategoryIds'?: string;
    /**
     * 
     * @type {Array<OverallTrialStatus>}
     * @memberof GetTrialsBody
     */
    'overallStatuses'?: Array<OverallTrialStatus>;
    /**
     * 
     * @type {Array<MatchingTrialStatus>}
     * @memberof GetTrialsBody
     */
    'matchingStatuses'?: Array<MatchingTrialStatus>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrialsBody
     */
    'locationString'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrialsBody
     */
    'countriesFilter'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetTrialsBody
     */
    'diseaseFilter'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrialsBody
     */
    'leadSponsorFilter'?: Array<string>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const GetUserTrialsOrderBy = {
    Distance: 'distance',
    RemainingQuestions: 'remainingQuestions'
} as const;

export type GetUserTrialsOrderBy = typeof GetUserTrialsOrderBy[keyof typeof GetUserTrialsOrderBy];


/**
 * 
 * @export
 * @interface GoogleLoginBody
 */
export interface GoogleLoginBody {
    /**
     * 
     * @type {Language}
     * @memberof GoogleLoginBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof GoogleLoginBody
     */
    'idToken': string;
}


/**
 * 
 * @export
 * @interface GoogleSignUpBody
 */
export interface GoogleSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof GoogleSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {ThemeType}
     * @memberof GoogleSignUpBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {Role}
     * @memberof GoogleSignUpBody
     */
    'role'?: Role;
    /**
     * 
     * @type {string}
     * @memberof GoogleSignUpBody
     */
    'idToken': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const HistoryType = {
    Seen: 'seen',
    Unseen: 'unseen',
    All: 'all',
    Answered: 'answered',
    Unanswered: 'unanswered'
} as const;

export type HistoryType = typeof HistoryType[keyof typeof HistoryType];


/**
 * 
 * @export
 * @interface HospitalCenterCreate
 */
export interface HospitalCenterCreate {
    /**
     * 
     * @type {Language}
     * @memberof HospitalCenterCreate
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterCreate
     */
    'zip': string;
}


/**
 * 
 * @export
 * @interface HospitalCenterUpdateQuery
 */
export interface HospitalCenterUpdateQuery {
    /**
     * 
     * @type {boolean}
     * @memberof HospitalCenterUpdateQuery
     */
    'isStandard': boolean;
}
/**
 * 
 * @export
 * @interface HospitalCenterView
 */
export interface HospitalCenterView {
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalCenterView
     */
    'country': string;
    /**
     * 
     * @type {boolean}
     * @memberof HospitalCenterView
     */
    'isStandard': boolean;
}
/**
 * 
 * @export
 * @interface HospitalMergeBody
 */
export interface HospitalMergeBody {
    /**
     * 
     * @type {string}
     * @memberof HospitalMergeBody
     */
    'targetHospitalId': string;
}
/**
 * 
 * @export
 * @interface HospitalNameCreate
 */
export interface HospitalNameCreate {
    /**
     * 
     * @type {Language}
     * @memberof HospitalNameCreate
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof HospitalNameCreate
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface HospitalNameUpdateQuery
 */
export interface HospitalNameUpdateQuery {
    /**
     * 
     * @type {string}
     * @memberof HospitalNameUpdateQuery
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface HospitalNameView
 */
export interface HospitalNameView {
    /**
     * 
     * @type {Language}
     * @memberof HospitalNameView
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof HospitalNameView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalNameView
     */
    'name': string;
}


/**
 * 
 * @export
 * @interface HospitalTranslationView
 */
export interface HospitalTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof HospitalTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof HospitalTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof HospitalTranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof HospitalTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalTranslationView
     */
    'hospitalId': string;
}


/**
 * 
 * @export
 * @interface HospitalTranslationsBody
 */
export interface HospitalTranslationsBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof HospitalTranslationsBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface HospitalView
 */
export interface HospitalView {
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'hospitalEntityId': string;
    /**
     * 
     * @type {string}
     * @memberof HospitalView
     */
    'hospitalEntityName': string;
}
/**
 * 
 * @export
 * @interface IcdDiseaseView
 */
export interface IcdDiseaseView {
    /**
     * 
     * @type {string}
     * @memberof IcdDiseaseView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof IcdDiseaseView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof IcdDiseaseView
     */
    'icdCode': string;
}
/**
 * 
 * @export
 * @interface InviteBody
 */
export interface InviteBody {
    /**
     * 
     * @type {ThemeType}
     * @memberof InviteBody
     */
    'theme': ThemeType;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof InviteBody
     */
    'role': InviteBodyRoleEnum;
}

export const InviteBodyRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type InviteBodyRoleEnum = typeof InviteBodyRoleEnum[keyof typeof InviteBodyRoleEnum];

/**
 * 
 * @export
 * @interface InviteListView
 */
export interface InviteListView {
    /**
     * 
     * @type {Array<InviteView>}
     * @memberof InviteListView
     */
    'items': Array<InviteView>;
    /**
     * 
     * @type {string}
     * @memberof InviteListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface InviteTrialData
 */
export interface InviteTrialData {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof InviteTrialData
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof InviteTrialData
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof InviteTrialData
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof InviteTrialData
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface InviteView
 */
export interface InviteView {
    /**
     * 
     * @type {Language}
     * @memberof InviteView
     */
    'language': Language;
    /**
     * 
     * @type {TokenType}
     * @memberof InviteView
     */
    'tokenType': TokenType;
    /**
     * 
     * @type {Role}
     * @memberof InviteView
     */
    'role': Role;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof InviteView
     */
    'permissions': Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof InviteView
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'teamRole': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'inviteUrl': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'companyRole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InviteView
     */
    'country'?: string | null;
}


/**
 * 
 * @export
 * @interface LabeledDelayItem
 */
export interface LabeledDelayItem {
    /**
     * 
     * @type {string}
     * @memberof LabeledDelayItem
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof LabeledDelayItem
     */
    'totalDelayTime': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Language = {
    En: 'en',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs'
} as const;

export type Language = typeof Language[keyof typeof Language];


/**
 * 
 * @export
 * @interface LeadResponsible
 */
export interface LeadResponsible {
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsible
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface LeadResponsibleView
 */
export interface LeadResponsibleView {
    /**
     * 
     * @type {string}
     * @memberof LeadResponsibleView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsibleView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LeadResponsibleView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface LeadSponsorView
 */
export interface LeadSponsorView {
    /**
     * 
     * @type {string}
     * @memberof LeadSponsorView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface ListAdminOverviewView
 */
export interface ListAdminOverviewView {
    /**
     * 
     * @type {Array<AdminOverviewView>}
     * @memberof ListAdminOverviewView
     */
    'items': Array<AdminOverviewView>;
    /**
     * 
     * @type {number}
     * @memberof ListAdminOverviewView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListAttributeView
 */
export interface ListAttributeView {
    /**
     * 
     * @type {Array<AttributeView>}
     * @memberof ListAttributeView
     */
    'items': Array<AttributeView>;
    /**
     * 
     * @type {number}
     * @memberof ListAttributeView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategoryContextTranslationView
 */
export interface ListCategoryContextTranslationView {
    /**
     * 
     * @type {Array<CategoryContextTranslationView>}
     * @memberof ListCategoryContextTranslationView
     */
    'items': Array<CategoryContextTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategoryContextTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategoryDiseaseView
 */
export interface ListCategoryDiseaseView {
    /**
     * 
     * @type {Array<CategoryDiseaseView>}
     * @memberof ListCategoryDiseaseView
     */
    'items': Array<CategoryDiseaseView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategoryDiseaseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategoryQuestionView
 */
export interface ListCategoryQuestionView {
    /**
     * 
     * @type {Array<CategoryQuestionView>}
     * @memberof ListCategoryQuestionView
     */
    'items': Array<CategoryQuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategoryQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCategorySearchView
 */
export interface ListCategorySearchView {
    /**
     * 
     * @type {Array<CategorySearchView>}
     * @memberof ListCategorySearchView
     */
    'items': Array<CategorySearchView>;
    /**
     * 
     * @type {number}
     * @memberof ListCategorySearchView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListChatEntryView
 */
export interface ListChatEntryView {
    /**
     * 
     * @type {Array<ChatEntryView>}
     * @memberof ListChatEntryView
     */
    'items': Array<ChatEntryView>;
    /**
     * 
     * @type {number}
     * @memberof ListChatEntryView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListContactView
 */
export interface ListContactView {
    /**
     * 
     * @type {Array<ContactView>}
     * @memberof ListContactView
     */
    'items': Array<ContactView>;
    /**
     * 
     * @type {number}
     * @memberof ListContactView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListCriteriaActivityView
 */
export interface ListCriteriaActivityView {
    /**
     * 
     * @type {Array<CriteriaActivityView>}
     * @memberof ListCriteriaActivityView
     */
    'items': Array<CriteriaActivityView>;
    /**
     * 
     * @type {number}
     * @memberof ListCriteriaActivityView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseNameView
 */
export interface ListDiseaseNameView {
    /**
     * 
     * @type {Array<DiseaseNameView>}
     * @memberof ListDiseaseNameView
     */
    'items': Array<DiseaseNameView>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseNameView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseTranslationView
 */
export interface ListDiseaseTranslationView {
    /**
     * 
     * @type {Array<DiseaseTranslationView>}
     * @memberof ListDiseaseTranslationView
     */
    'items': Array<DiseaseTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListDiseaseView
 */
export interface ListDiseaseView {
    /**
     * 
     * @type {Array<DiseaseView>}
     * @memberof ListDiseaseView
     */
    'items': Array<DiseaseView>;
    /**
     * 
     * @type {number}
     * @memberof ListDiseaseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalCenterView
 */
export interface ListHospitalCenterView {
    /**
     * 
     * @type {Array<HospitalCenterView>}
     * @memberof ListHospitalCenterView
     */
    'items': Array<HospitalCenterView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalCenterView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalNameView
 */
export interface ListHospitalNameView {
    /**
     * 
     * @type {Array<HospitalNameView>}
     * @memberof ListHospitalNameView
     */
    'items': Array<HospitalNameView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalNameView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalTranslationView
 */
export interface ListHospitalTranslationView {
    /**
     * 
     * @type {Array<HospitalTranslationView>}
     * @memberof ListHospitalTranslationView
     */
    'items': Array<HospitalTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListHospitalView
 */
export interface ListHospitalView {
    /**
     * 
     * @type {Array<HospitalView>}
     * @memberof ListHospitalView
     */
    'items': Array<HospitalView>;
    /**
     * 
     * @type {number}
     * @memberof ListHospitalView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListIcdDiseaseView
 */
export interface ListIcdDiseaseView {
    /**
     * 
     * @type {Array<IcdDiseaseView>}
     * @memberof ListIcdDiseaseView
     */
    'items': Array<IcdDiseaseView>;
    /**
     * 
     * @type {number}
     * @memberof ListIcdDiseaseView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListLabeledDelayItem
 */
export interface ListLabeledDelayItem {
    /**
     * 
     * @type {Array<LabeledDelayItem>}
     * @memberof ListLabeledDelayItem
     */
    'items': Array<LabeledDelayItem>;
    /**
     * 
     * @type {number}
     * @memberof ListLabeledDelayItem
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListLeadSponsorView
 */
export interface ListLeadSponsorView {
    /**
     * 
     * @type {Array<LeadSponsorView>}
     * @memberof ListLeadSponsorView
     */
    'items': Array<LeadSponsorView>;
    /**
     * 
     * @type {number}
     * @memberof ListLeadSponsorView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListLocationView
 */
export interface ListLocationView {
    /**
     * 
     * @type {Array<LocationView>}
     * @memberof ListLocationView
     */
    'items': Array<LocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListPublicLocationView
 */
export interface ListPublicLocationView {
    /**
     * 
     * @type {Array<PublicLocationView>}
     * @memberof ListPublicLocationView
     */
    'items': Array<PublicLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListPublicLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionCategoryView
 */
export interface ListQuestionCategoryView {
    /**
     * 
     * @type {Array<QuestionCategoryView>}
     * @memberof ListQuestionCategoryView
     */
    'items': Array<QuestionCategoryView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionCategoryView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionOptionView
 */
export interface ListQuestionOptionView {
    /**
     * 
     * @type {Array<QuestionOptionView>}
     * @memberof ListQuestionOptionView
     */
    'items': Array<QuestionOptionView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionOptionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionTranslationView
 */
export interface ListQuestionTranslationView {
    /**
     * 
     * @type {Array<QuestionTranslationView>}
     * @memberof ListQuestionTranslationView
     */
    'items': Array<QuestionTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListQuestionView
 */
export interface ListQuestionView {
    /**
     * 
     * @type {Array<QuestionView>}
     * @memberof ListQuestionView
     */
    'items': Array<QuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyQuestionView
 */
export interface ListSurveyQuestionView {
    /**
     * 
     * @type {Array<SurveyQuestionView>}
     * @memberof ListSurveyQuestionView
     */
    'items': Array<SurveyQuestionView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyQuestionView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyTranslationView
 */
export interface ListSurveyTranslationView {
    /**
     * 
     * @type {Array<SurveyTranslationView>}
     * @memberof ListSurveyTranslationView
     */
    'items': Array<SurveyTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListSurveyView
 */
export interface ListSurveyView {
    /**
     * 
     * @type {Array<SurveyView>}
     * @memberof ListSurveyView
     */
    'items': Array<SurveyView>;
    /**
     * 
     * @type {number}
     * @memberof ListSurveyView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTeamTrialView
 */
export interface ListTeamTrialView {
    /**
     * 
     * @type {Array<TeamTrialView>}
     * @memberof ListTeamTrialView
     */
    'items': Array<TeamTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListTeamTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialActivityView
 */
export interface ListTrialActivityView {
    /**
     * 
     * @type {Array<TrialActivityView>}
     * @memberof ListTrialActivityView
     */
    'items': Array<TrialActivityView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialActivityView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialContactView
 */
export interface ListTrialContactView {
    /**
     * 
     * @type {Array<TrialContactView>}
     * @memberof ListTrialContactView
     */
    'items': Array<TrialContactView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialContactView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialCriteriaView
 */
export interface ListTrialCriteriaView {
    /**
     * 
     * @type {Array<TrialCriteriaView>}
     * @memberof ListTrialCriteriaView
     */
    'items': Array<TrialCriteriaView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialCriteriaView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialLocationView
 */
export interface ListTrialLocationView {
    /**
     * 
     * @type {Array<TrialLocationView>}
     * @memberof ListTrialLocationView
     */
    'items': Array<TrialLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialMatchView
 */
export interface ListTrialMatchView {
    /**
     * 
     * @type {Array<TrialMatchView>}
     * @memberof ListTrialMatchView
     */
    'items': Array<TrialMatchView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialMatchView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialPublicView
 */
export interface ListTrialPublicView {
    /**
     * 
     * @type {Array<TrialPublicView>}
     * @memberof ListTrialPublicView
     */
    'items': Array<TrialPublicView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialPublicView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialTranslationView
 */
export interface ListTrialTranslationView {
    /**
     * 
     * @type {Array<TrialTranslationView>}
     * @memberof ListTrialTranslationView
     */
    'items': Array<TrialTranslationView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialTranslationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialView
 */
export interface ListTrialView {
    /**
     * 
     * @type {Array<TrialView>}
     * @memberof ListTrialView
     */
    'items': Array<TrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialVolunteerActivityUsersView
 */
export interface ListTrialVolunteerActivityUsersView {
    /**
     * 
     * @type {Array<TrialVolunteerActivityUsersView>}
     * @memberof ListTrialVolunteerActivityUsersView
     */
    'items': Array<TrialVolunteerActivityUsersView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialVolunteerActivityUsersView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListTrialVolunteerActivityView
 */
export interface ListTrialVolunteerActivityView {
    /**
     * 
     * @type {Array<TrialVolunteerActivityView>}
     * @memberof ListTrialVolunteerActivityView
     */
    'items': Array<TrialVolunteerActivityView>;
    /**
     * 
     * @type {number}
     * @memberof ListTrialVolunteerActivityView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUniqueLocationView
 */
export interface ListUniqueLocationView {
    /**
     * 
     * @type {Array<UniqueLocationView>}
     * @memberof ListUniqueLocationView
     */
    'items': Array<UniqueLocationView>;
    /**
     * 
     * @type {number}
     * @memberof ListUniqueLocationView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUserSurveyView
 */
export interface ListUserSurveyView {
    /**
     * 
     * @type {Array<UserSurveyView>}
     * @memberof ListUserSurveyView
     */
    'items': Array<UserSurveyView>;
    /**
     * 
     * @type {number}
     * @memberof ListUserSurveyView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ListUserTrialView
 */
export interface ListUserTrialView {
    /**
     * 
     * @type {Array<UserTrialView>}
     * @memberof ListUserTrialView
     */
    'items': Array<UserTrialView>;
    /**
     * 
     * @type {number}
     * @memberof ListUserTrialView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface LocationContactUpdateBody
 */
export interface LocationContactUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof LocationContactUpdateBody
     */
    'contactId': string;
}
/**
 * 
 * @export
 * @interface LocationDetailView
 */
export interface LocationDetailView {
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationDetailView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface LocationEffectBody
 */
export interface LocationEffectBody {
    /**
     * 
     * @type {EffectType}
     * @memberof LocationEffectBody
     */
    'type': EffectType;
    /**
     * 
     * @type {boolean}
     * @memberof LocationEffectBody
     */
    'withDirectMessage': boolean;
    /**
     * 
     * @type {string}
     * @memberof LocationEffectBody
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationEffectBody
     */
    'contactId'?: string;
}


/**
 * 
 * @export
 * @interface LocationSimpleView
 */
export interface LocationSimpleView {
    /**
     * 
     * @type {string}
     * @memberof LocationSimpleView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationSimpleView
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface LocationUpdateBody
 */
export interface LocationUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationUpdateBody
     */
    'facility'?: string;
}
/**
 * 
 * @export
 * @interface LocationView
 */
export interface LocationView {
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LocationView
     */
    'locationStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LocationView
     */
    'isActive': boolean;
    /**
     * 
     * @type {EffectView}
     * @memberof LocationView
     */
    'effect'?: EffectView;
}
/**
 * 
 * @export
 * @interface LoginBody
 */
export interface LoginBody {
    /**
     * 
     * @type {Language}
     * @memberof LoginBody
     */
    'language': Language;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof LoginBody
     */
    'password': string;
}


/**
 * 
 * @export
 * @interface LoginView
 */
export interface LoginView {
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof LoginView
     */
    'teamPermissions'?: Array<TeamPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'jotSubmissionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'teamId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginView
     */
    'intercomHash'?: string | null;
    /**
     * 
     * @type {Array<ReducedTeamView>}
     * @memberof LoginView
     */
    'teams'?: Array<ReducedTeamView> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ManagementStatus = {
    None: 'none',
    Researcher: 'researcher',
    Curewiki: 'curewiki',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type ManagementStatus = typeof ManagementStatus[keyof typeof ManagementStatus];


/**
 * 
 * @export
 * @interface MandateLocationView
 */
export interface MandateLocationView {
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MandateLocationView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MandatePermissionEnum = {
    TrialRead: 'trial:read',
    TrialWrite: 'trial:write',
    TeamWrite: 'team:write'
} as const;

export type MandatePermissionEnum = typeof MandatePermissionEnum[keyof typeof MandatePermissionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const MandateStatus = {
    Default: 'default',
    Paid: 'paid'
} as const;

export type MandateStatus = typeof MandateStatus[keyof typeof MandateStatus];


/**
 * 
 * @export
 * @interface MandateView
 */
export interface MandateView {
    /**
     * 
     * @type {MandateStatus}
     * @memberof MandateView
     */
    'status': MandateStatus;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'trialTitle': string;
    /**
     * 
     * @type {MandateLocationView}
     * @memberof MandateView
     */
    'location': MandateLocationView;
    /**
     * 
     * @type {string}
     * @memberof MandateView
     */
    'nextUnassignDate'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const MatchingTrialStatus = {
    Processing: 'processing',
    Proposed: 'proposed',
    Active: 'active',
    Completed: 'completed',
    Deleted: 'deleted'
} as const;

export type MatchingTrialStatus = typeof MatchingTrialStatus[keyof typeof MatchingTrialStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const MessageType = {
    Question: 'question',
    Notification: 'notification',
    Link: 'link',
    Action: 'action',
    RequestEmail: 'requestEmail'
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];


/**
 * 
 * @export
 * @interface MetadataView
 */
export interface MetadataView {
    /**
     * 
     * @type {string}
     * @memberof MetadataView
     */
    'metadata': string;
    /**
     * 
     * @type {string}
     * @memberof MetadataView
     */
    'userId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const MySurveyCommandType = {
    Start: 'start',
    Stop: 'stop'
} as const;

export type MySurveyCommandType = typeof MySurveyCommandType[keyof typeof MySurveyCommandType];


/**
 * 
 * @export
 * @enum {string}
 */

export const MyTrialCommandType = {
    Start: 'start',
    Stop: 'stop'
} as const;

export type MyTrialCommandType = typeof MyTrialCommandType[keyof typeof MyTrialCommandType];


/**
 * 
 * @export
 * @interface NestedCategoryView
 */
export interface NestedCategoryView {
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'shortName': string;
    /**
     * 
     * @type {Array<NestedCategoryView>}
     * @memberof NestedCategoryView
     */
    'subCategories': Array<NestedCategoryView>;
    /**
     * 
     * @type {string}
     * @memberof NestedCategoryView
     */
    'type': NestedCategoryViewTypeEnum;
}

export const NestedCategoryViewTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;

export type NestedCategoryViewTypeEnum = typeof NestedCategoryViewTypeEnum[keyof typeof NestedCategoryViewTypeEnum];

/**
 * 
 * @export
 * @interface NotificationCountView
 */
export interface NotificationCountView {
    /**
     * 
     * @type {number}
     * @memberof NotificationCountView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface NotificationListView
 */
export interface NotificationListView {
    /**
     * 
     * @type {Array<NotificationView>}
     * @memberof NotificationListView
     */
    'items': Array<NotificationView>;
    /**
     * 
     * @type {string}
     * @memberof NotificationListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface NotificationReadBody
 */
export interface NotificationReadBody {
    /**
     * 
     * @type {string}
     * @memberof NotificationReadBody
     */
    'start': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationReadBody
     */
    'end': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationStatus = {
    Read: 'read',
    Unread: 'unread'
} as const;

export type NotificationStatus = typeof NotificationStatus[keyof typeof NotificationStatus];


/**
 * 
 * @export
 * @interface NotificationView
 */
export interface NotificationView {
    /**
     * 
     * @type {NotificationStatus}
     * @memberof NotificationView
     */
    'status': NotificationStatus;
    /**
     * 
     * @type {string}
     * @memberof NotificationView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationView
     */
    'text': string;
    /**
     * 
     * @type {ContextView}
     * @memberof NotificationView
     */
    'context': ContextView;
    /**
     * 
     * @type {string}
     * @memberof NotificationView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface OptionView
 */
export interface OptionView {
    /**
     * 
     * @type {Language}
     * @memberof OptionView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof OptionView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OptionView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof OptionView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof OptionView
     */
    'key': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const OverallTrialStatus = {
    ActiveNotRecruiting: 'ACTIVE_NOT_RECRUITING',
    Completed: 'COMPLETED',
    EnrollingByInvitation: 'ENROLLING_BY_INVITATION',
    NotYetRecruiting: 'NOT_YET_RECRUITING',
    Recruiting: 'RECRUITING',
    Suspended: 'SUSPENDED',
    Terminated: 'TERMINATED',
    Withdrawn: 'WITHDRAWN',
    Available: 'AVAILABLE',
    NoLongerAvailable: 'NO_LONGER_AVAILABLE',
    TemporarilyNotAvailable: 'TEMPORARILY_NOT_AVAILABLE',
    ApprovedForMarketing: 'APPROVED_FOR_MARKETING',
    Withheld: 'WITHHELD',
    Unknown: 'UNKNOWN'
} as const;

export type OverallTrialStatus = typeof OverallTrialStatus[keyof typeof OverallTrialStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const PatientRejectionReason = {
    NotFittingCriteria: 'notFittingCriteria',
    Other: 'other'
} as const;

export type PatientRejectionReason = typeof PatientRejectionReason[keyof typeof PatientRejectionReason];


/**
 * 
 * @export
 * @interface PatientSignUpBody
 */
export interface PatientSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof PatientSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {Gender}
     * @memberof PatientSignUpBody
     */
    'gender'?: Gender;
    /**
     * 
     * @type {ThemeType}
     * @memberof PatientSignUpBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {BehalfOf}
     * @memberof PatientSignUpBody
     */
    'behalfOf'?: BehalfOf;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'password': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PatientSignUpBody
     */
    'diseases': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'hospital'?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientSignUpBody
     */
    'source'?: string;
}


/**
 * 
 * @export
 * @interface PreferenceView
 */
export interface PreferenceView {
    /**
     * 
     * @type {boolean}
     * @memberof PreferenceView
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PreferenceView
     */
    'notification': boolean;
    /**
     * 
     * @type {DigestView}
     * @memberof PreferenceView
     */
    'digest'?: DigestView;
}
/**
 * 
 * @export
 * @interface PublicLocationView
 */
export interface PublicLocationView {
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicLocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PublicLocationView
     */
    'isAvailable': boolean;
}
/**
 * 
 * @export
 * @interface QuestionBody
 */
export interface QuestionBody {
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionBody
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionBody
     */
    'questionType'?: QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionBody
     */
    'visibilityType'?: VisibilityType;
    /**
     * 
     * @type {string}
     * @memberof QuestionBody
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionBody
     */
    'unit'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionBody
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestionBody
     */
    'expiry'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionBody
     */
    'autoGenerateTranslations': boolean;
}


/**
 * 
 * @export
 * @interface QuestionBulkDelete
 */
export interface QuestionBulkDelete {
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionBulkDelete
     */
    'questionIds': Array<string>;
}
/**
 * 
 * @export
 * @interface QuestionCategoryOverview
 */
export interface QuestionCategoryOverview {
    /**
     * 
     * @type {CategoryType}
     * @memberof QuestionCategoryOverview
     */
    'type': CategoryType;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryOverview
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryOverview
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryOverview
     */
    'shortName': string;
}


/**
 * 
 * @export
 * @interface QuestionCategoryView
 */
export interface QuestionCategoryView {
    /**
     * 
     * @type {CategoryType}
     * @memberof QuestionCategoryView
     */
    'type': CategoryType;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'categoryId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'shortName': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'questionId': string;
    /**
     * 
     * @type {number}
     * @memberof QuestionCategoryView
     */
    'priority': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionCategoryView
     */
    'icdCodes'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof QuestionCategoryView
     */
    'icdTrialCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionCategoryView
     */
    'context'?: string;
}


/**
 * 
 * @export
 * @interface QuestionConfigurationItem
 */
export interface QuestionConfigurationItem {
    /**
     * 
     * @type {string}
     * @memberof QuestionConfigurationItem
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionConfigurationItem
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface QuestionConfigurationView
 */
export interface QuestionConfigurationView {
    /**
     * 
     * @type {Array<QuestionConfigurationItem>}
     * @memberof QuestionConfigurationView
     */
    'questions': Array<QuestionConfigurationItem>;
}
/**
 * 
 * @export
 * @interface QuestionCountListView
 */
export interface QuestionCountListView {
    /**
     * 
     * @type {Array<QuestionView>}
     * @memberof QuestionCountListView
     */
    'items': Array<QuestionView>;
    /**
     * 
     * @type {number}
     * @memberof QuestionCountListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface QuestionCriteriaListView
 */
export interface QuestionCriteriaListView {
    /**
     * 
     * @type {Array<QuestionCriterionView>}
     * @memberof QuestionCriteriaListView
     */
    'items': Array<QuestionCriterionView>;
    /**
     * 
     * @type {number}
     * @memberof QuestionCriteriaListView
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriteriaListView
     */
    'standardCriterionText'?: string | null;
}
/**
 * 
 * @export
 * @interface QuestionCriterionView
 */
export interface QuestionCriterionView {
    /**
     * 
     * @type {CriteriaStatus}
     * @memberof QuestionCriterionView
     */
    'status': CriteriaStatus;
    /**
     * 
     * @type {CriteriaType}
     * @memberof QuestionCriterionView
     */
    'type': CriteriaType;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof QuestionCriterionView
     */
    'matchingTrialStatus': MatchingTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'criteriaId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'trialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'criterionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionCriterionView
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionCriterionView
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionCriterionView
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionCriterionView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionCriterionView
     */
    'icdCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QuestionCriterionView
     */
    'leadSponsor': string;
}


/**
 * 
 * @export
 * @interface QuestionDependencyBody
 */
export interface QuestionDependencyBody {
    /**
     * 
     * @type {DependencyType}
     * @memberof QuestionDependencyBody
     */
    'type': DependencyType;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyBody
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyBody
     */
    'targetId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDependencyBody
     */
    'parameters': Array<string>;
}


/**
 * 
 * @export
 * @interface QuestionDependencyListView
 */
export interface QuestionDependencyListView {
    /**
     * 
     * @type {Array<QuestionDependencyView>}
     * @memberof QuestionDependencyListView
     */
    'targets': Array<QuestionDependencyView>;
    /**
     * 
     * @type {Array<QuestionDependencyView>}
     * @memberof QuestionDependencyListView
     */
    'sources': Array<QuestionDependencyView>;
    /**
     * 
     * @type {number}
     * @memberof QuestionDependencyListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface QuestionDependencyView
 */
export interface QuestionDependencyView {
    /**
     * 
     * @type {DependencyType}
     * @memberof QuestionDependencyView
     */
    'type': DependencyType;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'sourceId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'targetId': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDependencyView
     */
    'text': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionDependencyView
     */
    'parameters': Array<string>;
}


/**
 * 
 * @export
 * @interface QuestionDetailsView
 */
export interface QuestionDetailsView {
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionDetailsView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionDetailsView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionDetailsView
     */
    'visibilityType': VisibilityType;
    /**
     * 
     * @type {GenerationType}
     * @memberof QuestionDetailsView
     */
    'generationType': GenerationType;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'expiry'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionDetailsView
     */
    'answeredCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionDetailsView
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionDetailsView
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface QuestionIgnoreMergeBody
 */
export interface QuestionIgnoreMergeBody {
    /**
     * 
     * @type {string}
     * @memberof QuestionIgnoreMergeBody
     */
    'secondQuestionId': string;
}
/**
 * 
 * @export
 * @interface QuestionMergeBody
 */
export interface QuestionMergeBody {
    /**
     * 
     * @type {string}
     * @memberof QuestionMergeBody
     */
    'targetQuestionId': string;
}
/**
 * 
 * @export
 * @interface QuestionOptionBody
 */
export interface QuestionOptionBody {
    /**
     * 
     * @type {number}
     * @memberof QuestionOptionBody
     */
    'limit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionOptionBody
     */
    'offset'?: number | null;
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionOptionBody
     */
    'translations': Array<TranslationBody>;
    /**
     * 
     * @type {string}
     * @memberof QuestionOptionBody
     */
    'key': string;
}
/**
 * 
 * @export
 * @interface QuestionOptionTranslationBody
 */
export interface QuestionOptionTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionOptionTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface QuestionOptionView
 */
export interface QuestionOptionView {
    /**
     * 
     * @type {string}
     * @memberof QuestionOptionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionOptionView
     */
    'key': string;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof QuestionOptionView
     */
    'translations': Array<TranslationView>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionOrderBy = {
    UpdatedAt: 'updatedAt',
    QuestionType: 'questionType',
    IsActive: 'isActive',
    SkippedCount: 'skippedCount',
    AnsweredCount: 'answeredCount',
    TrialCount: 'trialCount',
    Distance: 'distance'
} as const;

export type QuestionOrderBy = typeof QuestionOrderBy[keyof typeof QuestionOrderBy];


/**
 * 
 * @export
 * @interface QuestionTranslationBody
 */
export interface QuestionTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof QuestionTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface QuestionTranslationView
 */
export interface QuestionTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof QuestionTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof QuestionTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionTranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof QuestionTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionTranslationView
     */
    'questionId': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionType = {
    Standard: 'standard',
    TrialSpecific: 'trialSpecific',
    Proposed: 'proposed',
    Physician: 'physician',
    Distractor: 'distractor'
} as const;

export type QuestionType = typeof QuestionType[keyof typeof QuestionType];


/**
 * 
 * @export
 * @interface QuestionUpdateBody
 */
export interface QuestionUpdateBody {
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionUpdateBody
     */
    'questionType'?: QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionUpdateBody
     */
    'visibilityType'?: VisibilityType;
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionUpdateBody
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {string}
     * @memberof QuestionUpdateBody
     */
    'unit'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QuestionUpdateBody
     */
    'expiry'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QuestionUpdateBody
     */
    'icdCodes'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionUpdateBody
     */
    'isActive'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionUpdateBody
     */
    'standardCriterionText'?: string | null;
}


/**
 * 
 * @export
 * @interface QuestionView
 */
export interface QuestionView {
    /**
     * 
     * @type {QuestionType}
     * @memberof QuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {VisibilityType}
     * @memberof QuestionView
     */
    'visibilityType': VisibilityType;
    /**
     * 
     * @type {AnswerType}
     * @memberof QuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {GenerationType}
     * @memberof QuestionView
     */
    'generationType': GenerationType;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionView
     */
    'isActive': boolean;
    /**
     * 
     * @type {Array<QuestionCategoryOverview>}
     * @memberof QuestionView
     */
    'categories': Array<QuestionCategoryOverview>;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'icdCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'answeredCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'trialCount': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'icdTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestionView
     */
    'distance'?: number | null;
}


/**
 * 
 * @export
 * @interface ReducedTeamView
 */
export interface ReducedTeamView {
    /**
     * 
     * @type {string}
     * @memberof ReducedTeamView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof ReducedTeamView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RefreshBody
 */
export interface RefreshBody {
    /**
     * 
     * @type {string}
     * @memberof RefreshBody
     */
    'refreshToken': string;
    /**
     * 
     * @type {string}
     * @memberof RefreshBody
     */
    'teamId'?: string | null;
}
/**
 * 
 * @export
 * @interface RejectionReasonBody
 */
export interface RejectionReasonBody {
    /**
     * 
     * @type {PatientRejectionReason}
     * @memberof RejectionReasonBody
     */
    'type': PatientRejectionReason;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonBody
     */
    'criteriaId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonBody
     */
    'comment'?: string | null;
}


/**
 * 
 * @export
 * @interface RejectionReasonView
 */
export interface RejectionReasonView {
    /**
     * 
     * @type {PatientRejectionReason}
     * @memberof RejectionReasonView
     */
    'type': PatientRejectionReason;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'rejecterId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'rejecterName': string;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'criteriaId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'criteriaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RejectionReasonView
     */
    'comment'?: string | null;
}


/**
 * 
 * @export
 * @interface RemoveCategoryDiseaseBody
 */
export interface RemoveCategoryDiseaseBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveCategoryDiseaseBody
     */
    'diseaseId': string;
}
/**
 * 
 * @export
 * @interface RemoveQuestionCategoryBody
 */
export interface RemoveQuestionCategoryBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveQuestionCategoryBody
     */
    'categoryId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ResearchType = {
    Trial: 'trial',
    Survey: 'survey'
} as const;

export type ResearchType = typeof ResearchType[keyof typeof ResearchType];


/**
 * 
 * @export
 * @interface ResetPasswordBody
 */
export interface ResetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordBody
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface RetryQuestionBody
 */
export interface RetryQuestionBody {
    /**
     * 
     * @type {Language}
     * @memberof RetryQuestionBody
     */
    'language': Language;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const Role = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type Role = typeof Role[keyof typeof Role];


/**
 * 
 * @export
 * @interface SetPasswordBody
 */
export interface SetPasswordBody {
    /**
     * 
     * @type {string}
     * @memberof SetPasswordBody
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof SetPasswordBody
     */
    'password': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SexEnum = {
    Male: 'MALE',
    Female: 'FEMALE',
    All: 'ALL'
} as const;

export type SexEnum = typeof SexEnum[keyof typeof SexEnum];


/**
 * 
 * @export
 * @interface SkipChatEntryBody
 */
export interface SkipChatEntryBody {
    /**
     * 
     * @type {SkipReason}
     * @memberof SkipChatEntryBody
     */
    'reason': SkipReason;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SkipReason = {
    DontWantAnswerNow: 'dont_want_answer_now',
    DontWantAnswerEver: 'dont_want_answer_ever',
    DontKnow: 'dont_know',
    DontUnderstandQuestion: 'dont_understand_question',
    HaveAskDoctor: 'have_ask_doctor',
    AlreadyAnsweredQuestion: 'already_answered_question',
    AnswerOtherQuestionFirst: 'answer_other_question_first',
    NotRelevant: 'not_relevant',
    Other: 'other'
} as const;

export type SkipReason = typeof SkipReason[keyof typeof SkipReason];


/**
 * 
 * @export
 * @interface SubscriptionPreferenceView
 */
export interface SubscriptionPreferenceView {
    /**
     * 
     * @type {CommunicationKey}
     * @memberof SubscriptionPreferenceView
     */
    'key': CommunicationKey;
    /**
     * 
     * @type {PreferenceView}
     * @memberof SubscriptionPreferenceView
     */
    'preference': PreferenceView;
}


/**
 * 
 * @export
 * @interface SubscriptionPreferencesBody
 */
export interface SubscriptionPreferencesBody {
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPreferencesBody
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPreferencesBody
     */
    'notification': boolean;
    /**
     * 
     * @type {DigestBody}
     * @memberof SubscriptionPreferencesBody
     */
    'digest'?: DigestBody | null;
}
/**
 * 
 * @export
 * @interface SubscriptionPreferencesListView
 */
export interface SubscriptionPreferencesListView {
    /**
     * 
     * @type {Array<SubscriptionPreferenceView>}
     * @memberof SubscriptionPreferencesListView
     */
    'items': Array<SubscriptionPreferenceView>;
}
/**
 * 
 * @export
 * @interface SurveyCreateBody
 */
export interface SurveyCreateBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyCreateBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyCreateBody
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyCreateBody
     */
    'endDate': string;
}
/**
 * 
 * @export
 * @interface SurveyDependencyUpdateBody
 */
export interface SurveyDependencyUpdateBody {
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyDependencyUpdateBody
     */
    'requiredAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface SurveyDetailsView
 */
export interface SurveyDetailsView {
    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyDetailsView
     */
    'status': SurveyStatus;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyDetailsView
     */
    'sentAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyDetailsView
     */
    'potentialReachCount'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SurveyOrderBy = {
    SurveyId: 'surveyId',
    UpdatedAt: 'updatedAt',
    Title: 'title'
} as const;

export type SurveyOrderBy = typeof SurveyOrderBy[keyof typeof SurveyOrderBy];


/**
 * 
 * @export
 * @interface SurveyPotentialCountView
 */
export interface SurveyPotentialCountView {
    /**
     * 
     * @type {number}
     * @memberof SurveyPotentialCountView
     */
    'potentialCount': number;
}
/**
 * 
 * @export
 * @interface SurveyQuestionBody
 */
export interface SurveyQuestionBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionBody
     */
    'questionId': string;
}
/**
 * 
 * @export
 * @interface SurveyQuestionConditionView
 */
export interface SurveyQuestionConditionView {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionConditionView
     */
    'answerType': SurveyQuestionConditionViewAnswerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyQuestionConditionView
     */
    'requiredAnswers'?: Array<string> | null;
}

export const SurveyQuestionConditionViewAnswerTypeEnum = {
    Boolean: 'boolean',
    Number: 'number',
    String: 'string',
    Date: 'date',
    Options: 'options',
    MultipleOptions: 'multipleOptions'
} as const;

export type SurveyQuestionConditionViewAnswerTypeEnum = typeof SurveyQuestionConditionViewAnswerTypeEnum[keyof typeof SurveyQuestionConditionViewAnswerTypeEnum];

/**
 * 
 * @export
 * @interface SurveyQuestionDependencyBody
 */
export interface SurveyQuestionDependencyBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyBody
     */
    'sourceId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyQuestionDependencyBody
     */
    'requiredAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface SurveyQuestionDependencyListView
 */
export interface SurveyQuestionDependencyListView {
    /**
     * 
     * @type {Array<SurveyQuestionDependencyView>}
     * @memberof SurveyQuestionDependencyListView
     */
    'items': Array<SurveyQuestionDependencyView>;
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionDependencyListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface SurveyQuestionDependencyView
 */
export interface SurveyQuestionDependencyView {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyView
     */
    'sourceId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionDependencyView
     */
    'text': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyQuestionDependencyView
     */
    'requiredAnswers': Array<string>;
}
/**
 * 
 * @export
 * @interface SurveyQuestionMoveBody
 */
export interface SurveyQuestionMoveBody {
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionMoveBody
     */
    'newPosition': number;
}
/**
 * 
 * @export
 * @interface SurveyQuestionOptionView
 */
export interface SurveyQuestionOptionView {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionOptionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionOptionView
     */
    'key': string;
    /**
     * 
     * @type {Array<TranslationView>}
     * @memberof SurveyQuestionOptionView
     */
    'translations': Array<TranslationView>;
}
/**
 * 
 * @export
 * @interface SurveyQuestionUpdateBody
 */
export interface SurveyQuestionUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionUpdateBody
     */
    'questionId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyQuestionUpdateBody
     */
    'getFromProfile'?: boolean;
}
/**
 * 
 * @export
 * @interface SurveyQuestionView
 */
export interface SurveyQuestionView {
    /**
     * 
     * @type {QuestionType}
     * @memberof SurveyQuestionView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {AnswerType}
     * @memberof SurveyQuestionView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'surveyId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SurveyQuestionView
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'questionText': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {Array<SurveyQuestionConditionView>}
     * @memberof SurveyQuestionView
     */
    'conditions'?: Array<SurveyQuestionConditionView> | null;
    /**
     * 
     * @type {Array<SurveyQuestionOptionView>}
     * @memberof SurveyQuestionView
     */
    'options'?: Array<SurveyQuestionOptionView> | null;
}


/**
 * 
 * @export
 * @interface SurveyResponseOverviewView
 */
export interface SurveyResponseOverviewView {
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseOverviewView
     */
    'confirmed': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SurveyStatus = {
    Draft: 'draft',
    Active: 'active',
    Closed: 'closed'
} as const;

export type SurveyStatus = typeof SurveyStatus[keyof typeof SurveyStatus];


/**
 * 
 * @export
 * @interface SurveyTranslationBody
 */
export interface SurveyTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof SurveyTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface SurveyTranslationView
 */
export interface SurveyTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof SurveyTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof SurveyTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyTranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof SurveyTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyTranslationView
     */
    'surveyId': string;
}


/**
 * 
 * @export
 * @interface SurveyUpdateBody
 */
export interface SurveyUpdateBody {
    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyUpdateBody
     */
    'status'?: SurveyStatus;
    /**
     * 
     * @type {string}
     * @memberof SurveyUpdateBody
     */
    'endDate'?: string;
}


/**
 * 
 * @export
 * @interface SurveyView
 */
export interface SurveyView {
    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyView
     */
    'status': SurveyStatus;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SurveyView
     */
    'endDate': string;
    /**
     * 
     * @type {number}
     * @memberof SurveyView
     */
    'questionCount': number;
}


/**
 * 
 * @export
 * @interface SurveysOverviewView
 */
export interface SurveysOverviewView {
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof SurveysOverviewView
     */
    'confirmed': number;
}
/**
 * 
 * @export
 * @interface TagConfigurationItem
 */
export interface TagConfigurationItem {
    /**
     * 
     * @type {string}
     * @memberof TagConfigurationItem
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof TagConfigurationItem
     */
    'id': string;
}
/**
 * 
 * @export
 * @interface TagConfigurationView
 */
export interface TagConfigurationView {
    /**
     * 
     * @type {Array<TagConfigurationItem>}
     * @memberof TagConfigurationView
     */
    'tags': Array<TagConfigurationItem>;
}
/**
 * 
 * @export
 * @interface TeamBody
 */
export interface TeamBody {
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'teamRole': string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'role': TeamBodyRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamBody
     */
    'token'?: string;
}

export const TeamBodyRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type TeamBodyRoleEnum = typeof TeamBodyRoleEnum[keyof typeof TeamBodyRoleEnum];

/**
 * 
 * @export
 * @interface TeamCreateInviteBody
 */
export interface TeamCreateInviteBody {
    /**
     * 
     * @type {ThemeType}
     * @memberof TeamCreateInviteBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {Role}
     * @memberof TeamCreateInviteBody
     */
    'teamRole': Role;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteBody
     */
    'teamName': string;
    /**
     * 
     * @type {Array<InviteTrialData>}
     * @memberof TeamCreateInviteBody
     */
    'trialData': Array<InviteTrialData>;
}


/**
 * 
 * @export
 * @interface TeamCreateInviteListView
 */
export interface TeamCreateInviteListView {
    /**
     * 
     * @type {Array<TeamCreateInviteView>}
     * @memberof TeamCreateInviteListView
     */
    'items': Array<TeamCreateInviteView>;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface TeamCreateInviteQuery
 */
export interface TeamCreateInviteQuery {
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteQuery
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface TeamCreateInviteUpdateBody
 */
export interface TeamCreateInviteUpdateBody {
    /**
     * 
     * @type {Role}
     * @memberof TeamCreateInviteUpdateBody
     */
    'teamRole'?: Role;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteUpdateBody
     */
    'teamName'?: string;
    /**
     * 
     * @type {Array<InviteTrialData>}
     * @memberof TeamCreateInviteUpdateBody
     */
    'trialData': Array<InviteTrialData>;
}


/**
 * 
 * @export
 * @interface TeamCreateInviteView
 */
export interface TeamCreateInviteView {
    /**
     * 
     * @type {Language}
     * @memberof TeamCreateInviteView
     */
    'language': Language;
    /**
     * 
     * @type {TokenType}
     * @memberof TeamCreateInviteView
     */
    'tokenType': TokenType;
    /**
     * 
     * @type {Role}
     * @memberof TeamCreateInviteView
     */
    'role': Role;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'inviteUrl': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof TeamCreateInviteView
     */
    'teamName': string;
    /**
     * 
     * @type {Array<TokenTrialDataView>}
     * @memberof TeamCreateInviteView
     */
    'trialData': Array<TokenTrialDataView>;
}


/**
 * 
 * @export
 * @interface TeamDetailsView
 */
export interface TeamDetailsView {
    /**
     * 
     * @type {Role}
     * @memberof TeamDetailsView
     */
    'role': Role;
    /**
     * 
     * @type {TeamType}
     * @memberof TeamDetailsView
     */
    'type': TeamType;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetailsView
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {LeadResponsible}
     * @memberof TeamDetailsView
     */
    'leadResponsible': LeadResponsible;
    /**
     * 
     * @type {boolean}
     * @memberof TeamDetailsView
     */
    'roleConfirmed': boolean;
}


/**
 * 
 * @export
 * @interface TeamListView
 */
export interface TeamListView {
    /**
     * 
     * @type {Array<TeamView>}
     * @memberof TeamListView
     */
    'items': Array<TeamView>;
    /**
     * 
     * @type {string}
     * @memberof TeamListView
     */
    'nextPageToken'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamLocationView
 */
export interface TeamLocationView {
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamLocationView
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface TeamMandatesListView
 */
export interface TeamMandatesListView {
    /**
     * 
     * @type {boolean}
     * @memberof TeamMandatesListView
     */
    'hasRunningSubscription': boolean;
    /**
     * 
     * @type {number}
     * @memberof TeamMandatesListView
     */
    'subscriptionCount': number;
    /**
     * 
     * @type {number}
     * @memberof TeamMandatesListView
     */
    'unusedSubscriptionCount': number;
    /**
     * 
     * @type {Array<MandateView>}
     * @memberof TeamMandatesListView
     */
    'mandates': Array<MandateView>;
    /**
     * 
     * @type {number}
     * @memberof TeamMandatesListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface TeamMemberBody
 */
export interface TeamMemberBody {
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TeamMemberBody
     */
    'trialPermissions'?: Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TeamMemberBody
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberBody
     */
    'teamRole': string;
}
/**
 * 
 * @export
 * @interface TeamMemberInviteBody
 */
export interface TeamMemberInviteBody {
    /**
     * 
     * @type {ThemeType}
     * @memberof TeamMemberInviteBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TeamMemberInviteBody
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TeamMemberInviteBody
     */
    'permissions'?: Array<TrialPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberInviteBody
     */
    'teamRole': string;
}


/**
 * 
 * @export
 * @interface TeamMemberListView
 */
export interface TeamMemberListView {
    /**
     * 
     * @type {Array<TeamMemberView>}
     * @memberof TeamMemberListView
     */
    'items': Array<TeamMemberView>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberListView
     */
    'nextPageToken'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamMemberView
 */
export interface TeamMemberView {
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TeamMemberView
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TeamMemberView
     */
    'trialPermissions': Array<TrialPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TeamMemberView
     */
    'teamRole': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TeamPermissionEnum = {
    TeamRead: 'team:read',
    TeamWrite: 'team:write',
    TeamUsers: 'team:users',
    TeamBilling: 'team:billing'
} as const;

export type TeamPermissionEnum = typeof TeamPermissionEnum[keyof typeof TeamPermissionEnum];


/**
 * 
 * @export
 * @interface TeamTrialBody
 */
export interface TeamTrialBody {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TeamTrialBody
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialBody
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialBody
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialBody
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @interface TeamTrialLocationView
 */
export interface TeamTrialLocationView {
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialLocationView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface TeamTrialView
 */
export interface TeamTrialView {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TeamTrialView
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TeamTrialView
     */
    'briefTitleKey': string;
    /**
     * 
     * @type {TeamTrialLocationView}
     * @memberof TeamTrialView
     */
    'location'?: TeamTrialLocationView;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TeamType = {
    Work: 'work',
    Management: 'management'
} as const;

export type TeamType = typeof TeamType[keyof typeof TeamType];


/**
 * 
 * @export
 * @interface TeamUpdateBody
 */
export interface TeamUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamUpdateBody
     */
    'leadResponsible'?: string;
}
/**
 * 
 * @export
 * @interface TeamView
 */
export interface TeamView {
    /**
     * 
     * @type {TeamType}
     * @memberof TeamView
     */
    'type': TeamType;
    /**
     * 
     * @type {Role}
     * @memberof TeamView
     */
    'role': Role;
    /**
     * 
     * @type {string}
     * @memberof TeamView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TeamView
     */
    'name': string;
    /**
     * 
     * @type {Array<TrialIdsView>}
     * @memberof TeamView
     */
    'trials': Array<TrialIdsView>;
    /**
     * 
     * @type {number}
     * @memberof TeamView
     */
    'memberCount': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ThemeType = {
    Curewiki: 'Curewiki',
    YesWeCancer: 'YesWeCancer',
    Bhs: 'BHS',
    Pce: 'PCE',
    Pec: 'PEC'
} as const;

export type ThemeType = typeof ThemeType[keyof typeof ThemeType];


/**
 * 
 * @export
 * @interface TokenTrialDataView
 */
export interface TokenTrialDataView {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TokenTrialDataView
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TokenTrialDataView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TokenTrialDataView
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof TokenTrialDataView
     */
    'locationId'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TokenType = {
    AccountClaim: 'account-claim',
    Invite: 'invite',
    TeamInvite: 'team-invite',
    TeamCreate: 'team-create'
} as const;

export type TokenType = typeof TokenType[keyof typeof TokenType];


/**
 * 
 * @export
 * @interface TokenView
 */
export interface TokenView {
    /**
     * 
     * @type {Language}
     * @memberof TokenView
     */
    'language': Language;
    /**
     * 
     * @type {TokenType}
     * @memberof TokenView
     */
    'tokenType': TokenType;
    /**
     * 
     * @type {Role}
     * @memberof TokenView
     */
    'role': Role;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'teamId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'teamRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'teamName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'companyRole'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenView
     */
    'country'?: string | null;
    /**
     * 
     * @type {Array<TokenTrialDataView>}
     * @memberof TokenView
     */
    'trialData'?: Array<TokenTrialDataView>;
}


/**
 * 
 * @export
 * @interface TranslationBody
 */
export interface TranslationBody {
    /**
     * 
     * @type {string}
     * @memberof TranslationBody
     */
    'language': TranslationBodyLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof TranslationBody
     */
    'value': string;
    /**
     * 
     * @type {boolean}
     * @memberof TranslationBody
     */
    'autoGenerate': boolean;
}

export const TranslationBodyLanguageEnum = {
    En: 'en',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs'
} as const;

export type TranslationBodyLanguageEnum = typeof TranslationBodyLanguageEnum[keyof typeof TranslationBodyLanguageEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TranslationStatus = {
    Ready: 'ready',
    Processing: 'processing'
} as const;

export type TranslationStatus = typeof TranslationStatus[keyof typeof TranslationStatus];


/**
 * 
 * @export
 * @interface TranslationView
 */
export interface TranslationView {
    /**
     * 
     * @type {Language}
     * @memberof TranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof TranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof TranslationView
     */
    'value': string;
}


/**
 * 
 * @export
 * @interface TrialAccessApproveBody
 */
export interface TrialAccessApproveBody {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TrialAccessApproveBody
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessApproveBody
     */
    'matchingId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessApproveBody
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessApproveBody
     */
    'locationName'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialAccessBody
 */
export interface TrialAccessBody {
    /**
     * 
     * @type {string}
     * @memberof TrialAccessBody
     */
    'matchingId'?: string | null;
    /**
     * 
     * @type {TrialAccessLocation}
     * @memberof TrialAccessBody
     */
    'location'?: TrialAccessLocation;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessBody
     */
    'requestMessage': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialAccessBody
     */
    'isExistingTrial': boolean;
}
/**
 * 
 * @export
 * @interface TrialAccessListView
 */
export interface TrialAccessListView {
    /**
     * 
     * @type {number}
     * @memberof TrialAccessListView
     */
    'count': number;
    /**
     * 
     * @type {Array<TrialAccessView>}
     * @memberof TrialAccessListView
     */
    'items': Array<TrialAccessView>;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessListView
     */
    'nextPageToken'?: string;
}
/**
 * 
 * @export
 * @interface TrialAccessLocation
 */
export interface TrialAccessLocation {
    /**
     * 
     * @type {boolean}
     * @memberof TrialAccessLocation
     */
    'isExistingLocation': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessLocation
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialAccessView
 */
export interface TrialAccessView {
    /**
     * 
     * @type {Language}
     * @memberof TrialAccessView
     */
    'language': Language;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof TrialAccessView
     */
    'status': AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'matchingId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'teamName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'teamLeadName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'organizationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'researchSiteName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'role': TrialAccessViewRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'requestMessage': string;
    /**
     * 
     * @type {string}
     * @memberof TrialAccessView
     */
    'createdAt': string;
    /**
     * 
     * @type {TrialAccessLocation}
     * @memberof TrialAccessView
     */
    'location'?: TrialAccessLocation;
}

export const TrialAccessViewRoleEnum = {
    Admin: 'admin',
    Volunteer: 'volunteer',
    TrialManager: 'trialManager',
    Reviewer: 'reviewer',
    PatientOrg: 'patientOrg',
    Sponsor: 'sponsor'
} as const;

export type TrialAccessViewRoleEnum = typeof TrialAccessViewRoleEnum[keyof typeof TrialAccessViewRoleEnum];

/**
 * 
 * @export
 * @interface TrialActivityView
 */
export interface TrialActivityView {
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialActivityView
     */
    'answerType'?: AnswerType;
    /**
     * 
     * @type {ActivityType}
     * @memberof TrialActivityView
     */
    'type': ActivityType;
    /**
     * 
     * @type {FeedbackType}
     * @memberof TrialActivityView
     */
    'feedbackType'?: FeedbackType;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'questionText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'criteriaText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialActivityView
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialActivityView
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialActivityView
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'unit'?: string;
    /**
     * 
     * @type {object}
     * @memberof TrialActivityView
     */
    'effectType'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialActivityView
     */
    'locationName'?: string | null;
}


/**
 * 
 * @export
 * @interface TrialAddCTBody
 */
export interface TrialAddCTBody {
    /**
     * 
     * @type {boolean}
     * @memberof TrialAddCTBody
     */
    'reprocessingConfirmed'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TrialBoosterBody
 */
export interface TrialBoosterBody {
    /**
     * 
     * @type {string}
     * @memberof TrialBoosterBody
     */
    'comment': string;
    /**
     * 
     * @type {number}
     * @memberof TrialBoosterBody
     */
    'numberOfPatients': number;
}
/**
 * 
 * @export
 * @interface TrialCommentBody
 */
export interface TrialCommentBody {
    /**
     * 
     * @type {string}
     * @memberof TrialCommentBody
     */
    'comment': string;
}
/**
 * 
 * @export
 * @interface TrialContactBody
 */
export interface TrialContactBody {
    /**
     * 
     * @type {string}
     * @memberof TrialContactBody
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactBody
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactBody
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface TrialContactView
 */
export interface TrialContactView {
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialContactView
     */
    'type': TrialContactViewTypeEnum;
}

export const TrialContactViewTypeEnum = {
    Static: 'static',
    LinkedUser: 'linkedUser'
} as const;

export type TrialContactViewTypeEnum = typeof TrialContactViewTypeEnum[keyof typeof TrialContactViewTypeEnum];

/**
 * 
 * @export
 * @interface TrialCreateBody
 */
export interface TrialCreateBody {
    /**
     * 
     * @type {SexEnum}
     * @memberof TrialCreateBody
     */
    'sex': SexEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'summary': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'primaryCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'studyCompletionDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'sponsor': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'responsibleParty': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCreateBody
     */
    'criteriaText': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialCreateBody
     */
    'conditions': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TrialCreateBody
     */
    'allowHealthyPatients': boolean;
}


/**
 * 
 * @export
 * @interface TrialCriteriaBody
 */
export interface TrialCriteriaBody {
    /**
     * 
     * @type {CriteriaType}
     * @memberof TrialCriteriaBody
     */
    'type': CriteriaType;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaBody
     */
    'criteriaText': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialCriteriaBody
     */
    'value'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaBody
     */
    'minThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaBody
     */
    'maxThreshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialCriteriaBody
     */
    'otherValues'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaBody
     */
    'questionId': string;
}


/**
 * 
 * @export
 * @interface TrialCriteriaView
 */
export interface TrialCriteriaView {
    /**
     * 
     * @type {CriteriaStatus}
     * @memberof TrialCriteriaView
     */
    'status': CriteriaStatus;
    /**
     * 
     * @type {CriteriaType}
     * @memberof TrialCriteriaView
     */
    'type': CriteriaType;
    /**
     * 
     * @type {QuestionType}
     * @memberof TrialCriteriaView
     */
    'questionType': QuestionType;
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialCriteriaView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'originalCriteriaText': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialCriteriaView
     */
    'questionText': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialCriteriaView
     */
    'value'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'minThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'maxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialCriteriaView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'commentCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'feedbackCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialCriteriaView
     */
    'position': number;
    /**
     * 
     * @type {Array<CriteriaDependencyView>}
     * @memberof TrialCriteriaView
     */
    'dependencies': Array<CriteriaDependencyView>;
}


/**
 * 
 * @export
 * @interface TrialDetailsView
 */
export interface TrialDetailsView {
    /**
     * 
     * @type {MandateStatus}
     * @memberof TrialDetailsView
     */
    'mandateStatus': MandateStatus;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof TrialDetailsView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof TrialDetailsView
     */
    'matchingStatus': MatchingTrialStatus;
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof TrialDetailsView
     */
    'overallStatus': OverallTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'mandateLocationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'briefTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'detailedDescription'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'briefSummary': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'isValidated': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'leadSponsor': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'primaryCompletionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'studyCompletionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'lastUpdatePostDate': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'responsibleParty': string;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'url': string;
    /**
     * 
     * @type {Array<AiProcessorView>}
     * @memberof TrialDetailsView
     */
    'processedBy'?: Array<AiProcessorView> | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'nextReachOutVerified'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialDetailsView
     */
    'nextReachOutMissingAnswers'?: string | null;
    /**
     * 
     * @type {EffectView}
     * @memberof TrialDetailsView
     */
    'effect'?: EffectView;
    /**
     * 
     * @type {boolean}
     * @memberof TrialDetailsView
     */
    'withDirectMessage': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialDetailsView
     */
    'conditions': Array<string>;
}


/**
 * 
 * @export
 * @interface TrialEffectBody
 */
export interface TrialEffectBody {
    /**
     * 
     * @type {EffectType}
     * @memberof TrialEffectBody
     */
    'type': EffectType;
    /**
     * 
     * @type {boolean}
     * @memberof TrialEffectBody
     */
    'withDirectMessage': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialEffectBody
     */
    'url'?: string;
}


/**
 * 
 * @export
 * @interface TrialIdsView
 */
export interface TrialIdsView {
    /**
     * 
     * @type {string}
     * @memberof TrialIdsView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialIdsView
     */
    'matchingId': string;
}
/**
 * 
 * @export
 * @interface TrialInviteUpdateBody
 */
export interface TrialInviteUpdateBody {
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TrialInviteUpdateBody
     */
    'permissions'?: Array<TrialPermissionEnum>;
    /**
     * 
     * @type {Array<TeamPermissionEnum>}
     * @memberof TrialInviteUpdateBody
     */
    'teamPermissions': Array<TeamPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialInviteUpdateBody
     */
    'tokenValue': string;
    /**
     * 
     * @type {string}
     * @memberof TrialInviteUpdateBody
     */
    'teamRole': string;
}
/**
 * 
 * @export
 * @interface TrialLocationBody
 */
export interface TrialLocationBody {
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationBody
     */
    'facility'?: string;
}
/**
 * 
 * @export
 * @interface TrialLocationPermissionsListView
 */
export interface TrialLocationPermissionsListView {
    /**
     * 
     * @type {number}
     * @memberof TrialLocationPermissionsListView
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface TrialLocationView
 */
export interface TrialLocationView {
    /**
     * 
     * @type {CoordinateView}
     * @memberof TrialLocationView
     */
    'coordinates'?: CoordinateView;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'facility'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialLocationView
     */
    'locationStatus'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialLocationView
     */
    'isActive': boolean;
    /**
     * 
     * @type {EffectView}
     * @memberof TrialLocationView
     */
    'effect'?: EffectView;
}
/**
 * 
 * @export
 * @interface TrialManagerSignUpBody
 */
export interface TrialManagerSignUpBody {
    /**
     * 
     * @type {Language}
     * @memberof TrialManagerSignUpBody
     */
    'language': Language;
    /**
     * 
     * @type {Role}
     * @memberof TrialManagerSignUpBody
     */
    'role'?: Role;
    /**
     * 
     * @type {ThemeType}
     * @memberof TrialManagerSignUpBody
     */
    'theme'?: ThemeType;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'companyRole'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'companyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'researchSiteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialManagerSignUpBody
     */
    'phoneNumber'?: string;
}


/**
 * 
 * @export
 * @interface TrialMatchView
 */
export interface TrialMatchView {
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialMatchView
     */
    'isLocationActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'contactedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'verifiedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialMatchView
     */
    'acceptedAt'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TrialOrderBy = {
    TrialId: 'trialId',
    UpdatedAt: 'updatedAt',
    MatchingStatus: 'matchingStatus',
    Favorite: 'favorite',
    ManagedBy: 'managedBy',
    PendingUserTrialCount: 'pendingUserTrialCount',
    ConfirmedUserTrialCount: 'confirmedUserTrialCount',
    AcceptedUserTrialCount: 'acceptedUserTrialCount',
    EligibleUserTrialCount: 'eligibleUserTrialCount',
    PotentialUserTrialCount: 'potentialUserTrialCount'
} as const;

export type TrialOrderBy = typeof TrialOrderBy[keyof typeof TrialOrderBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const TrialPermissionEnum = {
    TrialRead: 'trial:read',
    TrialComment: 'trial:comment',
    TrialWrite: 'trial:write',
    TrialFunnel: 'trial:funnel',
    ContactsRead: 'contacts:read',
    TeamWrite: 'team:write',
    FunnelOverview: 'funnel:overview'
} as const;

export type TrialPermissionEnum = typeof TrialPermissionEnum[keyof typeof TrialPermissionEnum];


/**
 * 
 * @export
 * @interface TrialPermissionsView
 */
export interface TrialPermissionsView {
    /**
     * 
     * @type {Role}
     * @memberof TrialPermissionsView
     */
    'type': Role;
    /**
     * 
     * @type {Array<TrialPermissionEnum>}
     * @memberof TrialPermissionsView
     */
    'permissions': Array<TrialPermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'trialId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPermissionsView
     */
    'email': string;
}


/**
 * 
 * @export
 * @interface TrialPublicView
 */
export interface TrialPublicView {
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof TrialPublicView
     */
    'status': AccessRequestStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'briefTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialPublicView
     */
    'trialId': string;
    /**
     * 
     * @type {number}
     * @memberof TrialPublicView
     */
    'potentialUserTrialCount'?: number;
}


/**
 * 
 * @export
 * @interface TrialReachOutBody
 */
export interface TrialReachOutBody {
    /**
     * 
     * @type {string}
     * @memberof TrialReachOutBody
     */
    'communicationKey': TrialReachOutBodyCommunicationKeyEnum;
}

export const TrialReachOutBodyCommunicationKeyEnum = {
    ResetPassword: 'resetPassword',
    SetPassword: 'setPassword',
    VerifyEmail: 'verifyEmail',
    Invite: 'invite',
    AcceptedTrialContact: 'acceptedTrialContact',
    VolunteerAcceptedManagedTrial: 'volunteerAcceptedManagedTrial',
    RequestTrialCriteriaDigest: 'requestTrialCriteriaDigest',
    TrialResponseDigest: 'trialResponseDigest',
    RequestBooster: 'requestBooster',
    ExternalContactMatch: 'externalContactMatch',
    FullMatch: 'fullMatch',
    NoMatch: 'noMatch',
    NewQuestions: 'newQuestions',
    NewTrial: 'newTrial',
    NewSurvey: 'newSurvey',
    NewTrialHealthy: 'newTrialHealthy',
    NewTrialUnhealthy: 'newTrialUnhealthy',
    TrialAccessApproved: 'trialAccessApproved',
    TrialAccessRejected: 'trialAccessRejected',
    CriteriaExplanation: 'criteriaExplanation',
    PatientReachOutMissingAnswers: 'patientReachOutMissingAnswers',
    PatientReachOutVerified: 'patientReachOutVerified',
    AccountClaim: 'accountClaim',
    TrialManagerWelcome: 'trialManagerWelcome',
    AccessRequestConfirmation: 'accessRequestConfirmation',
    NewAccessRequest: 'newAccessRequest',
    PendingPatients: 'pendingPatients',
    PendingLocationPatients: 'pendingLocationPatients',
    AutoApproveOverview: 'autoApproveOverview'
} as const;

export type TrialReachOutBodyCommunicationKeyEnum = typeof TrialReachOutBodyCommunicationKeyEnum[keyof typeof TrialReachOutBodyCommunicationKeyEnum];

/**
 * 
 * @export
 * @interface TrialReachOutView
 */
export interface TrialReachOutView {
    /**
     * 
     * @type {number}
     * @memberof TrialReachOutView
     */
    'patientCount': number;
    /**
     * 
     * @type {string}
     * @memberof TrialReachOutView
     */
    'nextReachOut': string;
}
/**
 * 
 * @export
 * @interface TrialTeamListView
 */
export interface TrialTeamListView {
    /**
     * 
     * @type {Array<TrialTeamView>}
     * @memberof TrialTeamListView
     */
    'items': Array<TrialTeamView>;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamListView
     */
    'nextPageToken'?: string | null;
}
/**
 * 
 * @export
 * @interface TrialTeamView
 */
export interface TrialTeamView {
    /**
     * 
     * @type {Array<MandatePermissionEnum>}
     * @memberof TrialTeamView
     */
    'mandatePermissions': Array<MandatePermissionEnum>;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamView
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamView
     */
    'teamName': string;
    /**
     * 
     * @type {number}
     * @memberof TrialTeamView
     */
    'memberCount': number;
    /**
     * 
     * @type {number}
     * @memberof TrialTeamView
     */
    'trialCount': number;
    /**
     * 
     * @type {LeadResponsibleView}
     * @memberof TrialTeamView
     */
    'leadResponsible': LeadResponsibleView;
    /**
     * 
     * @type {string}
     * @memberof TrialTeamView
     */
    'mandateLocationId'?: string;
    /**
     * 
     * @type {TeamLocationView}
     * @memberof TrialTeamView
     */
    'location'?: TeamLocationView;
}
/**
 * 
 * @export
 * @interface TrialTranslationBody
 */
export interface TrialTranslationBody {
    /**
     * 
     * @type {Array<TranslationBody>}
     * @memberof TrialTranslationBody
     */
    'translations': Array<TranslationBody>;
}
/**
 * 
 * @export
 * @interface TrialTranslationView
 */
export interface TrialTranslationView {
    /**
     * 
     * @type {Language}
     * @memberof TrialTranslationView
     */
    'language': Language;
    /**
     * 
     * @type {TranslationStatus}
     * @memberof TrialTranslationView
     */
    'status': TranslationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof TrialTranslationView
     */
    'isAiGenerated': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialTranslationView
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof TrialTranslationView
     */
    'trialId': string;
}


/**
 * 
 * @export
 * @interface TrialView
 */
export interface TrialView {
    /**
     * 
     * @type {ManagementStatus}
     * @memberof TrialView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {MatchingTrialStatus}
     * @memberof TrialView
     */
    'matchingStatus': MatchingTrialStatus;
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof TrialView
     */
    'overallStatus': OverallTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'officialTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'briefTitle': string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'trialId': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialView
     */
    'isFavorite': boolean;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'pendingUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'confirmedUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'eligibleUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'acceptedUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'potentialUserTrialCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrialView
     */
    'locationsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'deletedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'primaryCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'studyCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialView
     */
    'leadSponsor': string;
}


/**
 * 
 * @export
 * @interface TrialVolunteerActivityUsersView
 */
export interface TrialVolunteerActivityUsersView {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityUsersView
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityUsersView
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface TrialVolunteerActivityView
 */
export interface TrialVolunteerActivityView {
    /**
     * 
     * @type {VolunteerActivityType}
     * @memberof TrialVolunteerActivityView
     */
    'type': VolunteerActivityType;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'patientId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'locationId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'receiverId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'receiverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'researcherId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerActivityView
     */
    'researcherName': string;
}


/**
 * 
 * @export
 * @interface TrialVolunteerAnswersListView
 */
export interface TrialVolunteerAnswersListView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof TrialVolunteerAnswersListView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {Array<TrialVolunteerAnswersView>}
     * @memberof TrialVolunteerAnswersListView
     */
    'items': Array<TrialVolunteerAnswersView>;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersListView
     */
    'count': number;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'locationId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'locationName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'eligibleAt': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'patientLanguage': TrialVolunteerAnswersListViewPatientLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'patientCountry': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'patientPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersListView
     */
    'researcherFeedback'?: string | null;
    /**
     * 
     * @type {Array<RejectionReasonView>}
     * @memberof TrialVolunteerAnswersListView
     */
    'rejectionReasons': Array<RejectionReasonView>;
}

export const TrialVolunteerAnswersListViewPatientLanguageEnum = {
    En: 'en',
    Nl: 'nl',
    Fr: 'fr',
    De: 'de',
    Cs: 'cs'
} as const;

export type TrialVolunteerAnswersListViewPatientLanguageEnum = typeof TrialVolunteerAnswersListViewPatientLanguageEnum[keyof typeof TrialVolunteerAnswersListViewPatientLanguageEnum];

/**
 * 
 * @export
 * @interface TrialVolunteerAnswersView
 */
export interface TrialVolunteerAnswersView {
    /**
     * 
     * @type {AnswerType}
     * @memberof TrialVolunteerAnswersView
     */
    'answerType': AnswerType;
    /**
     * 
     * @type {CriteriaStatus}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaStatus': CriteriaStatus;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'questionId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'unit'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaText': string;
    /**
     * 
     * @type {boolean}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaValue'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaMinThreshold'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaMaxThreshold'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialVolunteerAnswersView
     */
    'criteriaOtherValues'?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteerAnswersView
     */
    'numberValue'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TrialVolunteerAnswersView
     */
    'otherValues'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TrialVolunteerAnswersView
     */
    'booleanValue'?: boolean | null;
}


/**
 * 
 * @export
 * @interface TrialVolunteerContactBody
 */
export interface TrialVolunteerContactBody {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactBody
     */
    'contactedAt': string;
}
/**
 * 
 * @export
 * @interface TrialVolunteerContactView
 */
export interface TrialVolunteerContactView {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerContactView
     */
    'phoneNumber'?: string;
}
/**
 * 
 * @export
 * @interface TrialVolunteerFeedbackBody
 */
export interface TrialVolunteerFeedbackBody {
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerFeedbackBody
     */
    'status': TrialVolunteerFeedbackBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof TrialVolunteerFeedbackBody
     */
    'patientMessage'?: string | null;
    /**
     * 
     * @type {Array<RejectionReasonBody>}
     * @memberof TrialVolunteerFeedbackBody
     */
    'rejectionReasons'?: Array<RejectionReasonBody> | null;
}

export const TrialVolunteerFeedbackBodyStatusEnum = {
    Active: 'active',
    Excluded: 'excluded',
    Eligible: 'eligible',
    Denied: 'denied',
    Pending: 'pending',
    PendingLocation: 'pendingLocation',
    Verified: 'verified',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Confirmed: 'confirmed'
} as const;

export type TrialVolunteerFeedbackBodyStatusEnum = typeof TrialVolunteerFeedbackBodyStatusEnum[keyof typeof TrialVolunteerFeedbackBodyStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const TrialVolunteersOrderBy = {
    Country: 'country',
    PostalCode: 'postalCode',
    LocationName: 'locationName',
    AcceptedAt: 'acceptedAt',
    VerifiedAt: 'verifiedAt',
    ContactedAt: 'contactedAt'
} as const;

export type TrialVolunteersOrderBy = typeof TrialVolunteersOrderBy[keyof typeof TrialVolunteersOrderBy];


/**
 * 
 * @export
 * @interface TrialVolunteersOverviewView
 */
export interface TrialVolunteersOverviewView {
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'confirmed': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'verified': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'rejected': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'excluded': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof TrialVolunteersOverviewView
     */
    'pendingLocation': number;
}
/**
 * 
 * @export
 * @interface TrialsOverviewView
 */
export interface TrialsOverviewView {
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'confirmed': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'verified': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'accepted': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'eligible': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'active': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'rejected': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'excluded': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'denied': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof TrialsOverviewView
     */
    'pendingLocation': number;
}
/**
 * 
 * @export
 * @interface UnassignMandateBody
 */
export interface UnassignMandateBody {
    /**
     * 
     * @type {string}
     * @memberof UnassignMandateBody
     */
    'teamId': string;
}
/**
 * 
 * @export
 * @interface UniqueLocationView
 */
export interface UniqueLocationView {
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UniqueLocationView
     */
    'facility'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateMetadataBody
 */
export interface UpdateMetadataBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateMetadataBody
     */
    'metadata': string;
}
/**
 * 
 * @export
 * @interface UpdateMySurveyBody
 */
export interface UpdateMySurveyBody {
    /**
     * 
     * @type {MySurveyCommandType}
     * @memberof UpdateMySurveyBody
     */
    'command': MySurveyCommandType;
}


/**
 * 
 * @export
 * @interface UpdateMyTrialBody
 */
export interface UpdateMyTrialBody {
    /**
     * 
     * @type {MyTrialCommandType}
     * @memberof UpdateMyTrialBody
     */
    'command': MyTrialCommandType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMyTrialBody
     */
    'isPhysician'?: boolean;
}


/**
 * 
 * @export
 * @interface UpdatePasswordBody
 */
export interface UpdatePasswordBody {
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordBody
     */
    'currentPassword': string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePasswordBody
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface UpdateProfileBody
 */
export interface UpdateProfileBody {
    /**
     * 
     * @type {Language}
     * @memberof UpdateProfileBody
     */
    'language'?: Language;
    /**
     * 
     * @type {Gender}
     * @memberof UpdateProfileBody
     */
    'gender'?: Gender;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProfileBody
     */
    'diseases'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'lastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'zipCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'hospital'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'birthDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileBody
     */
    'phoneNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface UpdateTrialBody
 */
export interface UpdateTrialBody {
    /**
     * 
     * @type {ManagementStatus}
     * @memberof UpdateTrialBody
     */
    'managedBy'?: ManagementStatus;
    /**
     * 
     * @type {BillingType}
     * @memberof UpdateTrialBody
     */
    'billingType'?: BillingType;
    /**
     * 
     * @type {OverallTrialStatus}
     * @memberof UpdateTrialBody
     */
    'overallStatus'?: OverallTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'primaryCompletionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTrialBody
     */
    'studyCompletionDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTrialBody
     */
    'withDirectMessage'?: boolean;
}


/**
 * 
 * @export
 * @interface UserSurveyDetailView
 */
export interface UserSurveyDetailView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserSurveyDetailView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyDetailView
     */
    'questionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyDetailView
     */
    'questionsAnswered'?: number;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserSurveyDetailView
     */
    'titleTranslated'?: TranslationView;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'description': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserSurveyDetailView
     */
    'descriptionTranslated'?: TranslationView;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'surveyId': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyDetailView
     */
    'endDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserSurveyDetailView
     */
    'hasMoreQuestions': boolean;
}


/**
 * 
 * @export
 * @interface UserSurveyView
 */
export interface UserSurveyView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserSurveyView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserSurveyView
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyView
     */
    'questionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSurveyView
     */
    'questionsAnswered'?: number;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserSurveyView
     */
    'titleTranslated'?: TranslationView;
}


/**
 * 
 * @export
 * @interface UserTrialDetailView
 */
export interface UserTrialDetailView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserTrialDetailView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof UserTrialDetailView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'briefTitle': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserTrialDetailView
     */
    'briefTitleTranslated'?: TranslationView;
    /**
     * 
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'criteriaTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'criteriaAnswered'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialDetailView
     */
    'distance'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'isValidatedTrial': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'leadSponsor': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'briefSummary': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserTrialDetailView
     */
    'briefSummaryTranslated'?: TranslationView;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTrialDetailView
     */
    'conditions': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'userFeedback'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'researcherFeedback'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'hasMoreQuestions': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialDetailView
     */
    'hasMorePhysicianQuestions': boolean;
    /**
     * 
     * @type {Array<LocationSimpleView>}
     * @memberof UserTrialDetailView
     */
    'locations': Array<LocationSimpleView>;
    /**
     * 
     * @type {LocationDetailView}
     * @memberof UserTrialDetailView
     */
    'currentLocation': LocationDetailView;
    /**
     * 
     * @type {EffectView}
     * @memberof UserTrialDetailView
     */
    'effect'?: EffectView;
    /**
     * 
     * @type {string}
     * @memberof UserTrialDetailView
     */
    'trialId': string;
    /**
     * 
     * @type {Array<ContactView>}
     * @memberof UserTrialDetailView
     */
    'contacts'?: Array<ContactView>;
}


/**
 * 
 * @export
 * @interface UserTrialFeedBackView
 */
export interface UserTrialFeedBackView {
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialFeedBackView
     */
    'isManaged': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialFeedBackView
     */
    'isAccepted': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedBackView
     */
    'redirectUrl'?: string;
}
/**
 * 
 * @export
 * @interface UserTrialFeedbackBody
 */
export interface UserTrialFeedbackBody {
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'status': UserTrialFeedbackBodyStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'userFeedback'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialFeedbackBody
     */
    'locationId': string;
}

export const UserTrialFeedbackBodyStatusEnum = {
    Active: 'active',
    Excluded: 'excluded',
    Eligible: 'eligible',
    Denied: 'denied',
    Pending: 'pending',
    PendingLocation: 'pendingLocation',
    Verified: 'verified',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Confirmed: 'confirmed'
} as const;

export type UserTrialFeedbackBodyStatusEnum = typeof UserTrialFeedbackBodyStatusEnum[keyof typeof UserTrialFeedbackBodyStatusEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const UserTrialStatus = {
    Active: 'active',
    Excluded: 'excluded',
    Eligible: 'eligible',
    Denied: 'denied',
    Pending: 'pending',
    PendingLocation: 'pendingLocation',
    Verified: 'verified',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Confirmed: 'confirmed'
} as const;

export type UserTrialStatus = typeof UserTrialStatus[keyof typeof UserTrialStatus];


/**
 * 
 * @export
 * @interface UserTrialView
 */
export interface UserTrialView {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserTrialView
     */
    'status': UserTrialStatus;
    /**
     * 
     * @type {ManagementStatus}
     * @memberof UserTrialView
     */
    'managedBy': ManagementStatus;
    /**
     * 
     * @type {string}
     * @memberof UserTrialView
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserTrialView
     */
    'briefTitle': string;
    /**
     * 
     * @type {TranslationView}
     * @memberof UserTrialView
     */
    'briefTitleTranslated'?: TranslationView;
    /**
     * 
     * @type {number}
     * @memberof UserTrialView
     */
    'criteriaTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialView
     */
    'criteriaAnswered'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserTrialView
     */
    'distance'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTrialView
     */
    'isValidatedTrial': boolean;
}


/**
 * 
 * @export
 * @interface VerifyBody
 */
export interface VerifyBody {
    /**
     * 
     * @type {string}
     * @memberof VerifyBody
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VisibilityType = {
    Hidden: 'hidden',
    Default: 'default',
    First: 'first'
} as const;

export type VisibilityType = typeof VisibilityType[keyof typeof VisibilityType];


/**
 * 
 * @export
 * @enum {string}
 */

export const VolunteerActivityType = {
    ViewAnswer: 'viewAnswer',
    ViewContact: 'viewContact',
    GrantedLocationView: 'grantedLocationView',
    RevokedLocationView: 'revokedLocationView',
    Accept: 'accept',
    Reject: 'reject',
    Booster: 'booster',
    Contacted: 'contacted',
    ReachOutVerified: 'reachOutVerified',
    ReachOutMissingAnswers: 'reachOutMissingAnswers'
} as const;

export type VolunteerActivityType = typeof VolunteerActivityType[keyof typeof VolunteerActivityType];



/**
 * ActivityApi - axios parameter creator
 * @export
 */
export const ActivityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary delete an activity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteActivity', 'id', id)
            const localVarPath = `/activity/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityApi - functional programming interface
 * @export
 */
export const ActivityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary delete an activity
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivity(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityApi.deleteActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityApi - factory interface
 * @export
 */
export const ActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityApiFp(configuration)
    return {
        /**
         * 
         * @summary delete an activity
         * @param {ActivityApiDeleteActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity(requestParameters: ActivityApiDeleteActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActivity(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteActivity operation in ActivityApi.
 * @export
 * @interface ActivityApiDeleteActivityRequest
 */
export interface ActivityApiDeleteActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof ActivityApiDeleteActivity
     */
    readonly id: string
}

/**
 * ActivityApi - object-oriented interface
 * @export
 * @class ActivityApi
 * @extends {BaseAPI}
 */
export class ActivityApi extends BaseAPI {
    /**
     * 
     * @summary delete an activity
     * @param {ActivityApiDeleteActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityApi
     */
    public deleteActivity(requestParameters: ActivityApiDeleteActivityRequest, options?: RawAxiosRequestConfig) {
        return ActivityApiFp(this.configuration).deleteActivity(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AttributesApi - axios parameter creator
 * @export
 */
export const AttributesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get a list of all attributes of a user
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {AttributeFilter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes: async (language: Language, limit?: number | null, offset?: number | null, filter?: AttributeFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getAttributes', 'language', language)
            const localVarPath = `/attributes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary gets the completion percentage for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletionPercentage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/attributes/completion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttributesApi - functional programming interface
 * @export
 */
export const AttributesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttributesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get a list of all attributes of a user
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {AttributeFilter} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttributes(language: Language, limit?: number | null, offset?: number | null, filter?: AttributeFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAttributeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttributes(language, limit, offset, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributesApi.getAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary gets the completion percentage for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompletionPercentage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletionPercentageView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompletionPercentage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttributesApi.getCompletionPercentage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttributesApi - factory interface
 * @export
 */
export const AttributesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttributesApiFp(configuration)
    return {
        /**
         * 
         * @summary get a list of all attributes of a user
         * @param {AttributesApiGetAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttributes(requestParameters: AttributesApiGetAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListAttributeView> {
            return localVarFp.getAttributes(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.filter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary gets the completion percentage for a user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletionPercentage(options?: RawAxiosRequestConfig): AxiosPromise<CompletionPercentageView> {
            return localVarFp.getCompletionPercentage(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAttributes operation in AttributesApi.
 * @export
 * @interface AttributesApiGetAttributesRequest
 */
export interface AttributesApiGetAttributesRequest {
    /**
     * 
     * @type {Language}
     * @memberof AttributesApiGetAttributes
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof AttributesApiGetAttributes
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof AttributesApiGetAttributes
     */
    readonly offset?: number | null

    /**
     * 
     * @type {AttributeFilter}
     * @memberof AttributesApiGetAttributes
     */
    readonly filter?: AttributeFilter
}

/**
 * AttributesApi - object-oriented interface
 * @export
 * @class AttributesApi
 * @extends {BaseAPI}
 */
export class AttributesApi extends BaseAPI {
    /**
     * 
     * @summary get a list of all attributes of a user
     * @param {AttributesApiGetAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public getAttributes(requestParameters: AttributesApiGetAttributesRequest, options?: RawAxiosRequestConfig) {
        return AttributesApiFp(this.configuration).getAttributes(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary gets the completion percentage for a user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttributesApi
     */
    public getCompletionPercentage(options?: RawAxiosRequestConfig) {
        return AttributesApiFp(this.configuration).getCompletionPercentage(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Claim an anonymous account through a token
         * @param {string} token 
         * @param {AnonymousClaimBody} anonymousClaimBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousClaim: async (token: string, anonymousClaimBody: AnonymousClaimBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('anonymousClaim', 'token', token)
            // verify required parameter 'anonymousClaimBody' is not null or undefined
            assertParamExists('anonymousClaim', 'anonymousClaimBody', anonymousClaimBody)
            const localVarPath = `/auth/anon/claim/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anonymousClaimBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request the claiming of an anonymous account through email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousRequestClaim: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('anonymousRequestClaim', 'email', email)
            const localVarPath = `/auth/anon/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new anonymous patient user
         * @param {AnonymousSignUpBody} anonymousSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousSignUp: async (anonymousSignUpBody: AnonymousSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anonymousSignUpBody' is not null or undefined
            assertParamExists('anonymousSignUp', 'anonymousSignUpBody', anonymousSignUpBody)
            const localVarPath = `/auth/anon/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(anonymousSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login with Google
         * @param {GoogleLoginBody} googleLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin: async (googleLoginBody: GoogleLoginBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleLoginBody' is not null or undefined
            assertParamExists('googleLogin', 'googleLoginBody', googleLoginBody)
            const localVarPath = `/auth/google-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleLoginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user with Google
         * @param {GoogleSignUpBody} googleSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleSignUp: async (googleSignUpBody: GoogleSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'googleSignUpBody' is not null or undefined
            assertParamExists('googleSignUp', 'googleSignUpBody', googleSignUpBody)
            const localVarPath = `/auth/google-sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(googleSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login by username and password
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginBody: LoginBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginBody' is not null or undefined
            assertParamExists('login', 'loginBody', loginBody)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new patient user
         * @param {PatientSignUpBody} patientSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSignUp: async (patientSignUpBody: PatientSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientSignUpBody' is not null or undefined
            assertParamExists('patientSignUp', 'patientSignUpBody', patientSignUpBody)
            const localVarPath = `/auth/sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patientSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh the current id token
         * @param {RefreshBody} refreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (refreshBody: RefreshBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshBody' is not null or undefined
            assertParamExists('refresh', 'refreshBody', refreshBody)
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request a reset password code
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordBody: ResetPasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordBody' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordBody', resetPasswordBody)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set password after receiving a code
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: async (setPasswordBody: SetPasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setPasswordBody' is not null or undefined
            assertParamExists('setPassword', 'setPasswordBody', setPasswordBody)
            const localVarPath = `/auth/set-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new trial manager user
         * @param {TrialManagerSignUpBody} trialManagerSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialManagerSignUp: async (trialManagerSignUpBody: TrialManagerSignUpBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialManagerSignUpBody' is not null or undefined
            assertParamExists('trialManagerSignUp', 'trialManagerSignUpBody', trialManagerSignUpBody)
            const localVarPath = `/auth/trial-manager-sign-up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialManagerSignUpBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify a user email
         * @param {VerifyBody} verifyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify: async (verifyBody: VerifyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyBody' is not null or undefined
            assertParamExists('verify', 'verifyBody', verifyBody)
            const localVarPath = `/auth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Claim an anonymous account through a token
         * @param {string} token 
         * @param {AnonymousClaimBody} anonymousClaimBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousClaim(token: string, anonymousClaimBody: AnonymousClaimBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anonymousClaim(token, anonymousClaimBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.anonymousClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request the claiming of an anonymous account through email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousRequestClaim(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anonymousRequestClaim(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.anonymousRequestClaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new anonymous patient user
         * @param {AnonymousSignUpBody} anonymousSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async anonymousSignUp(anonymousSignUpBody: AnonymousSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnonymousLoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.anonymousSignUp(anonymousSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.anonymousSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login with Google
         * @param {GoogleLoginBody} googleLoginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleLogin(googleLoginBody: GoogleLoginBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleLogin(googleLoginBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.googleLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new user with Google
         * @param {GoogleSignUpBody} googleSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async googleSignUp(googleSignUpBody: GoogleSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.googleSignUp(googleSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.googleSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login by username and password
         * @param {LoginBody} loginBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginBody: LoginBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new patient user
         * @param {PatientSignUpBody} patientSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patientSignUp(patientSignUpBody: PatientSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patientSignUp(patientSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.patientSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh the current id token
         * @param {RefreshBody} refreshBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(refreshBody: RefreshBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(refreshBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request a reset password code
         * @param {ResetPasswordBody} resetPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordBody: ResetPasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set password after receiving a code
         * @param {SetPasswordBody} setPasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPassword(setPasswordBody: SetPasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPassword(setPasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.setPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new trial manager user
         * @param {TrialManagerSignUpBody} trialManagerSignUpBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async trialManagerSignUp(trialManagerSignUpBody: TrialManagerSignUpBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.trialManagerSignUp(trialManagerSignUpBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.trialManagerSignUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify a user email
         * @param {VerifyBody} verifyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verify(verifyBody: VerifyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verify(verifyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Claim an anonymous account through a token
         * @param {AuthApiAnonymousClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousClaim(requestParameters: AuthApiAnonymousClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.anonymousClaim(requestParameters.token, requestParameters.anonymousClaimBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request the claiming of an anonymous account through email
         * @param {AuthApiAnonymousRequestClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousRequestClaim(requestParameters: AuthApiAnonymousRequestClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.anonymousRequestClaim(requestParameters.email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new anonymous patient user
         * @param {AuthApiAnonymousSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        anonymousSignUp(requestParameters: AuthApiAnonymousSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<AnonymousLoginView> {
            return localVarFp.anonymousSignUp(requestParameters.anonymousSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login with Google
         * @param {AuthApiGoogleLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleLogin(requestParameters: AuthApiGoogleLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.googleLogin(requestParameters.googleLoginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user with Google
         * @param {AuthApiGoogleSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        googleSignUp(requestParameters: AuthApiGoogleSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.googleSignUp(requestParameters.googleSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login by username and password
         * @param {AuthApiLoginRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(requestParameters: AuthApiLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.login(requestParameters.loginBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new patient user
         * @param {AuthApiPatientSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patientSignUp(requestParameters: AuthApiPatientSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.patientSignUp(requestParameters.patientSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh the current id token
         * @param {AuthApiRefreshRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(requestParameters: AuthApiRefreshRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.refresh(requestParameters.refreshBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request a reset password code
         * @param {AuthApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(requestParameters: AuthApiResetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(requestParameters.resetPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set password after receiving a code
         * @param {AuthApiSetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(requestParameters: AuthApiSetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.setPassword(requestParameters.setPasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new trial manager user
         * @param {AuthApiTrialManagerSignUpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        trialManagerSignUp(requestParameters: AuthApiTrialManagerSignUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.trialManagerSignUp(requestParameters.trialManagerSignUpBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify a user email
         * @param {AuthApiVerifyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verify(requestParameters: AuthApiVerifyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.verify(requestParameters.verifyBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for anonymousClaim operation in AuthApi.
 * @export
 * @interface AuthApiAnonymousClaimRequest
 */
export interface AuthApiAnonymousClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiAnonymousClaim
     */
    readonly token: string

    /**
     * 
     * @type {AnonymousClaimBody}
     * @memberof AuthApiAnonymousClaim
     */
    readonly anonymousClaimBody: AnonymousClaimBody
}

/**
 * Request parameters for anonymousRequestClaim operation in AuthApi.
 * @export
 * @interface AuthApiAnonymousRequestClaimRequest
 */
export interface AuthApiAnonymousRequestClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthApiAnonymousRequestClaim
     */
    readonly email: string
}

/**
 * Request parameters for anonymousSignUp operation in AuthApi.
 * @export
 * @interface AuthApiAnonymousSignUpRequest
 */
export interface AuthApiAnonymousSignUpRequest {
    /**
     * 
     * @type {AnonymousSignUpBody}
     * @memberof AuthApiAnonymousSignUp
     */
    readonly anonymousSignUpBody: AnonymousSignUpBody
}

/**
 * Request parameters for googleLogin operation in AuthApi.
 * @export
 * @interface AuthApiGoogleLoginRequest
 */
export interface AuthApiGoogleLoginRequest {
    /**
     * 
     * @type {GoogleLoginBody}
     * @memberof AuthApiGoogleLogin
     */
    readonly googleLoginBody: GoogleLoginBody
}

/**
 * Request parameters for googleSignUp operation in AuthApi.
 * @export
 * @interface AuthApiGoogleSignUpRequest
 */
export interface AuthApiGoogleSignUpRequest {
    /**
     * 
     * @type {GoogleSignUpBody}
     * @memberof AuthApiGoogleSignUp
     */
    readonly googleSignUpBody: GoogleSignUpBody
}

/**
 * Request parameters for login operation in AuthApi.
 * @export
 * @interface AuthApiLoginRequest
 */
export interface AuthApiLoginRequest {
    /**
     * 
     * @type {LoginBody}
     * @memberof AuthApiLogin
     */
    readonly loginBody: LoginBody
}

/**
 * Request parameters for patientSignUp operation in AuthApi.
 * @export
 * @interface AuthApiPatientSignUpRequest
 */
export interface AuthApiPatientSignUpRequest {
    /**
     * 
     * @type {PatientSignUpBody}
     * @memberof AuthApiPatientSignUp
     */
    readonly patientSignUpBody: PatientSignUpBody
}

/**
 * Request parameters for refresh operation in AuthApi.
 * @export
 * @interface AuthApiRefreshRequest
 */
export interface AuthApiRefreshRequest {
    /**
     * 
     * @type {RefreshBody}
     * @memberof AuthApiRefresh
     */
    readonly refreshBody: RefreshBody
}

/**
 * Request parameters for resetPassword operation in AuthApi.
 * @export
 * @interface AuthApiResetPasswordRequest
 */
export interface AuthApiResetPasswordRequest {
    /**
     * 
     * @type {ResetPasswordBody}
     * @memberof AuthApiResetPassword
     */
    readonly resetPasswordBody: ResetPasswordBody
}

/**
 * Request parameters for setPassword operation in AuthApi.
 * @export
 * @interface AuthApiSetPasswordRequest
 */
export interface AuthApiSetPasswordRequest {
    /**
     * 
     * @type {SetPasswordBody}
     * @memberof AuthApiSetPassword
     */
    readonly setPasswordBody: SetPasswordBody
}

/**
 * Request parameters for trialManagerSignUp operation in AuthApi.
 * @export
 * @interface AuthApiTrialManagerSignUpRequest
 */
export interface AuthApiTrialManagerSignUpRequest {
    /**
     * 
     * @type {TrialManagerSignUpBody}
     * @memberof AuthApiTrialManagerSignUp
     */
    readonly trialManagerSignUpBody: TrialManagerSignUpBody
}

/**
 * Request parameters for verify operation in AuthApi.
 * @export
 * @interface AuthApiVerifyRequest
 */
export interface AuthApiVerifyRequest {
    /**
     * 
     * @type {VerifyBody}
     * @memberof AuthApiVerify
     */
    readonly verifyBody: VerifyBody
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Claim an anonymous account through a token
     * @param {AuthApiAnonymousClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public anonymousClaim(requestParameters: AuthApiAnonymousClaimRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).anonymousClaim(requestParameters.token, requestParameters.anonymousClaimBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request the claiming of an anonymous account through email
     * @param {AuthApiAnonymousRequestClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public anonymousRequestClaim(requestParameters: AuthApiAnonymousRequestClaimRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).anonymousRequestClaim(requestParameters.email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new anonymous patient user
     * @param {AuthApiAnonymousSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public anonymousSignUp(requestParameters: AuthApiAnonymousSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).anonymousSignUp(requestParameters.anonymousSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login with Google
     * @param {AuthApiGoogleLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleLogin(requestParameters: AuthApiGoogleLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleLogin(requestParameters.googleLoginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user with Google
     * @param {AuthApiGoogleSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public googleSignUp(requestParameters: AuthApiGoogleSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).googleSignUp(requestParameters.googleSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login by username and password
     * @param {AuthApiLoginRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(requestParameters: AuthApiLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(requestParameters.loginBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new patient user
     * @param {AuthApiPatientSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public patientSignUp(requestParameters: AuthApiPatientSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).patientSignUp(requestParameters.patientSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh the current id token
     * @param {AuthApiRefreshRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public refresh(requestParameters: AuthApiRefreshRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).refresh(requestParameters.refreshBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request a reset password code
     * @param {AuthApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public resetPassword(requestParameters: AuthApiResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).resetPassword(requestParameters.resetPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set password after receiving a code
     * @param {AuthApiSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public setPassword(requestParameters: AuthApiSetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).setPassword(requestParameters.setPasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new trial manager user
     * @param {AuthApiTrialManagerSignUpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public trialManagerSignUp(requestParameters: AuthApiTrialManagerSignUpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).trialManagerSignUp(requestParameters.trialManagerSignUpBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify a user email
     * @param {AuthApiVerifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public verify(requestParameters: AuthApiVerifyRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verify(requestParameters.verifyBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CategoryApi - axios parameter creator
 * @export
 */
export const CategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a disease to a category on the platform
         * @param {string} id 
         * @param {AddCategoryDiseaseBody} addCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCategoryDisease: async (id: string, addCategoryDiseaseBody: AddCategoryDiseaseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addCategoryDisease', 'id', id)
            // verify required parameter 'addCategoryDiseaseBody' is not null or undefined
            assertParamExists('addCategoryDisease', 'addCategoryDiseaseBody', addCategoryDiseaseBody)
            const localVarPath = `/category/{id}/diseases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCategoryDiseaseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a category on the platform
         * @param {CategoryCreateBody} categoryCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory: async (categoryCreateBody: CategoryCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryCreateBody' is not null or undefined
            assertParamExists('createCategory', 'categoryCreateBody', categoryCreateBody)
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCategory', 'id', id)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all categories on the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {string} [parentCategoryId] 
         * @param {GetCategoriesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (limit?: number | null, offset?: number | null, searchString?: string, parentCategoryId?: string, type?: GetCategoriesTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (parentCategoryId !== undefined) {
                localVarQueryParameter['parentCategoryId'] = parentCategoryId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all translations of a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryContextTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryContextTranslations', 'id', id)
            const localVarPath = `/category/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all diseases associated to a category on the platform
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryDiseases: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryDiseases', 'id', id)
            const localVarPath = `/category/{id}/diseases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all questions associated to a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryQuestions: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCategoryQuestions', 'id', id)
            const localVarPath = `/category/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the full tree of all categories of a certain type in the platform
         * @param {GetNestedCategoriesTypeEnum} type 
         * @param {boolean | null} [forceRecalculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNestedCategories: async (type: GetNestedCategoriesTypeEnum, forceRecalculate?: boolean | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getNestedCategories', 'type', type)
            const localVarPath = `/category/nested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (forceRecalculate !== undefined) {
                localVarQueryParameter['forceRecalculate'] = forceRecalculate;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary remove a disease from a category on the platform
         * @param {string} id 
         * @param {RemoveCategoryDiseaseBody} removeCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCategoryDisease: async (id: string, removeCategoryDiseaseBody: RemoveCategoryDiseaseBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCategoryDisease', 'id', id)
            // verify required parameter 'removeCategoryDiseaseBody' is not null or undefined
            assertParamExists('removeCategoryDisease', 'removeCategoryDiseaseBody', removeCategoryDiseaseBody)
            const localVarPath = `/category/{id}/diseases`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeCategoryDiseaseBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a category on the platform
         * @param {string} id 
         * @param {CategoryUpdateBody} categoryUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory: async (id: string, categoryUpdateBody: CategoryUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCategory', 'id', id)
            // verify required parameter 'categoryUpdateBody' is not null or undefined
            assertParamExists('updateCategory', 'categoryUpdateBody', categoryUpdateBody)
            const localVarPath = `/category/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the translations of a category on the platform
         * @param {string} id 
         * @param {CategoryContextTranslationsBody} categoryContextTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCategoryContextTranslations: async (id: string, categoryContextTranslationsBody: CategoryContextTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertCategoryContextTranslations', 'id', id)
            // verify required parameter 'categoryContextTranslationsBody' is not null or undefined
            assertParamExists('upsertCategoryContextTranslations', 'categoryContextTranslationsBody', categoryContextTranslationsBody)
            const localVarPath = `/category/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(categoryContextTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoryApi - functional programming interface
 * @export
 */
export const CategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add a disease to a category on the platform
         * @param {string} id 
         * @param {AddCategoryDiseaseBody} addCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCategoryDisease(id: string, addCategoryDiseaseBody: AddCategoryDiseaseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCategoryDisease(id, addCategoryDiseaseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.addCategoryDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a category on the platform
         * @param {CategoryCreateBody} categoryCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCategory(categoryCreateBody: CategoryCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(categoryCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.createCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCategory(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.deleteCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all categories on the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {string} [parentCategoryId] 
         * @param {GetCategoriesTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(limit?: number | null, offset?: number | null, searchString?: string, parentCategoryId?: string, type?: GetCategoriesTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategorySearchView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(limit, offset, searchString, parentCategoryId, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all translations of a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryContextTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryContextTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryContextTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategoryContextTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all diseases associated to a category on the platform
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryDiseases(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryDiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryDiseases(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategoryDiseases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all questions associated to a category on the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryQuestions(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryQuestions(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getCategoryQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the full tree of all categories of a certain type in the platform
         * @param {GetNestedCategoriesTypeEnum} type 
         * @param {boolean | null} [forceRecalculate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNestedCategories(type: GetNestedCategoriesTypeEnum, forceRecalculate?: boolean | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryTreeView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNestedCategories(type, forceRecalculate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.getNestedCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary remove a disease from a category on the platform
         * @param {string} id 
         * @param {RemoveCategoryDiseaseBody} removeCategoryDiseaseBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCategoryDisease(id: string, removeCategoryDiseaseBody: RemoveCategoryDiseaseBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCategoryDisease(id, removeCategoryDiseaseBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.removeCategoryDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a category on the platform
         * @param {string} id 
         * @param {CategoryUpdateBody} categoryUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCategory(id: string, categoryUpdateBody: CategoryUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(id, categoryUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.updateCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the translations of a category on the platform
         * @param {string} id 
         * @param {CategoryContextTranslationsBody} categoryContextTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertCategoryContextTranslations(id: string, categoryContextTranslationsBody: CategoryContextTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCategoryContextTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertCategoryContextTranslations(id, categoryContextTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CategoryApi.upsertCategoryContextTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CategoryApi - factory interface
 * @export
 */
export const CategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoryApiFp(configuration)
    return {
        /**
         * 
         * @summary add a disease to a category on the platform
         * @param {CategoryApiAddCategoryDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCategoryDisease(requestParameters: CategoryApiAddCategoryDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCategoryDisease(requestParameters.id, requestParameters.addCategoryDiseaseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a category on the platform
         * @param {CategoryApiCreateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCategory(requestParameters: CategoryApiCreateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDetailsView> {
            return localVarFp.createCategory(requestParameters.categoryCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a category on the platform
         * @param {CategoryApiDeleteCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCategory(requestParameters: CategoryApiDeleteCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCategory(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all categories on the platform
         * @param {CategoryApiGetCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(requestParameters: CategoryApiGetCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListCategorySearchView> {
            return localVarFp.getCategories(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.parentCategoryId, requestParameters.type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all translations of a category on the platform
         * @param {CategoryApiGetCategoryContextTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryContextTranslations(requestParameters: CategoryApiGetCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryContextTranslationView> {
            return localVarFp.getCategoryContextTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all diseases associated to a category on the platform
         * @param {CategoryApiGetCategoryDiseasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryDiseases(requestParameters: CategoryApiGetCategoryDiseasesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryDiseaseView> {
            return localVarFp.getCategoryDiseases(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all questions associated to a category on the platform
         * @param {CategoryApiGetCategoryQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryQuestions(requestParameters: CategoryApiGetCategoryQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryQuestionView> {
            return localVarFp.getCategoryQuestions(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the full tree of all categories of a certain type in the platform
         * @param {CategoryApiGetNestedCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNestedCategories(requestParameters: CategoryApiGetNestedCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryTreeView> {
            return localVarFp.getNestedCategories(requestParameters.type, requestParameters.forceRecalculate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary remove a disease from a category on the platform
         * @param {CategoryApiRemoveCategoryDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCategoryDisease(requestParameters: CategoryApiRemoveCategoryDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeCategoryDisease(requestParameters.id, requestParameters.removeCategoryDiseaseBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a category on the platform
         * @param {CategoryApiUpdateCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategory(requestParameters: CategoryApiUpdateCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CategoryDetailsView> {
            return localVarFp.updateCategory(requestParameters.id, requestParameters.categoryUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the translations of a category on the platform
         * @param {CategoryApiUpsertCategoryContextTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertCategoryContextTranslations(requestParameters: CategoryApiUpsertCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCategoryContextTranslationView> {
            return localVarFp.upsertCategoryContextTranslations(requestParameters.id, requestParameters.categoryContextTranslationsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCategoryDisease operation in CategoryApi.
 * @export
 * @interface CategoryApiAddCategoryDiseaseRequest
 */
export interface CategoryApiAddCategoryDiseaseRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiAddCategoryDisease
     */
    readonly id: string

    /**
     * 
     * @type {AddCategoryDiseaseBody}
     * @memberof CategoryApiAddCategoryDisease
     */
    readonly addCategoryDiseaseBody: AddCategoryDiseaseBody
}

/**
 * Request parameters for createCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiCreateCategoryRequest
 */
export interface CategoryApiCreateCategoryRequest {
    /**
     * 
     * @type {CategoryCreateBody}
     * @memberof CategoryApiCreateCategory
     */
    readonly categoryCreateBody: CategoryCreateBody
}

/**
 * Request parameters for deleteCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiDeleteCategoryRequest
 */
export interface CategoryApiDeleteCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiDeleteCategory
     */
    readonly id: string
}

/**
 * Request parameters for getCategories operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoriesRequest
 */
export interface CategoryApiGetCategoriesRequest {
    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategories
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategories
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategories
     */
    readonly searchString?: string

    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategories
     */
    readonly parentCategoryId?: string

    /**
     * 
     * @type {'starter' | 'icdCode' | 'tag' | 'mergedQuestion'}
     * @memberof CategoryApiGetCategories
     */
    readonly type?: GetCategoriesTypeEnum
}

/**
 * Request parameters for getCategoryContextTranslations operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoryContextTranslationsRequest
 */
export interface CategoryApiGetCategoryContextTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategoryContextTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getCategoryDiseases operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoryDiseasesRequest
 */
export interface CategoryApiGetCategoryDiseasesRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategoryDiseases
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategoryDiseases
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CategoryApiGetCategoryDiseases
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getCategoryQuestions operation in CategoryApi.
 * @export
 * @interface CategoryApiGetCategoryQuestionsRequest
 */
export interface CategoryApiGetCategoryQuestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiGetCategoryQuestions
     */
    readonly id: string
}

/**
 * Request parameters for getNestedCategories operation in CategoryApi.
 * @export
 * @interface CategoryApiGetNestedCategoriesRequest
 */
export interface CategoryApiGetNestedCategoriesRequest {
    /**
     * 
     * @type {'starter' | 'icdCode' | 'tag' | 'mergedQuestion'}
     * @memberof CategoryApiGetNestedCategories
     */
    readonly type: GetNestedCategoriesTypeEnum

    /**
     * 
     * @type {boolean}
     * @memberof CategoryApiGetNestedCategories
     */
    readonly forceRecalculate?: boolean | null
}

/**
 * Request parameters for removeCategoryDisease operation in CategoryApi.
 * @export
 * @interface CategoryApiRemoveCategoryDiseaseRequest
 */
export interface CategoryApiRemoveCategoryDiseaseRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiRemoveCategoryDisease
     */
    readonly id: string

    /**
     * 
     * @type {RemoveCategoryDiseaseBody}
     * @memberof CategoryApiRemoveCategoryDisease
     */
    readonly removeCategoryDiseaseBody: RemoveCategoryDiseaseBody
}

/**
 * Request parameters for updateCategory operation in CategoryApi.
 * @export
 * @interface CategoryApiUpdateCategoryRequest
 */
export interface CategoryApiUpdateCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiUpdateCategory
     */
    readonly id: string

    /**
     * 
     * @type {CategoryUpdateBody}
     * @memberof CategoryApiUpdateCategory
     */
    readonly categoryUpdateBody: CategoryUpdateBody
}

/**
 * Request parameters for upsertCategoryContextTranslations operation in CategoryApi.
 * @export
 * @interface CategoryApiUpsertCategoryContextTranslationsRequest
 */
export interface CategoryApiUpsertCategoryContextTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof CategoryApiUpsertCategoryContextTranslations
     */
    readonly id: string

    /**
     * 
     * @type {CategoryContextTranslationsBody}
     * @memberof CategoryApiUpsertCategoryContextTranslations
     */
    readonly categoryContextTranslationsBody: CategoryContextTranslationsBody
}

/**
 * CategoryApi - object-oriented interface
 * @export
 * @class CategoryApi
 * @extends {BaseAPI}
 */
export class CategoryApi extends BaseAPI {
    /**
     * 
     * @summary add a disease to a category on the platform
     * @param {CategoryApiAddCategoryDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public addCategoryDisease(requestParameters: CategoryApiAddCategoryDiseaseRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).addCategoryDisease(requestParameters.id, requestParameters.addCategoryDiseaseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a category on the platform
     * @param {CategoryApiCreateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public createCategory(requestParameters: CategoryApiCreateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).createCategory(requestParameters.categoryCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a category on the platform
     * @param {CategoryApiDeleteCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public deleteCategory(requestParameters: CategoryApiDeleteCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).deleteCategory(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all categories on the platform
     * @param {CategoryApiGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategories(requestParameters: CategoryApiGetCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategories(requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.parentCategoryId, requestParameters.type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all translations of a category on the platform
     * @param {CategoryApiGetCategoryContextTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryContextTranslations(requestParameters: CategoryApiGetCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryContextTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all diseases associated to a category on the platform
     * @param {CategoryApiGetCategoryDiseasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryDiseases(requestParameters: CategoryApiGetCategoryDiseasesRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryDiseases(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all questions associated to a category on the platform
     * @param {CategoryApiGetCategoryQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getCategoryQuestions(requestParameters: CategoryApiGetCategoryQuestionsRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getCategoryQuestions(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the full tree of all categories of a certain type in the platform
     * @param {CategoryApiGetNestedCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public getNestedCategories(requestParameters: CategoryApiGetNestedCategoriesRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).getNestedCategories(requestParameters.type, requestParameters.forceRecalculate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary remove a disease from a category on the platform
     * @param {CategoryApiRemoveCategoryDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public removeCategoryDisease(requestParameters: CategoryApiRemoveCategoryDiseaseRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).removeCategoryDisease(requestParameters.id, requestParameters.removeCategoryDiseaseBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a category on the platform
     * @param {CategoryApiUpdateCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public updateCategory(requestParameters: CategoryApiUpdateCategoryRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).updateCategory(requestParameters.id, requestParameters.categoryUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the translations of a category on the platform
     * @param {CategoryApiUpsertCategoryContextTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoryApi
     */
    public upsertCategoryContextTranslations(requestParameters: CategoryApiUpsertCategoryContextTranslationsRequest, options?: RawAxiosRequestConfig) {
        return CategoryApiFp(this.configuration).upsertCategoryContextTranslations(requestParameters.id, requestParameters.categoryContextTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCategoriesTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;
export type GetCategoriesTypeEnum = typeof GetCategoriesTypeEnum[keyof typeof GetCategoriesTypeEnum];
/**
 * @export
 */
export const GetNestedCategoriesTypeEnum = {
    Starter: 'starter',
    IcdCode: 'icdCode',
    Tag: 'tag',
    MergedQuestion: 'mergedQuestion'
} as const;
export type GetNestedCategoriesTypeEnum = typeof GetNestedCategoriesTypeEnum[keyof typeof GetNestedCategoriesTypeEnum];


/**
 * ChatEntriesApi - axios parameter creator
 * @export
 */
export const ChatEntriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {string} id 
         * @param {AnswerChatBody} answerChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerChatEntry: async (id: string, answerChatBody: AnswerChatBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('answerChatEntry', 'id', id)
            // verify required parameter 'answerChatBody' is not null or undefined
            assertParamExists('answerChatEntry', 'answerChatBody', answerChatBody)
            const localVarPath = `/chats/entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerChatBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueChat: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chats/entries/continue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all chatEntries from a user
         * @param {HistoryType} history 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatEntries: async (history: HistoryType, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'history' is not null or undefined
            assertParamExists('getChatEntries', 'history', history)
            const localVarPath = `/chats/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (history !== undefined) {
                localVarQueryParameter['history'] = history;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete to skip a question (chatEntry)
         * @param {string} id 
         * @param {SkipChatEntryBody} skipChatEntryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipChatEntry: async (id: string, skipChatEntryBody: SkipChatEntryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skipChatEntry', 'id', id)
            // verify required parameter 'skipChatEntryBody' is not null or undefined
            assertParamExists('skipChatEntry', 'skipChatEntryBody', skipChatEntryBody)
            const localVarPath = `/chats/entries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skipChatEntryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatEntriesApi - functional programming interface
 * @export
 */
export const ChatEntriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatEntriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {string} id 
         * @param {AnswerChatBody} answerChatBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerChatEntry(id: string, answerChatBody: AnswerChatBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerChatEntry(id, answerChatBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.answerChatEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async continueChat(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.continueChat(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.continueChat']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all chatEntries from a user
         * @param {HistoryType} history 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChatEntries(history: HistoryType, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListChatEntryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChatEntries(history, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.getChatEntries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete to skip a question (chatEntry)
         * @param {string} id 
         * @param {SkipChatEntryBody} skipChatEntryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipChatEntry(id: string, skipChatEntryBody: SkipChatEntryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipChatEntry(id, skipChatEntryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatEntriesApi.skipChatEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatEntriesApi - factory interface
 * @export
 */
export const ChatEntriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatEntriesApiFp(configuration)
    return {
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {ChatEntriesApiAnswerChatEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerChatEntry(requestParameters: ChatEntriesApiAnswerChatEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerChatEntry(requestParameters.id, requestParameters.answerChatBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary process an answer to a question (chatEntry)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        continueChat(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.continueChat(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all chatEntries from a user
         * @param {ChatEntriesApiGetChatEntriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChatEntries(requestParameters: ChatEntriesApiGetChatEntriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListChatEntryView> {
            return localVarFp.getChatEntries(requestParameters.history, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete to skip a question (chatEntry)
         * @param {ChatEntriesApiSkipChatEntryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipChatEntry(requestParameters: ChatEntriesApiSkipChatEntryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.skipChatEntry(requestParameters.id, requestParameters.skipChatEntryBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for answerChatEntry operation in ChatEntriesApi.
 * @export
 * @interface ChatEntriesApiAnswerChatEntryRequest
 */
export interface ChatEntriesApiAnswerChatEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatEntriesApiAnswerChatEntry
     */
    readonly id: string

    /**
     * 
     * @type {AnswerChatBody}
     * @memberof ChatEntriesApiAnswerChatEntry
     */
    readonly answerChatBody: AnswerChatBody
}

/**
 * Request parameters for getChatEntries operation in ChatEntriesApi.
 * @export
 * @interface ChatEntriesApiGetChatEntriesRequest
 */
export interface ChatEntriesApiGetChatEntriesRequest {
    /**
     * 
     * @type {HistoryType}
     * @memberof ChatEntriesApiGetChatEntries
     */
    readonly history: HistoryType

    /**
     * 
     * @type {number}
     * @memberof ChatEntriesApiGetChatEntries
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof ChatEntriesApiGetChatEntries
     */
    readonly offset?: number | null
}

/**
 * Request parameters for skipChatEntry operation in ChatEntriesApi.
 * @export
 * @interface ChatEntriesApiSkipChatEntryRequest
 */
export interface ChatEntriesApiSkipChatEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatEntriesApiSkipChatEntry
     */
    readonly id: string

    /**
     * 
     * @type {SkipChatEntryBody}
     * @memberof ChatEntriesApiSkipChatEntry
     */
    readonly skipChatEntryBody: SkipChatEntryBody
}

/**
 * ChatEntriesApi - object-oriented interface
 * @export
 * @class ChatEntriesApi
 * @extends {BaseAPI}
 */
export class ChatEntriesApi extends BaseAPI {
    /**
     * 
     * @summary process an answer to a question (chatEntry)
     * @param {ChatEntriesApiAnswerChatEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public answerChatEntry(requestParameters: ChatEntriesApiAnswerChatEntryRequest, options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).answerChatEntry(requestParameters.id, requestParameters.answerChatBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary process an answer to a question (chatEntry)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public continueChat(options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).continueChat(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all chatEntries from a user
     * @param {ChatEntriesApiGetChatEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public getChatEntries(requestParameters: ChatEntriesApiGetChatEntriesRequest, options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).getChatEntries(requestParameters.history, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete to skip a question (chatEntry)
     * @param {ChatEntriesApiSkipChatEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatEntriesApi
     */
    public skipChatEntry(requestParameters: ChatEntriesApiSkipChatEntryRequest, options?: RawAxiosRequestConfig) {
        return ChatEntriesApiFp(this.configuration).skipChatEntry(requestParameters.id, requestParameters.skipChatEntryBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConfigurationApi - axios parameter creator
 * @export
 */
export const ConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the configuration details of the application state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the question configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations/question-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the tag configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/configurations/tag-configuration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigurationApi - functional programming interface
 * @export
 */
export const ConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the configuration details of the application state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConfigurationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigurationApi.getConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the question configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionConfigurationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigurationApi.getQuestionConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the tag configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TagConfigurationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigurationApi.getTagConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigurationApi - factory interface
 * @export
 */
export const ConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigurationApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the configuration details of the application state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<ConfigurationView> {
            return localVarFp.getConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the question configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<QuestionConfigurationView> {
            return localVarFp.getQuestionConfiguration(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the tag configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<TagConfigurationView> {
            return localVarFp.getTagConfiguration(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigurationApi - object-oriented interface
 * @export
 * @class ConfigurationApi
 * @extends {BaseAPI}
 */
export class ConfigurationApi extends BaseAPI {
    /**
     * 
     * @summary Get the configuration details of the application state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getConfiguration(options?: RawAxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).getConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the question configuration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getQuestionConfiguration(options?: RawAxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).getQuestionConfiguration(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the tag configuration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigurationApi
     */
    public getTagConfiguration(options?: RawAxiosRequestConfig) {
        return ConfigurationApiFp(this.configuration).getTagConfiguration(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a contact
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteContact', 'id', id)
            const localVarPath = `/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing contact
         * @param {string} id 
         * @param {ContactUpdateBody} contactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (id: string, contactUpdateBody: ContactUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateContact', 'id', id)
            // verify required parameter 'contactUpdateBody' is not null or undefined
            assertParamExists('updateContact', 'contactUpdateBody', contactUpdateBody)
            const localVarPath = `/contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a contact
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.deleteContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing contact
         * @param {string} id 
         * @param {ContactUpdateBody} contactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(id: string, contactUpdateBody: ContactUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(id, contactUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a contact
         * @param {ContactApiDeleteContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(requestParameters: ContactApiDeleteContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContact(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing contact
         * @param {ContactApiUpdateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(requestParameters: ContactApiUpdateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContact(requestParameters.id, requestParameters.contactUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteContact operation in ContactApi.
 * @export
 * @interface ContactApiDeleteContactRequest
 */
export interface ContactApiDeleteContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiDeleteContact
     */
    readonly id: string
}

/**
 * Request parameters for updateContact operation in ContactApi.
 * @export
 * @interface ContactApiUpdateContactRequest
 */
export interface ContactApiUpdateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactApiUpdateContact
     */
    readonly id: string

    /**
     * 
     * @type {ContactUpdateBody}
     * @memberof ContactApiUpdateContact
     */
    readonly contactUpdateBody: ContactUpdateBody
}

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * 
     * @summary Delete a contact
     * @param {ContactApiDeleteContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public deleteContact(requestParameters: ContactApiDeleteContactRequest, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).deleteContact(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing contact
     * @param {ContactApiUpdateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public updateContact(requestParameters: ContactApiUpdateContactRequest, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).updateContact(requestParameters.id, requestParameters.contactUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CriteriaApi - axios parameter creator
 * @export
 */
export const CriteriaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add a comment to a criteria
         * @param {string} id 
         * @param {CriteriaCommentBody} criteriaCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment: async (id: string, criteriaCommentBody: CriteriaCommentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createComment', 'id', id)
            // verify required parameter 'criteriaCommentBody' is not null or undefined
            assertParamExists('createComment', 'criteriaCommentBody', criteriaCommentBody)
            const localVarPath = `/criteria/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaCommentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a feedback to a criteria
         * @param {string} id 
         * @param {CriteriaFeedbackBody} criteriaFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback: async (id: string, criteriaFeedbackBody: CriteriaFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createFeedback', 'id', id)
            // verify required parameter 'criteriaFeedbackBody' is not null or undefined
            assertParamExists('createFeedback', 'criteriaFeedbackBody', criteriaFeedbackBody)
            const localVarPath = `/criteria/{id}/feedback`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary soft delete a criteria, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCriteria: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCriteria', 'id', id)
            const localVarPath = `/criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActivity', 'id', id)
            const localVarPath = `/criteria/{id}/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change the position of a criteria
         * @param {string} id 
         * @param {CriteriaMoveBody} criteriaMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCriteria: async (id: string, criteriaMoveBody: CriteriaMoveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveCriteria', 'id', id)
            // verify required parameter 'criteriaMoveBody' is not null or undefined
            assertParamExists('moveCriteria', 'criteriaMoveBody', criteriaMoveBody)
            const localVarPath = `/criteria/{id}/move`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaMoveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary restore a deleted criteria
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCriteria: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreCriteria', 'id', id)
            const localVarPath = `/criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change any of the properties of a criteria
         * @param {string} id 
         * @param {CriteriaUpdateBody} criteriaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteria: async (id: string, criteriaUpdateBody: CriteriaUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCriteria', 'id', id)
            // verify required parameter 'criteriaUpdateBody' is not null or undefined
            assertParamExists('updateCriteria', 'criteriaUpdateBody', criteriaUpdateBody)
            const localVarPath = `/criteria/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CriteriaApi - functional programming interface
 * @export
 */
export const CriteriaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CriteriaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add a comment to a criteria
         * @param {string} id 
         * @param {CriteriaCommentBody} criteriaCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComment(id: string, criteriaCommentBody: CriteriaCommentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComment(id, criteriaCommentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.createComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a feedback to a criteria
         * @param {string} id 
         * @param {CriteriaFeedbackBody} criteriaFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFeedback(id: string, criteriaFeedbackBody: CriteriaFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFeedback(id, criteriaFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.createFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary soft delete a criteria, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCriteria(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCriteria(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.deleteCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListCriteriaActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.getActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change the position of a criteria
         * @param {string} id 
         * @param {CriteriaMoveBody} criteriaMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveCriteria(id: string, criteriaMoveBody: CriteriaMoveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveCriteria(id, criteriaMoveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.moveCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary restore a deleted criteria
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreCriteria(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreCriteria(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.restoreCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change any of the properties of a criteria
         * @param {string} id 
         * @param {CriteriaUpdateBody} criteriaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCriteria(id: string, criteriaUpdateBody: CriteriaUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCriteria(id, criteriaUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CriteriaApi.updateCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CriteriaApi - factory interface
 * @export
 */
export const CriteriaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CriteriaApiFp(configuration)
    return {
        /**
         * 
         * @summary add a comment to a criteria
         * @param {CriteriaApiCreateCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(requestParameters: CriteriaApiCreateCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createComment(requestParameters.id, requestParameters.criteriaCommentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a feedback to a criteria
         * @param {CriteriaApiCreateFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFeedback(requestParameters: CriteriaApiCreateFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createFeedback(requestParameters.id, requestParameters.criteriaFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary soft delete a criteria, it will be restorable for 30 days
         * @param {CriteriaApiDeleteCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCriteria(requestParameters: CriteriaApiDeleteCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCriteria(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {CriteriaApiGetActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(requestParameters: CriteriaApiGetActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListCriteriaActivityView> {
            return localVarFp.getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change the position of a criteria
         * @param {CriteriaApiMoveCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveCriteria(requestParameters: CriteriaApiMoveCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveCriteria(requestParameters.id, requestParameters.criteriaMoveBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary restore a deleted criteria
         * @param {CriteriaApiRestoreCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreCriteria(requestParameters: CriteriaApiRestoreCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreCriteria(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change any of the properties of a criteria
         * @param {CriteriaApiUpdateCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteria(requestParameters: CriteriaApiUpdateCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateCriteria(requestParameters.id, requestParameters.criteriaUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createComment operation in CriteriaApi.
 * @export
 * @interface CriteriaApiCreateCommentRequest
 */
export interface CriteriaApiCreateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiCreateComment
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaCommentBody}
     * @memberof CriteriaApiCreateComment
     */
    readonly criteriaCommentBody: CriteriaCommentBody
}

/**
 * Request parameters for createFeedback operation in CriteriaApi.
 * @export
 * @interface CriteriaApiCreateFeedbackRequest
 */
export interface CriteriaApiCreateFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiCreateFeedback
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaFeedbackBody}
     * @memberof CriteriaApiCreateFeedback
     */
    readonly criteriaFeedbackBody: CriteriaFeedbackBody
}

/**
 * Request parameters for deleteCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiDeleteCriteriaRequest
 */
export interface CriteriaApiDeleteCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiDeleteCriteria
     */
    readonly id: string
}

/**
 * Request parameters for getActivity operation in CriteriaApi.
 * @export
 * @interface CriteriaApiGetActivityRequest
 */
export interface CriteriaApiGetActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiGetActivity
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof CriteriaApiGetActivity
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof CriteriaApiGetActivity
     */
    readonly offset?: number | null
}

/**
 * Request parameters for moveCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiMoveCriteriaRequest
 */
export interface CriteriaApiMoveCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiMoveCriteria
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaMoveBody}
     * @memberof CriteriaApiMoveCriteria
     */
    readonly criteriaMoveBody: CriteriaMoveBody
}

/**
 * Request parameters for restoreCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiRestoreCriteriaRequest
 */
export interface CriteriaApiRestoreCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiRestoreCriteria
     */
    readonly id: string
}

/**
 * Request parameters for updateCriteria operation in CriteriaApi.
 * @export
 * @interface CriteriaApiUpdateCriteriaRequest
 */
export interface CriteriaApiUpdateCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaApiUpdateCriteria
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaUpdateBody}
     * @memberof CriteriaApiUpdateCriteria
     */
    readonly criteriaUpdateBody: CriteriaUpdateBody
}

/**
 * CriteriaApi - object-oriented interface
 * @export
 * @class CriteriaApi
 * @extends {BaseAPI}
 */
export class CriteriaApi extends BaseAPI {
    /**
     * 
     * @summary add a comment to a criteria
     * @param {CriteriaApiCreateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public createComment(requestParameters: CriteriaApiCreateCommentRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).createComment(requestParameters.id, requestParameters.criteriaCommentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a feedback to a criteria
     * @param {CriteriaApiCreateFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public createFeedback(requestParameters: CriteriaApiCreateFeedbackRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).createFeedback(requestParameters.id, requestParameters.criteriaFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary soft delete a criteria, it will be restorable for 30 days
     * @param {CriteriaApiDeleteCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public deleteCriteria(requestParameters: CriteriaApiDeleteCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).deleteCriteria(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch paginated activity log of a criteria
     * @param {CriteriaApiGetActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public getActivity(requestParameters: CriteriaApiGetActivityRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change the position of a criteria
     * @param {CriteriaApiMoveCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public moveCriteria(requestParameters: CriteriaApiMoveCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).moveCriteria(requestParameters.id, requestParameters.criteriaMoveBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary restore a deleted criteria
     * @param {CriteriaApiRestoreCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public restoreCriteria(requestParameters: CriteriaApiRestoreCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).restoreCriteria(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change any of the properties of a criteria
     * @param {CriteriaApiUpdateCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CriteriaApi
     */
    public updateCriteria(requestParameters: CriteriaApiUpdateCriteriaRequest, options?: RawAxiosRequestConfig) {
        return CriteriaApiFp(this.configuration).updateCriteria(requestParameters.id, requestParameters.criteriaUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DelayIndexApi - axios parameter creator
 * @export
 */
export const DelayIndexApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get the clinical trial delay index for a specific month
         * @param {number} month 
         * @param {number} year 
         * @param {Array<string>} [countriesFilter] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndex: async (month: number, year: number, countriesFilter?: Array<string>, icdCategoryFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getDelayIndex', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getDelayIndex', 'year', year)
            const localVarPath = `/delay-index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (countriesFilter) {
                localVarQueryParameter['countriesFilter'] = countriesFilter;
            }

            if (icdCategoryFilter !== undefined) {
                localVarQueryParameter['icdCategoryFilter'] = icdCategoryFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per country
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerCountry: async (month: number, year: number, limit?: number | null, offset?: number | null, icdCategoryFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getDelayIndexPerCountry', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getDelayIndexPerCountry', 'year', year)
            const localVarPath = `/delay-index/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (icdCategoryFilter !== undefined) {
                localVarQueryParameter['icdCategoryFilter'] = icdCategoryFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per disease
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {Array<string>} [countriesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerDisease: async (month: number, year: number, limit?: number | null, offset?: number | null, countriesFilter?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'month' is not null or undefined
            assertParamExists('getDelayIndexPerDisease', 'month', month)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getDelayIndexPerDisease', 'year', year)
            const localVarPath = `/delay-index/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (countriesFilter) {
                localVarQueryParameter['countriesFilter'] = countriesFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DelayIndexApi - functional programming interface
 * @export
 */
export const DelayIndexApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DelayIndexApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get the clinical trial delay index for a specific month
         * @param {number} month 
         * @param {number} year 
         * @param {Array<string>} [countriesFilter] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelayIndex(month: number, year: number, countriesFilter?: Array<string>, icdCategoryFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelayIndexView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelayIndex(month, year, countriesFilter, icdCategoryFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DelayIndexApi.getDelayIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per country
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [icdCategoryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelayIndexPerCountry(month: number, year: number, limit?: number | null, offset?: number | null, icdCategoryFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLabeledDelayItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelayIndexPerCountry(month, year, limit, offset, icdCategoryFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DelayIndexApi.getDelayIndexPerCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per disease
         * @param {number} month 
         * @param {number} year 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {Array<string>} [countriesFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDelayIndexPerDisease(month: number, year: number, limit?: number | null, offset?: number | null, countriesFilter?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLabeledDelayItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDelayIndexPerDisease(month, year, limit, offset, countriesFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DelayIndexApi.getDelayIndexPerDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DelayIndexApi - factory interface
 * @export
 */
export const DelayIndexApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DelayIndexApiFp(configuration)
    return {
        /**
         * 
         * @summary get the clinical trial delay index for a specific month
         * @param {DelayIndexApiGetDelayIndexRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndex(requestParameters: DelayIndexApiGetDelayIndexRequest, options?: RawAxiosRequestConfig): AxiosPromise<DelayIndexView> {
            return localVarFp.getDelayIndex(requestParameters.month, requestParameters.year, requestParameters.countriesFilter, requestParameters.icdCategoryFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per country
         * @param {DelayIndexApiGetDelayIndexPerCountryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerCountry(requestParameters: DelayIndexApiGetDelayIndexPerCountryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListLabeledDelayItem> {
            return localVarFp.getDelayIndexPerCountry(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.icdCategoryFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the clinical trial delay index for a specific month per disease
         * @param {DelayIndexApiGetDelayIndexPerDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDelayIndexPerDisease(requestParameters: DelayIndexApiGetDelayIndexPerDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListLabeledDelayItem> {
            return localVarFp.getDelayIndexPerDisease(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.countriesFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getDelayIndex operation in DelayIndexApi.
 * @export
 * @interface DelayIndexApiGetDelayIndexRequest
 */
export interface DelayIndexApiGetDelayIndexRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly month: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly year: number

    /**
     * 
     * @type {Array<string>}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly countriesFilter?: Array<string>

    /**
     * 
     * @type {string}
     * @memberof DelayIndexApiGetDelayIndex
     */
    readonly icdCategoryFilter?: string
}

/**
 * Request parameters for getDelayIndexPerCountry operation in DelayIndexApi.
 * @export
 * @interface DelayIndexApiGetDelayIndexPerCountryRequest
 */
export interface DelayIndexApiGetDelayIndexPerCountryRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly month: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly year: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DelayIndexApiGetDelayIndexPerCountry
     */
    readonly icdCategoryFilter?: string
}

/**
 * Request parameters for getDelayIndexPerDisease operation in DelayIndexApi.
 * @export
 * @interface DelayIndexApiGetDelayIndexPerDiseaseRequest
 */
export interface DelayIndexApiGetDelayIndexPerDiseaseRequest {
    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly month: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly year: number

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly offset?: number | null

    /**
     * 
     * @type {Array<string>}
     * @memberof DelayIndexApiGetDelayIndexPerDisease
     */
    readonly countriesFilter?: Array<string>
}

/**
 * DelayIndexApi - object-oriented interface
 * @export
 * @class DelayIndexApi
 * @extends {BaseAPI}
 */
export class DelayIndexApi extends BaseAPI {
    /**
     * 
     * @summary get the clinical trial delay index for a specific month
     * @param {DelayIndexApiGetDelayIndexRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelayIndexApi
     */
    public getDelayIndex(requestParameters: DelayIndexApiGetDelayIndexRequest, options?: RawAxiosRequestConfig) {
        return DelayIndexApiFp(this.configuration).getDelayIndex(requestParameters.month, requestParameters.year, requestParameters.countriesFilter, requestParameters.icdCategoryFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the clinical trial delay index for a specific month per country
     * @param {DelayIndexApiGetDelayIndexPerCountryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelayIndexApi
     */
    public getDelayIndexPerCountry(requestParameters: DelayIndexApiGetDelayIndexPerCountryRequest, options?: RawAxiosRequestConfig) {
        return DelayIndexApiFp(this.configuration).getDelayIndexPerCountry(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.icdCategoryFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the clinical trial delay index for a specific month per disease
     * @param {DelayIndexApiGetDelayIndexPerDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DelayIndexApi
     */
    public getDelayIndexPerDisease(requestParameters: DelayIndexApiGetDelayIndexPerDiseaseRequest, options?: RawAxiosRequestConfig) {
        return DelayIndexApiFp(this.configuration).getDelayIndexPerDisease(requestParameters.month, requestParameters.year, requestParameters.limit, requestParameters.offset, requestParameters.countriesFilter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DependencyApi - axios parameter creator
 * @export
 */
export const DependencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDependency: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDependency', 'id', id)
            const localVarPath = `/dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing dependency
         * @param {string} id 
         * @param {DependencyUpdateBody} dependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependency: async (id: string, dependencyUpdateBody: DependencyUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDependency', 'id', id)
            // verify required parameter 'dependencyUpdateBody' is not null or undefined
            assertParamExists('updateDependency', 'dependencyUpdateBody', dependencyUpdateBody)
            const localVarPath = `/dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dependencyUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DependencyApi - functional programming interface
 * @export
 */
export const DependencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DependencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDependency(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDependency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DependencyApi.deleteDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing dependency
         * @param {string} id 
         * @param {DependencyUpdateBody} dependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDependency(id: string, dependencyUpdateBody: DependencyUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDependency(id, dependencyUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DependencyApi.updateDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DependencyApi - factory interface
 * @export
 */
export const DependencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DependencyApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a dependency
         * @param {DependencyApiDeleteDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDependency(requestParameters: DependencyApiDeleteDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDependency(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing dependency
         * @param {DependencyApiUpdateDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDependency(requestParameters: DependencyApiUpdateDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDependency(requestParameters.id, requestParameters.dependencyUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDependency operation in DependencyApi.
 * @export
 * @interface DependencyApiDeleteDependencyRequest
 */
export interface DependencyApiDeleteDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DependencyApiDeleteDependency
     */
    readonly id: string
}

/**
 * Request parameters for updateDependency operation in DependencyApi.
 * @export
 * @interface DependencyApiUpdateDependencyRequest
 */
export interface DependencyApiUpdateDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof DependencyApiUpdateDependency
     */
    readonly id: string

    /**
     * 
     * @type {DependencyUpdateBody}
     * @memberof DependencyApiUpdateDependency
     */
    readonly dependencyUpdateBody: DependencyUpdateBody
}

/**
 * DependencyApi - object-oriented interface
 * @export
 * @class DependencyApi
 * @extends {BaseAPI}
 */
export class DependencyApi extends BaseAPI {
    /**
     * 
     * @summary Delete a dependency
     * @param {DependencyApiDeleteDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyApi
     */
    public deleteDependency(requestParameters: DependencyApiDeleteDependencyRequest, options?: RawAxiosRequestConfig) {
        return DependencyApiFp(this.configuration).deleteDependency(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing dependency
     * @param {DependencyApiUpdateDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DependencyApi
     */
    public updateDependency(requestParameters: DependencyApiUpdateDependencyRequest, options?: RawAxiosRequestConfig) {
        return DependencyApiFp(this.configuration).updateDependency(requestParameters.id, requestParameters.dependencyUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DiseasesApi - axios parameter creator
 * @export
 */
export const DiseasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a new disease
         * @param {DiseaseCreateBody} diseaseCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDisease: async (diseaseCreateBody: DiseaseCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'diseaseCreateBody' is not null or undefined
            assertParamExists('createDisease', 'diseaseCreateBody', diseaseCreateBody)
            const localVarPath = `/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a name to an icd code
         * @param {string} id 
         * @param {DiseaseNameCreate} diseaseNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIcdDiseaseName: async (id: string, diseaseNameCreate: DiseaseNameCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createIcdDiseaseName', 'id', id)
            // verify required parameter 'diseaseNameCreate' is not null or undefined
            assertParamExists('createIcdDiseaseName', 'diseaseNameCreate', diseaseNameCreate)
            const localVarPath = `/diseases/icd/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseNameCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a disease name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiseaseName: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDiseaseName', 'id', id)
            const localVarPath = `/diseases/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all disease names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {boolean} [exactMatch] 
         * @param {string} [countryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseases: async (language: Language, limit?: number | null, offset?: number | null, searchString?: string, exactMatch?: boolean, countryFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getDiseases', 'language', language)
            const localVarPath = `/diseases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (exactMatch !== undefined) {
                localVarQueryParameter['exactMatch'] = exactMatch;
            }

            if (countryFilter !== undefined) {
                localVarQueryParameter['countryFilter'] = countryFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get trials count of selected diseases for a specific country
         * @param {string} countryFilter 
         * @param {Array<string>} diseaseIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseasesTrialsCount: async (countryFilter: string, diseaseIds: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryFilter' is not null or undefined
            assertParamExists('getDiseasesTrialsCount', 'countryFilter', countryFilter)
            // verify required parameter 'diseaseIds' is not null or undefined
            assertParamExists('getDiseasesTrialsCount', 'diseaseIds', diseaseIds)
            const localVarPath = `/diseases/trials-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryFilter !== undefined) {
                localVarQueryParameter['countryFilter'] = countryFilter;
            }

            if (diseaseIds) {
                localVarQueryParameter['diseaseIds'] = diseaseIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all names of an icd code in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseNames: async (language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getIcdDiseaseNames', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIcdDiseaseNames', 'id', id)
            const localVarPath = `/diseases/icd/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all translations of an icd code in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getIcdDiseaseTranslations', 'id', id)
            const localVarPath = `/diseases/icd/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all icd codes in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseases: async (limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/diseases/icd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a disease name
         * @param {string} id 
         * @param {DiseaseNameUpdateQuery} diseaseNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiseaseName: async (id: string, diseaseNameUpdateQuery: DiseaseNameUpdateQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDiseaseName', 'id', id)
            // verify required parameter 'diseaseNameUpdateQuery' is not null or undefined
            assertParamExists('updateDiseaseName', 'diseaseNameUpdateQuery', diseaseNameUpdateQuery)
            const localVarPath = `/diseases/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseNameUpdateQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the translations of an icd code in the platform
         * @param {string} id 
         * @param {DiseaseTranslationsBody} diseaseTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIcdDiseaseTranslations: async (id: string, diseaseTranslationsBody: DiseaseTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertIcdDiseaseTranslations', 'id', id)
            // verify required parameter 'diseaseTranslationsBody' is not null or undefined
            assertParamExists('upsertIcdDiseaseTranslations', 'diseaseTranslationsBody', diseaseTranslationsBody)
            const localVarPath = `/diseases/icd/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(diseaseTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DiseasesApi - functional programming interface
 * @export
 */
export const DiseasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DiseasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a new disease
         * @param {DiseaseCreateBody} diseaseCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDisease(diseaseCreateBody: DiseaseCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseCreateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDisease(diseaseCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.createDisease']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a name to an icd code
         * @param {string} id 
         * @param {DiseaseNameCreate} diseaseNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIcdDiseaseName(id: string, diseaseNameCreate: DiseaseNameCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIcdDiseaseName(id, diseaseNameCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.createIcdDiseaseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a disease name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDiseaseName(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDiseaseName(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.deleteDiseaseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all disease names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {boolean} [exactMatch] 
         * @param {string} [countryFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiseases(language: Language, limit?: number | null, offset?: number | null, searchString?: string, exactMatch?: boolean, countryFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiseases(language, limit, offset, searchString, exactMatch, countryFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getDiseases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get trials count of selected diseases for a specific country
         * @param {string} countryFilter 
         * @param {Array<string>} diseaseIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiseasesTrialsCount(countryFilter: string, diseaseIds: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseTrialsCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiseasesTrialsCount(countryFilter, diseaseIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getDiseasesTrialsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all names of an icd code in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIcdDiseaseNames(language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIcdDiseaseNames(language, id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getIcdDiseaseNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all translations of an icd code in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIcdDiseaseTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIcdDiseaseTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getIcdDiseaseTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all icd codes in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIcdDiseases(limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListIcdDiseaseView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIcdDiseases(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.getIcdDiseases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a disease name
         * @param {string} id 
         * @param {DiseaseNameUpdateQuery} diseaseNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiseaseName(id: string, diseaseNameUpdateQuery: DiseaseNameUpdateQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiseaseNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiseaseName(id, diseaseNameUpdateQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.updateDiseaseName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the translations of an icd code in the platform
         * @param {string} id 
         * @param {DiseaseTranslationsBody} diseaseTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertIcdDiseaseTranslations(id: string, diseaseTranslationsBody: DiseaseTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListDiseaseTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertIcdDiseaseTranslations(id, diseaseTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DiseasesApi.upsertIcdDiseaseTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DiseasesApi - factory interface
 * @export
 */
export const DiseasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DiseasesApiFp(configuration)
    return {
        /**
         * 
         * @summary create a new disease
         * @param {DiseasesApiCreateDiseaseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDisease(requestParameters: DiseasesApiCreateDiseaseRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseCreateView> {
            return localVarFp.createDisease(requestParameters.diseaseCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a name to an icd code
         * @param {DiseasesApiCreateIcdDiseaseNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIcdDiseaseName(requestParameters: DiseasesApiCreateIcdDiseaseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseView> {
            return localVarFp.createIcdDiseaseName(requestParameters.id, requestParameters.diseaseNameCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a disease name
         * @param {DiseasesApiDeleteDiseaseNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiseaseName(requestParameters: DiseasesApiDeleteDiseaseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDiseaseName(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all disease names in the platform
         * @param {DiseasesApiGetDiseasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseases(requestParameters: DiseasesApiGetDiseasesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseView> {
            return localVarFp.getDiseases(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.exactMatch, requestParameters.countryFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get trials count of selected diseases for a specific country
         * @param {DiseasesApiGetDiseasesTrialsCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiseasesTrialsCount(requestParameters: DiseasesApiGetDiseasesTrialsCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseTrialsCountView> {
            return localVarFp.getDiseasesTrialsCount(requestParameters.countryFilter, requestParameters.diseaseIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all names of an icd code in the platform
         * @param {DiseasesApiGetIcdDiseaseNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseNames(requestParameters: DiseasesApiGetIcdDiseaseNamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseNameView> {
            return localVarFp.getIcdDiseaseNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all translations of an icd code in the platform
         * @param {DiseasesApiGetIcdDiseaseTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseaseTranslations(requestParameters: DiseasesApiGetIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseTranslationView> {
            return localVarFp.getIcdDiseaseTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all icd codes in the platform
         * @param {DiseasesApiGetIcdDiseasesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIcdDiseases(requestParameters: DiseasesApiGetIcdDiseasesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListIcdDiseaseView> {
            return localVarFp.getIcdDiseases(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a disease name
         * @param {DiseasesApiUpdateDiseaseNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiseaseName(requestParameters: DiseasesApiUpdateDiseaseNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<DiseaseNameView> {
            return localVarFp.updateDiseaseName(requestParameters.id, requestParameters.diseaseNameUpdateQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the translations of an icd code in the platform
         * @param {DiseasesApiUpsertIcdDiseaseTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertIcdDiseaseTranslations(requestParameters: DiseasesApiUpsertIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListDiseaseTranslationView> {
            return localVarFp.upsertIcdDiseaseTranslations(requestParameters.id, requestParameters.diseaseTranslationsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDisease operation in DiseasesApi.
 * @export
 * @interface DiseasesApiCreateDiseaseRequest
 */
export interface DiseasesApiCreateDiseaseRequest {
    /**
     * 
     * @type {DiseaseCreateBody}
     * @memberof DiseasesApiCreateDisease
     */
    readonly diseaseCreateBody: DiseaseCreateBody
}

/**
 * Request parameters for createIcdDiseaseName operation in DiseasesApi.
 * @export
 * @interface DiseasesApiCreateIcdDiseaseNameRequest
 */
export interface DiseasesApiCreateIcdDiseaseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiCreateIcdDiseaseName
     */
    readonly id: string

    /**
     * 
     * @type {DiseaseNameCreate}
     * @memberof DiseasesApiCreateIcdDiseaseName
     */
    readonly diseaseNameCreate: DiseaseNameCreate
}

/**
 * Request parameters for deleteDiseaseName operation in DiseasesApi.
 * @export
 * @interface DiseasesApiDeleteDiseaseNameRequest
 */
export interface DiseasesApiDeleteDiseaseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiDeleteDiseaseName
     */
    readonly id: string
}

/**
 * Request parameters for getDiseases operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetDiseasesRequest
 */
export interface DiseasesApiGetDiseasesRequest {
    /**
     * 
     * @type {Language}
     * @memberof DiseasesApiGetDiseases
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetDiseases
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetDiseases
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseases
     */
    readonly searchString?: string

    /**
     * 
     * @type {boolean}
     * @memberof DiseasesApiGetDiseases
     */
    readonly exactMatch?: boolean

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseases
     */
    readonly countryFilter?: string
}

/**
 * Request parameters for getDiseasesTrialsCount operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetDiseasesTrialsCountRequest
 */
export interface DiseasesApiGetDiseasesTrialsCountRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetDiseasesTrialsCount
     */
    readonly countryFilter: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DiseasesApiGetDiseasesTrialsCount
     */
    readonly diseaseIds: Array<string>
}

/**
 * Request parameters for getIcdDiseaseNames operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetIcdDiseaseNamesRequest
 */
export interface DiseasesApiGetIcdDiseaseNamesRequest {
    /**
     * 
     * @type {Language}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseaseNames
     */
    readonly searchString?: string
}

/**
 * Request parameters for getIcdDiseaseTranslations operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetIcdDiseaseTranslationsRequest
 */
export interface DiseasesApiGetIcdDiseaseTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseaseTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getIcdDiseases operation in DiseasesApi.
 * @export
 * @interface DiseasesApiGetIcdDiseasesRequest
 */
export interface DiseasesApiGetIcdDiseasesRequest {
    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof DiseasesApiGetIcdDiseases
     */
    readonly searchString?: string
}

/**
 * Request parameters for updateDiseaseName operation in DiseasesApi.
 * @export
 * @interface DiseasesApiUpdateDiseaseNameRequest
 */
export interface DiseasesApiUpdateDiseaseNameRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiUpdateDiseaseName
     */
    readonly id: string

    /**
     * 
     * @type {DiseaseNameUpdateQuery}
     * @memberof DiseasesApiUpdateDiseaseName
     */
    readonly diseaseNameUpdateQuery: DiseaseNameUpdateQuery
}

/**
 * Request parameters for upsertIcdDiseaseTranslations operation in DiseasesApi.
 * @export
 * @interface DiseasesApiUpsertIcdDiseaseTranslationsRequest
 */
export interface DiseasesApiUpsertIcdDiseaseTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof DiseasesApiUpsertIcdDiseaseTranslations
     */
    readonly id: string

    /**
     * 
     * @type {DiseaseTranslationsBody}
     * @memberof DiseasesApiUpsertIcdDiseaseTranslations
     */
    readonly diseaseTranslationsBody: DiseaseTranslationsBody
}

/**
 * DiseasesApi - object-oriented interface
 * @export
 * @class DiseasesApi
 * @extends {BaseAPI}
 */
export class DiseasesApi extends BaseAPI {
    /**
     * 
     * @summary create a new disease
     * @param {DiseasesApiCreateDiseaseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public createDisease(requestParameters: DiseasesApiCreateDiseaseRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).createDisease(requestParameters.diseaseCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a name to an icd code
     * @param {DiseasesApiCreateIcdDiseaseNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public createIcdDiseaseName(requestParameters: DiseasesApiCreateIcdDiseaseNameRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).createIcdDiseaseName(requestParameters.id, requestParameters.diseaseNameCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a disease name
     * @param {DiseasesApiDeleteDiseaseNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public deleteDiseaseName(requestParameters: DiseasesApiDeleteDiseaseNameRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).deleteDiseaseName(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all disease names in the platform
     * @param {DiseasesApiGetDiseasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getDiseases(requestParameters: DiseasesApiGetDiseasesRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getDiseases(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, requestParameters.exactMatch, requestParameters.countryFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get trials count of selected diseases for a specific country
     * @param {DiseasesApiGetDiseasesTrialsCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getDiseasesTrialsCount(requestParameters: DiseasesApiGetDiseasesTrialsCountRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getDiseasesTrialsCount(requestParameters.countryFilter, requestParameters.diseaseIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all names of an icd code in the platform
     * @param {DiseasesApiGetIcdDiseaseNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getIcdDiseaseNames(requestParameters: DiseasesApiGetIcdDiseaseNamesRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getIcdDiseaseNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all translations of an icd code in the platform
     * @param {DiseasesApiGetIcdDiseaseTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getIcdDiseaseTranslations(requestParameters: DiseasesApiGetIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getIcdDiseaseTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all icd codes in the platform
     * @param {DiseasesApiGetIcdDiseasesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public getIcdDiseases(requestParameters: DiseasesApiGetIcdDiseasesRequest = {}, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).getIcdDiseases(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a disease name
     * @param {DiseasesApiUpdateDiseaseNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public updateDiseaseName(requestParameters: DiseasesApiUpdateDiseaseNameRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).updateDiseaseName(requestParameters.id, requestParameters.diseaseNameUpdateQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the translations of an icd code in the platform
     * @param {DiseasesApiUpsertIcdDiseaseTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiseasesApi
     */
    public upsertIcdDiseaseTranslations(requestParameters: DiseasesApiUpsertIcdDiseaseTranslationsRequest, options?: RawAxiosRequestConfig) {
        return DiseasesApiFp(this.configuration).upsertIcdDiseaseTranslations(requestParameters.id, requestParameters.diseaseTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HospitalsApi - axios parameter creator
 * @export
 */
export const HospitalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary create a new hospital center
         * @param {HospitalCenterCreate} hospitalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenter: async (hospitalCenterCreate: HospitalCenterCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hospitalCenterCreate' is not null or undefined
            assertParamExists('createHospitalCenter', 'hospitalCenterCreate', hospitalCenterCreate)
            const localVarPath = `/hospitals/center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalCenterCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a name to a hospital center
         * @param {string} id 
         * @param {HospitalNameCreate} hospitalNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenterName: async (id: string, hospitalNameCreate: HospitalNameCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createHospitalCenterName', 'id', id)
            // verify required parameter 'hospitalNameCreate' is not null or undefined
            assertParamExists('createHospitalCenterName', 'hospitalNameCreate', hospitalNameCreate)
            const localVarPath = `/hospitals/center/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalNameCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a hospital name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHospitalName: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteHospitalName', 'id', id)
            const localVarPath = `/hospitals/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a hospital centers in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHospitalCenterDetails', 'id', id)
            const localVarPath = `/hospitals/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all hospital names of a hospital center in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterNames: async (language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getHospitalCenterNames', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHospitalCenterNames', 'id', id)
            const localVarPath = `/hospitals/center/{id}/names`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all translations of a hospital center in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHospitalCenterTranslations', 'id', id)
            const localVarPath = `/hospitals/center/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all hospital centers in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenters: async (limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hospitals/center`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all hospital names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitals: async (language: Language, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getHospitals', 'language', language)
            const localVarPath = `/hospitals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary merge this hospital into the specified target hospital.
         * @param {string} id 
         * @param {HospitalMergeBody} hospitalMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeHospitals: async (id: string, hospitalMergeBody: HospitalMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mergeHospitals', 'id', id)
            // verify required parameter 'hospitalMergeBody' is not null or undefined
            assertParamExists('mergeHospitals', 'hospitalMergeBody', hospitalMergeBody)
            const localVarPath = `/hospitals/{id}/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update \'isStandard\' field of a hospital center.
         * @param {string} id 
         * @param {HospitalCenterUpdateQuery} hospitalCenterUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalCenter: async (id: string, hospitalCenterUpdateQuery: HospitalCenterUpdateQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHospitalCenter', 'id', id)
            // verify required parameter 'hospitalCenterUpdateQuery' is not null or undefined
            assertParamExists('updateHospitalCenter', 'hospitalCenterUpdateQuery', hospitalCenterUpdateQuery)
            const localVarPath = `/hospitals/center/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalCenterUpdateQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a hospital name
         * @param {string} id 
         * @param {HospitalNameUpdateQuery} hospitalNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalName: async (id: string, hospitalNameUpdateQuery: HospitalNameUpdateQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHospitalName', 'id', id)
            // verify required parameter 'hospitalNameUpdateQuery' is not null or undefined
            assertParamExists('updateHospitalName', 'hospitalNameUpdateQuery', hospitalNameUpdateQuery)
            const localVarPath = `/hospitals/names/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalNameUpdateQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the translations of a hospital center in the platform
         * @param {string} id 
         * @param {HospitalTranslationsBody} hospitalTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHospitalCenterTranslations: async (id: string, hospitalTranslationsBody: HospitalTranslationsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertHospitalCenterTranslations', 'id', id)
            // verify required parameter 'hospitalTranslationsBody' is not null or undefined
            assertParamExists('upsertHospitalCenterTranslations', 'hospitalTranslationsBody', hospitalTranslationsBody)
            const localVarPath = `/hospitals/center/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hospitalTranslationsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HospitalsApi - functional programming interface
 * @export
 */
export const HospitalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HospitalsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary create a new hospital center
         * @param {HospitalCenterCreate} hospitalCenterCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHospitalCenter(hospitalCenterCreate: HospitalCenterCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHospitalCenter(hospitalCenterCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.createHospitalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a name to a hospital center
         * @param {string} id 
         * @param {HospitalNameCreate} hospitalNameCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHospitalCenterName(id: string, hospitalNameCreate: HospitalNameCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHospitalCenterName(id, hospitalNameCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.createHospitalCenterName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a hospital name
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHospitalName(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHospitalName(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.deleteHospitalName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a hospital centers in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenterDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenterDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenterDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all hospital names of a hospital center in the platform
         * @param {Language} language 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenterNames(language: Language, id: string, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenterNames(language, id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenterNames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all translations of a hospital center in the platform
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenterTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenterTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenterTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all hospital centers in the platform
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitalCenters(limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitalCenters(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitalCenters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all hospital names in the platform
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHospitals(language: Language, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHospitals(language, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.getHospitals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary merge this hospital into the specified target hospital.
         * @param {string} id 
         * @param {HospitalMergeBody} hospitalMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeHospitals(id: string, hospitalMergeBody: HospitalMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeHospitals(id, hospitalMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.mergeHospitals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update \'isStandard\' field of a hospital center.
         * @param {string} id 
         * @param {HospitalCenterUpdateQuery} hospitalCenterUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHospitalCenter(id: string, hospitalCenterUpdateQuery: HospitalCenterUpdateQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalCenterView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospitalCenter(id, hospitalCenterUpdateQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.updateHospitalCenter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a hospital name
         * @param {string} id 
         * @param {HospitalNameUpdateQuery} hospitalNameUpdateQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHospitalName(id: string, hospitalNameUpdateQuery: HospitalNameUpdateQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HospitalNameView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHospitalName(id, hospitalNameUpdateQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.updateHospitalName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the translations of a hospital center in the platform
         * @param {string} id 
         * @param {HospitalTranslationsBody} hospitalTranslationsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertHospitalCenterTranslations(id: string, hospitalTranslationsBody: HospitalTranslationsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListHospitalTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertHospitalCenterTranslations(id, hospitalTranslationsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalsApi.upsertHospitalCenterTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HospitalsApi - factory interface
 * @export
 */
export const HospitalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HospitalsApiFp(configuration)
    return {
        /**
         * 
         * @summary create a new hospital center
         * @param {HospitalsApiCreateHospitalCenterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenter(requestParameters: HospitalsApiCreateHospitalCenterRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalCenterView> {
            return localVarFp.createHospitalCenter(requestParameters.hospitalCenterCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a name to a hospital center
         * @param {HospitalsApiCreateHospitalCenterNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHospitalCenterName(requestParameters: HospitalsApiCreateHospitalCenterNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalView> {
            return localVarFp.createHospitalCenterName(requestParameters.id, requestParameters.hospitalNameCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a hospital name
         * @param {HospitalsApiDeleteHospitalNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHospitalName(requestParameters: HospitalsApiDeleteHospitalNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteHospitalName(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a hospital centers in the platform
         * @param {HospitalsApiGetHospitalCenterDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterDetails(requestParameters: HospitalsApiGetHospitalCenterDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalCenterView> {
            return localVarFp.getHospitalCenterDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all hospital names of a hospital center in the platform
         * @param {HospitalsApiGetHospitalCenterNamesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterNames(requestParameters: HospitalsApiGetHospitalCenterNamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalNameView> {
            return localVarFp.getHospitalCenterNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all translations of a hospital center in the platform
         * @param {HospitalsApiGetHospitalCenterTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenterTranslations(requestParameters: HospitalsApiGetHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalTranslationView> {
            return localVarFp.getHospitalCenterTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all hospital centers in the platform
         * @param {HospitalsApiGetHospitalCentersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitalCenters(requestParameters: HospitalsApiGetHospitalCentersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalCenterView> {
            return localVarFp.getHospitalCenters(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all hospital names in the platform
         * @param {HospitalsApiGetHospitalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHospitals(requestParameters: HospitalsApiGetHospitalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalView> {
            return localVarFp.getHospitals(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary merge this hospital into the specified target hospital.
         * @param {HospitalsApiMergeHospitalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeHospitals(requestParameters: HospitalsApiMergeHospitalsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.mergeHospitals(requestParameters.id, requestParameters.hospitalMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update \'isStandard\' field of a hospital center.
         * @param {HospitalsApiUpdateHospitalCenterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalCenter(requestParameters: HospitalsApiUpdateHospitalCenterRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalCenterView> {
            return localVarFp.updateHospitalCenter(requestParameters.id, requestParameters.hospitalCenterUpdateQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a hospital name
         * @param {HospitalsApiUpdateHospitalNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHospitalName(requestParameters: HospitalsApiUpdateHospitalNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<HospitalNameView> {
            return localVarFp.updateHospitalName(requestParameters.id, requestParameters.hospitalNameUpdateQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the translations of a hospital center in the platform
         * @param {HospitalsApiUpsertHospitalCenterTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertHospitalCenterTranslations(requestParameters: HospitalsApiUpsertHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListHospitalTranslationView> {
            return localVarFp.upsertHospitalCenterTranslations(requestParameters.id, requestParameters.hospitalTranslationsBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createHospitalCenter operation in HospitalsApi.
 * @export
 * @interface HospitalsApiCreateHospitalCenterRequest
 */
export interface HospitalsApiCreateHospitalCenterRequest {
    /**
     * 
     * @type {HospitalCenterCreate}
     * @memberof HospitalsApiCreateHospitalCenter
     */
    readonly hospitalCenterCreate: HospitalCenterCreate
}

/**
 * Request parameters for createHospitalCenterName operation in HospitalsApi.
 * @export
 * @interface HospitalsApiCreateHospitalCenterNameRequest
 */
export interface HospitalsApiCreateHospitalCenterNameRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiCreateHospitalCenterName
     */
    readonly id: string

    /**
     * 
     * @type {HospitalNameCreate}
     * @memberof HospitalsApiCreateHospitalCenterName
     */
    readonly hospitalNameCreate: HospitalNameCreate
}

/**
 * Request parameters for deleteHospitalName operation in HospitalsApi.
 * @export
 * @interface HospitalsApiDeleteHospitalNameRequest
 */
export interface HospitalsApiDeleteHospitalNameRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiDeleteHospitalName
     */
    readonly id: string
}

/**
 * Request parameters for getHospitalCenterDetails operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCenterDetailsRequest
 */
export interface HospitalsApiGetHospitalCenterDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterDetails
     */
    readonly id: string
}

/**
 * Request parameters for getHospitalCenterNames operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCenterNamesRequest
 */
export interface HospitalsApiGetHospitalCenterNamesRequest {
    /**
     * 
     * @type {Language}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterNames
     */
    readonly searchString?: string
}

/**
 * Request parameters for getHospitalCenterTranslations operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCenterTranslationsRequest
 */
export interface HospitalsApiGetHospitalCenterTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenterTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getHospitalCenters operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalCentersRequest
 */
export interface HospitalsApiGetHospitalCentersRequest {
    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenters
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitalCenters
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitalCenters
     */
    readonly searchString?: string
}

/**
 * Request parameters for getHospitals operation in HospitalsApi.
 * @export
 * @interface HospitalsApiGetHospitalsRequest
 */
export interface HospitalsApiGetHospitalsRequest {
    /**
     * 
     * @type {Language}
     * @memberof HospitalsApiGetHospitals
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitals
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof HospitalsApiGetHospitals
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof HospitalsApiGetHospitals
     */
    readonly searchString?: string
}

/**
 * Request parameters for mergeHospitals operation in HospitalsApi.
 * @export
 * @interface HospitalsApiMergeHospitalsRequest
 */
export interface HospitalsApiMergeHospitalsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiMergeHospitals
     */
    readonly id: string

    /**
     * 
     * @type {HospitalMergeBody}
     * @memberof HospitalsApiMergeHospitals
     */
    readonly hospitalMergeBody: HospitalMergeBody
}

/**
 * Request parameters for updateHospitalCenter operation in HospitalsApi.
 * @export
 * @interface HospitalsApiUpdateHospitalCenterRequest
 */
export interface HospitalsApiUpdateHospitalCenterRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiUpdateHospitalCenter
     */
    readonly id: string

    /**
     * 
     * @type {HospitalCenterUpdateQuery}
     * @memberof HospitalsApiUpdateHospitalCenter
     */
    readonly hospitalCenterUpdateQuery: HospitalCenterUpdateQuery
}

/**
 * Request parameters for updateHospitalName operation in HospitalsApi.
 * @export
 * @interface HospitalsApiUpdateHospitalNameRequest
 */
export interface HospitalsApiUpdateHospitalNameRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiUpdateHospitalName
     */
    readonly id: string

    /**
     * 
     * @type {HospitalNameUpdateQuery}
     * @memberof HospitalsApiUpdateHospitalName
     */
    readonly hospitalNameUpdateQuery: HospitalNameUpdateQuery
}

/**
 * Request parameters for upsertHospitalCenterTranslations operation in HospitalsApi.
 * @export
 * @interface HospitalsApiUpsertHospitalCenterTranslationsRequest
 */
export interface HospitalsApiUpsertHospitalCenterTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof HospitalsApiUpsertHospitalCenterTranslations
     */
    readonly id: string

    /**
     * 
     * @type {HospitalTranslationsBody}
     * @memberof HospitalsApiUpsertHospitalCenterTranslations
     */
    readonly hospitalTranslationsBody: HospitalTranslationsBody
}

/**
 * HospitalsApi - object-oriented interface
 * @export
 * @class HospitalsApi
 * @extends {BaseAPI}
 */
export class HospitalsApi extends BaseAPI {
    /**
     * 
     * @summary create a new hospital center
     * @param {HospitalsApiCreateHospitalCenterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public createHospitalCenter(requestParameters: HospitalsApiCreateHospitalCenterRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).createHospitalCenter(requestParameters.hospitalCenterCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a name to a hospital center
     * @param {HospitalsApiCreateHospitalCenterNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public createHospitalCenterName(requestParameters: HospitalsApiCreateHospitalCenterNameRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).createHospitalCenterName(requestParameters.id, requestParameters.hospitalNameCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a hospital name
     * @param {HospitalsApiDeleteHospitalNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public deleteHospitalName(requestParameters: HospitalsApiDeleteHospitalNameRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).deleteHospitalName(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a hospital centers in the platform
     * @param {HospitalsApiGetHospitalCenterDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenterDetails(requestParameters: HospitalsApiGetHospitalCenterDetailsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenterDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all hospital names of a hospital center in the platform
     * @param {HospitalsApiGetHospitalCenterNamesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenterNames(requestParameters: HospitalsApiGetHospitalCenterNamesRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenterNames(requestParameters.language, requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all translations of a hospital center in the platform
     * @param {HospitalsApiGetHospitalCenterTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenterTranslations(requestParameters: HospitalsApiGetHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenterTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all hospital centers in the platform
     * @param {HospitalsApiGetHospitalCentersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitalCenters(requestParameters: HospitalsApiGetHospitalCentersRequest = {}, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitalCenters(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all hospital names in the platform
     * @param {HospitalsApiGetHospitalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public getHospitals(requestParameters: HospitalsApiGetHospitalsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).getHospitals(requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary merge this hospital into the specified target hospital.
     * @param {HospitalsApiMergeHospitalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public mergeHospitals(requestParameters: HospitalsApiMergeHospitalsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).mergeHospitals(requestParameters.id, requestParameters.hospitalMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update \'isStandard\' field of a hospital center.
     * @param {HospitalsApiUpdateHospitalCenterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public updateHospitalCenter(requestParameters: HospitalsApiUpdateHospitalCenterRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).updateHospitalCenter(requestParameters.id, requestParameters.hospitalCenterUpdateQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a hospital name
     * @param {HospitalsApiUpdateHospitalNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public updateHospitalName(requestParameters: HospitalsApiUpdateHospitalNameRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).updateHospitalName(requestParameters.id, requestParameters.hospitalNameUpdateQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the translations of a hospital center in the platform
     * @param {HospitalsApiUpsertHospitalCenterTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalsApi
     */
    public upsertHospitalCenterTranslations(requestParameters: HospitalsApiUpsertHospitalCenterTranslationsRequest, options?: RawAxiosRequestConfig) {
        return HospitalsApiFp(this.configuration).upsertHospitalCenterTranslations(requestParameters.id, requestParameters.hospitalTranslationsBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InviteApi - axios parameter creator
 * @export
 */
export const InviteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept an invite with a token as an existing user
         * @param {AcceptExistingUserInviteBody} acceptExistingUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteAuthorized: async (acceptExistingUserInviteBody: AcceptExistingUserInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptExistingUserInviteBody' is not null or undefined
            assertParamExists('acceptInviteAuthorized', 'acceptExistingUserInviteBody', acceptExistingUserInviteBody)
            const localVarPath = `/invites/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptExistingUserInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept an invite with a token as a new user
         * @param {AcceptNewUserInviteBody} acceptNewUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteUnauthorized: async (acceptNewUserInviteBody: AcceptNewUserInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptNewUserInviteBody' is not null or undefined
            assertParamExists('acceptInviteUnauthorized', 'acceptNewUserInviteBody', acceptNewUserInviteBody)
            const localVarPath = `/invites/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptNewUserInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept an invite for multiple trials to be added to the users team
         * @param {string} teamId 
         * @param {AcceptExistingTeamInviteBody} acceptExistingTeamInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTrialInviteWithExistingTeam: async (teamId: string, acceptExistingTeamInviteBody: AcceptExistingTeamInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('acceptTrialInviteWithExistingTeam', 'teamId', teamId)
            // verify required parameter 'acceptExistingTeamInviteBody' is not null or undefined
            assertParamExists('acceptTrialInviteWithExistingTeam', 'acceptExistingTeamInviteBody', acceptExistingTeamInviteBody)
            const localVarPath = `/invites/team/{teamId}/accept`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptExistingTeamInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an invite to the platform (admin, patient or reviewer)
         * @param {InviteBody} inviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvite: async (inviteBody: InviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteBody' is not null or undefined
            assertParamExists('createInvite', 'inviteBody', inviteBody)
            const localVarPath = `/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an invite for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteBody} teamCreateInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamCreationInvite: async (teamCreateInviteBody: TeamCreateInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamCreateInviteBody' is not null or undefined
            assertParamExists('createTeamCreationInvite', 'teamCreateInviteBody', teamCreateInviteBody)
            const localVarPath = `/invites/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an invite to a team.
         * @param {string} teamId 
         * @param {TeamMemberInviteBody} teamMemberInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamInvite: async (teamId: string, teamMemberInviteBody: TeamMemberInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamInvite', 'teamId', teamId)
            // verify required parameter 'teamMemberInviteBody' is not null or undefined
            assertParamExists('createTeamInvite', 'teamMemberInviteBody', teamMemberInviteBody)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamCreationInvite: async (tokenValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenValue' is not null or undefined
            assertParamExists('deleteTeamCreationInvite', 'tokenValue', tokenValue)
            const localVarPath = `/invites/team/token/{tokenValue}`
                .replace(`{${"tokenValue"}}`, encodeURIComponent(String(tokenValue)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an invite of a team
         * @param {string} teamId 
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamInvite: async (teamId: string, tokenValue: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamInvite', 'teamId', teamId)
            // verify required parameter 'tokenValue' is not null or undefined
            assertParamExists('deleteTeamInvite', 'tokenValue', tokenValue)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tokenValue !== undefined) {
                localVarQueryParameter['tokenValue'] = tokenValue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary View all invites to the platform
         * @param {number} [limit] 
         * @param {Role} [role] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvites: async (limit?: number, role?: Role, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch all invites for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteQuery} teamCreateInviteQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamCreateInvites: async (teamCreateInviteQuery: TeamCreateInviteQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamCreateInviteQuery' is not null or undefined
            assertParamExists('getTeamCreateInvites', 'teamCreateInviteQuery', teamCreateInviteQuery)
            const localVarPath = `/invites/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateInviteQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invites of a specific team
         * @param {string} teamId 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvites: async (teamId: string, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamInvites', 'teamId', teamId)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {TeamCreateInviteUpdateBody} teamCreateInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamCreationInvite: async (tokenValue: string, teamCreateInviteUpdateBody: TeamCreateInviteUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenValue' is not null or undefined
            assertParamExists('updateTeamCreationInvite', 'tokenValue', tokenValue)
            // verify required parameter 'teamCreateInviteUpdateBody' is not null or undefined
            assertParamExists('updateTeamCreationInvite', 'teamCreateInviteUpdateBody', teamCreateInviteUpdateBody)
            const localVarPath = `/invites/team/token/{tokenValue}`
                .replace(`{${"tokenValue"}}`, encodeURIComponent(String(tokenValue)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamCreateInviteUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update an invite for a trial manager to a team.
         * @param {string} teamId 
         * @param {TrialInviteUpdateBody} trialInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberInvite: async (teamId: string, trialInviteUpdateBody: TrialInviteUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamMemberInvite', 'teamId', teamId)
            // verify required parameter 'trialInviteUpdateBody' is not null or undefined
            assertParamExists('updateTeamMemberInvite', 'trialInviteUpdateBody', trialInviteUpdateBody)
            const localVarPath = `/invites/team/{teamId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialInviteUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InviteApi - functional programming interface
 * @export
 */
export const InviteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InviteApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept an invite with a token as an existing user
         * @param {AcceptExistingUserInviteBody} acceptExistingUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInviteAuthorized(acceptExistingUserInviteBody: AcceptExistingUserInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInviteAuthorized(acceptExistingUserInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptInviteAuthorized']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept an invite with a token as a new user
         * @param {AcceptNewUserInviteBody} acceptNewUserInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInviteUnauthorized(acceptNewUserInviteBody: AcceptNewUserInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInviteUnauthorized(acceptNewUserInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptInviteUnauthorized']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept an invite for multiple trials to be added to the users team
         * @param {string} teamId 
         * @param {AcceptExistingTeamInviteBody} acceptExistingTeamInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTrialInviteWithExistingTeam(teamId: string, acceptExistingTeamInviteBody: AcceptExistingTeamInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTrialInviteWithExistingTeam(teamId, acceptExistingTeamInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.acceptTrialInviteWithExistingTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an invite to the platform (admin, patient or reviewer)
         * @param {InviteBody} inviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvite(inviteBody: InviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvite(inviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.createInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an invite for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteBody} teamCreateInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamCreationInvite(teamCreateInviteBody: TeamCreateInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateInviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamCreationInvite(teamCreateInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.createTeamCreationInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an invite to a team.
         * @param {string} teamId 
         * @param {TeamMemberInviteBody} teamMemberInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamInvite(teamId: string, teamMemberInviteBody: TeamMemberInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamInvite(teamId, teamMemberInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.createTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamCreationInvite(tokenValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamCreationInvite(tokenValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.deleteTeamCreationInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an invite of a team
         * @param {string} teamId 
         * @param {string} tokenValue 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamInvite(teamId: string, tokenValue: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamInvite(teamId, tokenValue, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.deleteTeamInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary View all invites to the platform
         * @param {number} [limit] 
         * @param {Role} [role] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvites(limit?: number, role?: Role, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvites(limit, role, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.getInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch all invites for multiple trials to be added to the users team on creation
         * @param {TeamCreateInviteQuery} teamCreateInviteQuery 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamCreateInvites(teamCreateInviteQuery: TeamCreateInviteQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateInviteListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamCreateInvites(teamCreateInviteQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.getTeamCreateInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get invites of a specific team
         * @param {string} teamId 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamInvites(teamId: string, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamInvites(teamId, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.getTeamInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an invite for multiple trials to be added to the users team on creation
         * @param {string} tokenValue 
         * @param {TeamCreateInviteUpdateBody} teamCreateInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamCreationInvite(tokenValue: string, teamCreateInviteUpdateBody: TeamCreateInviteUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamCreateInviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamCreationInvite(tokenValue, teamCreateInviteUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.updateTeamCreationInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update an invite for a trial manager to a team.
         * @param {string} teamId 
         * @param {TrialInviteUpdateBody} trialInviteUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMemberInvite(teamId: string, trialInviteUpdateBody: TrialInviteUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMemberInvite(teamId, trialInviteUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InviteApi.updateTeamMemberInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InviteApi - factory interface
 * @export
 */
export const InviteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InviteApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept an invite with a token as an existing user
         * @param {InviteApiAcceptInviteAuthorizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteAuthorized(requestParameters: InviteApiAcceptInviteAuthorizedRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.acceptInviteAuthorized(requestParameters.acceptExistingUserInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept an invite with a token as a new user
         * @param {InviteApiAcceptInviteUnauthorizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInviteUnauthorized(requestParameters: InviteApiAcceptInviteUnauthorizedRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.acceptInviteUnauthorized(requestParameters.acceptNewUserInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept an invite for multiple trials to be added to the users team
         * @param {InviteApiAcceptTrialInviteWithExistingTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTrialInviteWithExistingTeam(requestParameters: InviteApiAcceptTrialInviteWithExistingTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptTrialInviteWithExistingTeam(requestParameters.teamId, requestParameters.acceptExistingTeamInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an invite to the platform (admin, patient or reviewer)
         * @param {InviteApiCreateInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvite(requestParameters: InviteApiCreateInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createInvite(requestParameters.inviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an invite for multiple trials to be added to the users team on creation
         * @param {InviteApiCreateTeamCreationInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamCreationInvite(requestParameters: InviteApiCreateTeamCreationInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateInviteView> {
            return localVarFp.createTeamCreationInvite(requestParameters.teamCreateInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an invite to a team.
         * @param {InviteApiCreateTeamInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamInvite(requestParameters: InviteApiCreateTeamInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteView> {
            return localVarFp.createTeamInvite(requestParameters.teamId, requestParameters.teamMemberInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an invite for multiple trials to be added to the users team on creation
         * @param {InviteApiDeleteTeamCreationInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamCreationInvite(requestParameters: InviteApiDeleteTeamCreationInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamCreationInvite(requestParameters.tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an invite of a team
         * @param {InviteApiDeleteTeamInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamInvite(requestParameters: InviteApiDeleteTeamInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTeamInvite(requestParameters.teamId, requestParameters.tokenValue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary View all invites to the platform
         * @param {InviteApiGetInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvites(requestParameters: InviteApiGetInvitesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<InviteListView> {
            return localVarFp.getInvites(requestParameters.limit, requestParameters.role, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch all invites for multiple trials to be added to the users team on creation
         * @param {InviteApiGetTeamCreateInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamCreateInvites(requestParameters: InviteApiGetTeamCreateInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateInviteListView> {
            return localVarFp.getTeamCreateInvites(requestParameters.teamCreateInviteQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invites of a specific team
         * @param {InviteApiGetTeamInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamInvites(requestParameters: InviteApiGetTeamInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteListView> {
            return localVarFp.getTeamInvites(requestParameters.teamId, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an invite for multiple trials to be added to the users team on creation
         * @param {InviteApiUpdateTeamCreationInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamCreationInvite(requestParameters: InviteApiUpdateTeamCreationInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamCreateInviteView> {
            return localVarFp.updateTeamCreationInvite(requestParameters.tokenValue, requestParameters.teamCreateInviteUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update an invite for a trial manager to a team.
         * @param {InviteApiUpdateTeamMemberInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberInvite(requestParameters: InviteApiUpdateTeamMemberInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteView> {
            return localVarFp.updateTeamMemberInvite(requestParameters.teamId, requestParameters.trialInviteUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for acceptInviteAuthorized operation in InviteApi.
 * @export
 * @interface InviteApiAcceptInviteAuthorizedRequest
 */
export interface InviteApiAcceptInviteAuthorizedRequest {
    /**
     * 
     * @type {AcceptExistingUserInviteBody}
     * @memberof InviteApiAcceptInviteAuthorized
     */
    readonly acceptExistingUserInviteBody: AcceptExistingUserInviteBody
}

/**
 * Request parameters for acceptInviteUnauthorized operation in InviteApi.
 * @export
 * @interface InviteApiAcceptInviteUnauthorizedRequest
 */
export interface InviteApiAcceptInviteUnauthorizedRequest {
    /**
     * 
     * @type {AcceptNewUserInviteBody}
     * @memberof InviteApiAcceptInviteUnauthorized
     */
    readonly acceptNewUserInviteBody: AcceptNewUserInviteBody
}

/**
 * Request parameters for acceptTrialInviteWithExistingTeam operation in InviteApi.
 * @export
 * @interface InviteApiAcceptTrialInviteWithExistingTeamRequest
 */
export interface InviteApiAcceptTrialInviteWithExistingTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiAcceptTrialInviteWithExistingTeam
     */
    readonly teamId: string

    /**
     * 
     * @type {AcceptExistingTeamInviteBody}
     * @memberof InviteApiAcceptTrialInviteWithExistingTeam
     */
    readonly acceptExistingTeamInviteBody: AcceptExistingTeamInviteBody
}

/**
 * Request parameters for createInvite operation in InviteApi.
 * @export
 * @interface InviteApiCreateInviteRequest
 */
export interface InviteApiCreateInviteRequest {
    /**
     * 
     * @type {InviteBody}
     * @memberof InviteApiCreateInvite
     */
    readonly inviteBody: InviteBody
}

/**
 * Request parameters for createTeamCreationInvite operation in InviteApi.
 * @export
 * @interface InviteApiCreateTeamCreationInviteRequest
 */
export interface InviteApiCreateTeamCreationInviteRequest {
    /**
     * 
     * @type {TeamCreateInviteBody}
     * @memberof InviteApiCreateTeamCreationInvite
     */
    readonly teamCreateInviteBody: TeamCreateInviteBody
}

/**
 * Request parameters for createTeamInvite operation in InviteApi.
 * @export
 * @interface InviteApiCreateTeamInviteRequest
 */
export interface InviteApiCreateTeamInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiCreateTeamInvite
     */
    readonly teamId: string

    /**
     * 
     * @type {TeamMemberInviteBody}
     * @memberof InviteApiCreateTeamInvite
     */
    readonly teamMemberInviteBody: TeamMemberInviteBody
}

/**
 * Request parameters for deleteTeamCreationInvite operation in InviteApi.
 * @export
 * @interface InviteApiDeleteTeamCreationInviteRequest
 */
export interface InviteApiDeleteTeamCreationInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiDeleteTeamCreationInvite
     */
    readonly tokenValue: string
}

/**
 * Request parameters for deleteTeamInvite operation in InviteApi.
 * @export
 * @interface InviteApiDeleteTeamInviteRequest
 */
export interface InviteApiDeleteTeamInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiDeleteTeamInvite
     */
    readonly teamId: string

    /**
     * 
     * @type {string}
     * @memberof InviteApiDeleteTeamInvite
     */
    readonly tokenValue: string
}

/**
 * Request parameters for getInvites operation in InviteApi.
 * @export
 * @interface InviteApiGetInvitesRequest
 */
export interface InviteApiGetInvitesRequest {
    /**
     * 
     * @type {number}
     * @memberof InviteApiGetInvites
     */
    readonly limit?: number

    /**
     * 
     * @type {Role}
     * @memberof InviteApiGetInvites
     */
    readonly role?: Role

    /**
     * 
     * @type {string}
     * @memberof InviteApiGetInvites
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getTeamCreateInvites operation in InviteApi.
 * @export
 * @interface InviteApiGetTeamCreateInvitesRequest
 */
export interface InviteApiGetTeamCreateInvitesRequest {
    /**
     * 
     * @type {TeamCreateInviteQuery}
     * @memberof InviteApiGetTeamCreateInvites
     */
    readonly teamCreateInviteQuery: TeamCreateInviteQuery
}

/**
 * Request parameters for getTeamInvites operation in InviteApi.
 * @export
 * @interface InviteApiGetTeamInvitesRequest
 */
export interface InviteApiGetTeamInvitesRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiGetTeamInvites
     */
    readonly teamId: string

    /**
     * 
     * @type {string}
     * @memberof InviteApiGetTeamInvites
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for updateTeamCreationInvite operation in InviteApi.
 * @export
 * @interface InviteApiUpdateTeamCreationInviteRequest
 */
export interface InviteApiUpdateTeamCreationInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiUpdateTeamCreationInvite
     */
    readonly tokenValue: string

    /**
     * 
     * @type {TeamCreateInviteUpdateBody}
     * @memberof InviteApiUpdateTeamCreationInvite
     */
    readonly teamCreateInviteUpdateBody: TeamCreateInviteUpdateBody
}

/**
 * Request parameters for updateTeamMemberInvite operation in InviteApi.
 * @export
 * @interface InviteApiUpdateTeamMemberInviteRequest
 */
export interface InviteApiUpdateTeamMemberInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof InviteApiUpdateTeamMemberInvite
     */
    readonly teamId: string

    /**
     * 
     * @type {TrialInviteUpdateBody}
     * @memberof InviteApiUpdateTeamMemberInvite
     */
    readonly trialInviteUpdateBody: TrialInviteUpdateBody
}

/**
 * InviteApi - object-oriented interface
 * @export
 * @class InviteApi
 * @extends {BaseAPI}
 */
export class InviteApi extends BaseAPI {
    /**
     * 
     * @summary Accept an invite with a token as an existing user
     * @param {InviteApiAcceptInviteAuthorizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptInviteAuthorized(requestParameters: InviteApiAcceptInviteAuthorizedRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptInviteAuthorized(requestParameters.acceptExistingUserInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept an invite with a token as a new user
     * @param {InviteApiAcceptInviteUnauthorizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptInviteUnauthorized(requestParameters: InviteApiAcceptInviteUnauthorizedRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptInviteUnauthorized(requestParameters.acceptNewUserInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept an invite for multiple trials to be added to the users team
     * @param {InviteApiAcceptTrialInviteWithExistingTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public acceptTrialInviteWithExistingTeam(requestParameters: InviteApiAcceptTrialInviteWithExistingTeamRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).acceptTrialInviteWithExistingTeam(requestParameters.teamId, requestParameters.acceptExistingTeamInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an invite to the platform (admin, patient or reviewer)
     * @param {InviteApiCreateInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public createInvite(requestParameters: InviteApiCreateInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).createInvite(requestParameters.inviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an invite for multiple trials to be added to the users team on creation
     * @param {InviteApiCreateTeamCreationInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public createTeamCreationInvite(requestParameters: InviteApiCreateTeamCreationInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).createTeamCreationInvite(requestParameters.teamCreateInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an invite to a team.
     * @param {InviteApiCreateTeamInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public createTeamInvite(requestParameters: InviteApiCreateTeamInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).createTeamInvite(requestParameters.teamId, requestParameters.teamMemberInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an invite for multiple trials to be added to the users team on creation
     * @param {InviteApiDeleteTeamCreationInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public deleteTeamCreationInvite(requestParameters: InviteApiDeleteTeamCreationInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).deleteTeamCreationInvite(requestParameters.tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an invite of a team
     * @param {InviteApiDeleteTeamInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public deleteTeamInvite(requestParameters: InviteApiDeleteTeamInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).deleteTeamInvite(requestParameters.teamId, requestParameters.tokenValue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary View all invites to the platform
     * @param {InviteApiGetInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public getInvites(requestParameters: InviteApiGetInvitesRequest = {}, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).getInvites(requestParameters.limit, requestParameters.role, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch all invites for multiple trials to be added to the users team on creation
     * @param {InviteApiGetTeamCreateInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public getTeamCreateInvites(requestParameters: InviteApiGetTeamCreateInvitesRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).getTeamCreateInvites(requestParameters.teamCreateInviteQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invites of a specific team
     * @param {InviteApiGetTeamInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public getTeamInvites(requestParameters: InviteApiGetTeamInvitesRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).getTeamInvites(requestParameters.teamId, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an invite for multiple trials to be added to the users team on creation
     * @param {InviteApiUpdateTeamCreationInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public updateTeamCreationInvite(requestParameters: InviteApiUpdateTeamCreationInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).updateTeamCreationInvite(requestParameters.tokenValue, requestParameters.teamCreateInviteUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update an invite for a trial manager to a team.
     * @param {InviteApiUpdateTeamMemberInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InviteApi
     */
    public updateTeamMemberInvite(requestParameters: InviteApiUpdateTeamMemberInviteRequest, options?: RawAxiosRequestConfig) {
        return InviteApiFp(this.configuration).updateTeamMemberInvite(requestParameters.teamId, requestParameters.trialInviteUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LocationApi - axios parameter creator
 * @export
 */
export const LocationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary set the acceptance flow for a location. A trial can have 1 effect.
         * @param {string} id 
         * @param {LocationEffectBody} locationEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect: async (id: string, locationEffectBody: LocationEffectBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEffect', 'id', id)
            // verify required parameter 'locationEffectBody' is not null or undefined
            assertParamExists('addEffect', 'locationEffectBody', locationEffectBody)
            const localVarPath = `/location/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationEffectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLocation', 'id', id)
            const localVarPath = `/location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocation', 'id', id)
            const localVarPath = `/location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of locations with unique facility name
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset the acceptance flow for the location to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEffect', 'id', id)
            const localVarPath = `/location/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing location
         * @param {string} id 
         * @param {LocationUpdateBody} locationUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation: async (id: string, locationUpdateBody: LocationUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLocation', 'id', id)
            // verify required parameter 'locationUpdateBody' is not null or undefined
            assertParamExists('updateLocation', 'locationUpdateBody', locationUpdateBody)
            const localVarPath = `/location/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the external contact for a location (if that type of effect is present)
         * @param {string} id 
         * @param {LocationContactUpdateBody} locationContactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationContact: async (id: string, locationContactUpdateBody: LocationContactUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLocationContact', 'id', id)
            // verify required parameter 'locationContactUpdateBody' is not null or undefined
            assertParamExists('updateLocationContact', 'locationContactUpdateBody', locationContactUpdateBody)
            const localVarPath = `/location/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(locationContactUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationApi - functional programming interface
 * @export
 */
export const LocationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary set the acceptance flow for a location. A trial can have 1 effect.
         * @param {string} id 
         * @param {LocationEffectBody} locationEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEffect(id: string, locationEffectBody: LocationEffectBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEffect(id, locationEffectBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.addEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLocation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.deleteLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific location
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocation(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of locations with unique facility name
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUniqueLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reset the acceptance flow for the location to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEffect(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEffect(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.removeEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing location
         * @param {string} id 
         * @param {LocationUpdateBody} locationUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocation(id: string, locationUpdateBody: LocationUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocation(id, locationUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.updateLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the external contact for a location (if that type of effect is present)
         * @param {string} id 
         * @param {LocationContactUpdateBody} locationContactUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocationContact(id: string, locationContactUpdateBody: LocationContactUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocationContact(id, locationContactUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LocationApi.updateLocationContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LocationApi - factory interface
 * @export
 */
export const LocationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocationApiFp(configuration)
    return {
        /**
         * 
         * @summary set the acceptance flow for a location. A trial can have 1 effect.
         * @param {LocationApiAddEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect(requestParameters: LocationApiAddEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addEffect(requestParameters.id, requestParameters.locationEffectBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a location
         * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLocation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific location
         * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocation(requestParameters: LocationApiGetLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationView> {
            return localVarFp.getLocation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of locations with unique facility name
         * @param {LocationApiGetLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(requestParameters: LocationApiGetLocationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListUniqueLocationView> {
            return localVarFp.getLocations(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reset the acceptance flow for the location to the default
         * @param {LocationApiRemoveEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect(requestParameters: LocationApiRemoveEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEffect(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing location
         * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLocation(requestParameters.id, requestParameters.locationUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the external contact for a location (if that type of effect is present)
         * @param {LocationApiUpdateLocationContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocationContact(requestParameters: LocationApiUpdateLocationContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateLocationContact(requestParameters.id, requestParameters.locationContactUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addEffect operation in LocationApi.
 * @export
 * @interface LocationApiAddEffectRequest
 */
export interface LocationApiAddEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiAddEffect
     */
    readonly id: string

    /**
     * 
     * @type {LocationEffectBody}
     * @memberof LocationApiAddEffect
     */
    readonly locationEffectBody: LocationEffectBody
}

/**
 * Request parameters for deleteLocation operation in LocationApi.
 * @export
 * @interface LocationApiDeleteLocationRequest
 */
export interface LocationApiDeleteLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiDeleteLocation
     */
    readonly id: string
}

/**
 * Request parameters for getLocation operation in LocationApi.
 * @export
 * @interface LocationApiGetLocationRequest
 */
export interface LocationApiGetLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiGetLocation
     */
    readonly id: string
}

/**
 * Request parameters for getLocations operation in LocationApi.
 * @export
 * @interface LocationApiGetLocationsRequest
 */
export interface LocationApiGetLocationsRequest {
    /**
     * 
     * @type {number}
     * @memberof LocationApiGetLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof LocationApiGetLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof LocationApiGetLocations
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for removeEffect operation in LocationApi.
 * @export
 * @interface LocationApiRemoveEffectRequest
 */
export interface LocationApiRemoveEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiRemoveEffect
     */
    readonly id: string
}

/**
 * Request parameters for updateLocation operation in LocationApi.
 * @export
 * @interface LocationApiUpdateLocationRequest
 */
export interface LocationApiUpdateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiUpdateLocation
     */
    readonly id: string

    /**
     * 
     * @type {LocationUpdateBody}
     * @memberof LocationApiUpdateLocation
     */
    readonly locationUpdateBody: LocationUpdateBody
}

/**
 * Request parameters for updateLocationContact operation in LocationApi.
 * @export
 * @interface LocationApiUpdateLocationContactRequest
 */
export interface LocationApiUpdateLocationContactRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationApiUpdateLocationContact
     */
    readonly id: string

    /**
     * 
     * @type {LocationContactUpdateBody}
     * @memberof LocationApiUpdateLocationContact
     */
    readonly locationContactUpdateBody: LocationContactUpdateBody
}

/**
 * LocationApi - object-oriented interface
 * @export
 * @class LocationApi
 * @extends {BaseAPI}
 */
export class LocationApi extends BaseAPI {
    /**
     * 
     * @summary set the acceptance flow for a location. A trial can have 1 effect.
     * @param {LocationApiAddEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public addEffect(requestParameters: LocationApiAddEffectRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).addEffect(requestParameters.id, requestParameters.locationEffectBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a location
     * @param {LocationApiDeleteLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public deleteLocation(requestParameters: LocationApiDeleteLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).deleteLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific location
     * @param {LocationApiGetLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getLocation(requestParameters: LocationApiGetLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getLocation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of locations with unique facility name
     * @param {LocationApiGetLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public getLocations(requestParameters: LocationApiGetLocationsRequest = {}, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).getLocations(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reset the acceptance flow for the location to the default
     * @param {LocationApiRemoveEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public removeEffect(requestParameters: LocationApiRemoveEffectRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).removeEffect(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing location
     * @param {LocationApiUpdateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocation(requestParameters: LocationApiUpdateLocationRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).updateLocation(requestParameters.id, requestParameters.locationUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the external contact for a location (if that type of effect is present)
     * @param {LocationApiUpdateLocationContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationApi
     */
    public updateLocationContact(requestParameters: LocationApiUpdateLocationContactRequest, options?: RawAxiosRequestConfig) {
        return LocationApiFp(this.configuration).updateLocationContact(requestParameters.id, requestParameters.locationContactUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MandateApi - axios parameter creator
 * @export
 */
export const MandateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary handle webhook events sent by Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhookEvents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/mandate/webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MandateApi - functional programming interface
 * @export
 */
export const MandateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MandateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary handle webhook events sent by Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleWebhookEvents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleWebhookEvents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MandateApi.handleWebhookEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MandateApi - factory interface
 * @export
 */
export const MandateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MandateApiFp(configuration)
    return {
        /**
         * 
         * @summary handle webhook events sent by Stripe
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleWebhookEvents(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.handleWebhookEvents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MandateApi - object-oriented interface
 * @export
 * @class MandateApi
 * @extends {BaseAPI}
 */
export class MandateApi extends BaseAPI {
    /**
     * 
     * @summary handle webhook events sent by Stripe
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandateApi
     */
    public handleWebhookEvents(options?: RawAxiosRequestConfig) {
        return MandateApiFp(this.configuration).handleWebhookEvents(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get notifications.
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get count of unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadNotificationsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications/unread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary mark notifications as read.
         * @param {NotificationReadBody} notificationReadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead: async (notificationReadBody: NotificationReadBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationReadBody' is not null or undefined
            assertParamExists('markNotificationsAsRead', 'notificationReadBody', notificationReadBody)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationReadBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get notifications.
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get count of unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadNotificationsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadNotificationsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getUnreadNotificationsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary mark notifications as read.
         * @param {NotificationReadBody} notificationReadBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationsAsRead(notificationReadBody: NotificationReadBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationsAsRead(notificationReadBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary get notifications.
         * @param {NotificationsApiGetNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(requestParameters: NotificationsApiGetNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<NotificationListView> {
            return localVarFp.getNotifications(requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get count of unread notifications.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadNotificationsCount(options?: RawAxiosRequestConfig): AxiosPromise<NotificationCountView> {
            return localVarFp.getUnreadNotificationsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary mark notifications as read.
         * @param {NotificationsApiMarkNotificationsAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead(requestParameters: NotificationsApiMarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markNotificationsAsRead(requestParameters.notificationReadBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getNotifications operation in NotificationsApi.
 * @export
 * @interface NotificationsApiGetNotificationsRequest
 */
export interface NotificationsApiGetNotificationsRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationsApiGetNotifications
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof NotificationsApiGetNotifications
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for markNotificationsAsRead operation in NotificationsApi.
 * @export
 * @interface NotificationsApiMarkNotificationsAsReadRequest
 */
export interface NotificationsApiMarkNotificationsAsReadRequest {
    /**
     * 
     * @type {NotificationReadBody}
     * @memberof NotificationsApiMarkNotificationsAsRead
     */
    readonly notificationReadBody: NotificationReadBody
}

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary get notifications.
     * @param {NotificationsApiGetNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(requestParameters: NotificationsApiGetNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get count of unread notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getUnreadNotificationsCount(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getUnreadNotificationsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary mark notifications as read.
     * @param {NotificationsApiMarkNotificationsAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markNotificationsAsRead(requestParameters: NotificationsApiMarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markNotificationsAsRead(requestParameters.notificationReadBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PermissionsApi - axios parameter creator
 * @export
 */
export const PermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {TrialAccessApproveBody} trialAccessApproveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTrialAccessRequest: async (trialId: string, teamId: string, trialAccessApproveBody: TrialAccessApproveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('approveTrialAccessRequest', 'trialId', trialId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('approveTrialAccessRequest', 'teamId', teamId)
            // verify required parameter 'trialAccessApproveBody' is not null or undefined
            assertParamExists('approveTrialAccessRequest', 'trialAccessApproveBody', trialAccessApproveBody)
            const localVarPath = `/permissions/trial/{trialId}/access/{teamId}`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAccessApproveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all trial access requests.
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {boolean | null} [isExistingTrial] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequests: async (status: AccessRequestStatus, limit?: number, isExistingTrial?: boolean | null, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getAccessRequests', 'status', status)
            const localVarPath = `/permissions/access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (isExistingTrial !== undefined) {
                localVarQueryParameter['isExistingTrial'] = isExistingTrial;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
         * @param {string} trialId 
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPermissions: async (trialId: string, teamId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('getLocationPermissions', 'trialId', trialId)
            const localVarPath = `/permissions/trial/{trialId}/location`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trial access requests for a single trial.
         * @param {string} trialId 
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialAccessRequests: async (trialId: string, status: AccessRequestStatus, limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('getTrialAccessRequests', 'trialId', trialId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getTrialAccessRequests', 'status', status)
            const localVarPath = `/permissions/trial/{trialId}/access`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get permissions of a user for a trial.
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrialPermissions: async (trialId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('getUserTrialPermissions', 'trialId', trialId)
            const localVarPath = `/permissions/trial/{trialId}/user`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {string} responseMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectTrialAccessRequest: async (trialId: string, teamId: string, responseMessage: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('rejectTrialAccessRequest', 'trialId', trialId)
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('rejectTrialAccessRequest', 'teamId', teamId)
            // verify required parameter 'responseMessage' is not null or undefined
            assertParamExists('rejectTrialAccessRequest', 'responseMessage', responseMessage)
            const localVarPath = `/permissions/trial/{trialId}/access/{teamId}`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)))
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (responseMessage !== undefined) {
                localVarQueryParameter['responseMessage'] = responseMessage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request access to a trial.
         * @param {string} trialId 
         * @param {TrialAccessBody} trialAccessBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess: async (trialId: string, trialAccessBody: TrialAccessBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('requestAccess', 'trialId', trialId)
            // verify required parameter 'trialAccessBody' is not null or undefined
            assertParamExists('requestAccess', 'trialAccessBody', trialAccessBody)
            const localVarPath = `/permissions/trial/{trialId}/access`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAccessBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the permission timestamp for a single trial.
         * @param {string} trialId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionTimestamp: async (trialId: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialId' is not null or undefined
            assertParamExists('updatePermissionTimestamp', 'trialId', trialId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updatePermissionTimestamp', 'body', body)
            const localVarPath = `/permissions/trial/{trialId}/permission-timestamp`
                .replace(`{${"trialId"}}`, encodeURIComponent(String(trialId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PermissionsApi - functional programming interface
 * @export
 */
export const PermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {TrialAccessApproveBody} trialAccessApproveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveTrialAccessRequest(trialId: string, teamId: string, trialAccessApproveBody: TrialAccessApproveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveTrialAccessRequest(trialId, teamId, trialAccessApproveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.approveTrialAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all trial access requests.
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {boolean | null} [isExistingTrial] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccessRequests(status: AccessRequestStatus, limit?: number, isExistingTrial?: boolean | null, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTrialAccessListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccessRequests(status, limit, isExistingTrial, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
         * @param {string} trialId 
         * @param {string | null} [teamId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocationPermissions(trialId: string, teamId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialLocationPermissionsListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocationPermissions(trialId, teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getLocationPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get trial access requests for a single trial.
         * @param {string} trialId 
         * @param {AccessRequestStatus} status 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialAccessRequests(trialId: string, status: AccessRequestStatus, limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialAccessListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialAccessRequests(trialId, status, limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getTrialAccessRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get permissions of a user for a trial.
         * @param {string} trialId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTrialPermissions(trialId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialPermissionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTrialPermissions(trialId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.getUserTrialPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a trial request access.
         * @param {string} trialId 
         * @param {string} teamId 
         * @param {string} responseMessage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectTrialAccessRequest(trialId: string, teamId: string, responseMessage: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectTrialAccessRequest(trialId, teamId, responseMessage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.rejectTrialAccessRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request access to a trial.
         * @param {string} trialId 
         * @param {TrialAccessBody} trialAccessBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccess(trialId: string, trialAccessBody: TrialAccessBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccess(trialId, trialAccessBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.requestAccess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the permission timestamp for a single trial.
         * @param {string} trialId 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePermissionTimestamp(trialId: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePermissionTimestamp(trialId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PermissionsApi.updatePermissionTimestamp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PermissionsApi - factory interface
 * @export
 */
export const PermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PermissionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve a trial request access.
         * @param {PermissionsApiApproveTrialAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTrialAccessRequest(requestParameters: PermissionsApiApproveTrialAccessRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.trialAccessApproveBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all trial access requests.
         * @param {PermissionsApiGetAccessRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessRequests(requestParameters: PermissionsApiGetAccessRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTrialAccessListView> {
            return localVarFp.getAccessRequests(requestParameters.status, requestParameters.limit, requestParameters.isExistingTrial, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
         * @param {PermissionsApiGetLocationPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocationPermissions(requestParameters: PermissionsApiGetLocationPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialLocationPermissionsListView> {
            return localVarFp.getLocationPermissions(requestParameters.trialId, requestParameters.teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trial access requests for a single trial.
         * @param {PermissionsApiGetTrialAccessRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialAccessRequests(requestParameters: PermissionsApiGetTrialAccessRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialAccessListView> {
            return localVarFp.getTrialAccessRequests(requestParameters.trialId, requestParameters.status, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get permissions of a user for a trial.
         * @param {PermissionsApiGetUserTrialPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTrialPermissions(requestParameters: PermissionsApiGetUserTrialPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialPermissionsView> {
            return localVarFp.getUserTrialPermissions(requestParameters.trialId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a trial request access.
         * @param {PermissionsApiRejectTrialAccessRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectTrialAccessRequest(requestParameters: PermissionsApiRejectTrialAccessRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.responseMessage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request access to a trial.
         * @param {PermissionsApiRequestAccessRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccess(requestParameters: PermissionsApiRequestAccessRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestAccess(requestParameters.trialId, requestParameters.trialAccessBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the permission timestamp for a single trial.
         * @param {PermissionsApiUpdatePermissionTimestampRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePermissionTimestamp(requestParameters: PermissionsApiUpdatePermissionTimestampRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updatePermissionTimestamp(requestParameters.trialId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveTrialAccessRequest operation in PermissionsApi.
 * @export
 * @interface PermissionsApiApproveTrialAccessRequestRequest
 */
export interface PermissionsApiApproveTrialAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiApproveTrialAccessRequest
     */
    readonly trialId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiApproveTrialAccessRequest
     */
    readonly teamId: string

    /**
     * 
     * @type {TrialAccessApproveBody}
     * @memberof PermissionsApiApproveTrialAccessRequest
     */
    readonly trialAccessApproveBody: TrialAccessApproveBody
}

/**
 * Request parameters for getAccessRequests operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetAccessRequestsRequest
 */
export interface PermissionsApiGetAccessRequestsRequest {
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly status: AccessRequestStatus

    /**
     * 
     * @type {number}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {boolean}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly isExistingTrial?: boolean | null

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetAccessRequests
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getLocationPermissions operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetLocationPermissionsRequest
 */
export interface PermissionsApiGetLocationPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetLocationPermissions
     */
    readonly trialId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetLocationPermissions
     */
    readonly teamId?: string | null
}

/**
 * Request parameters for getTrialAccessRequests operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetTrialAccessRequestsRequest
 */
export interface PermissionsApiGetTrialAccessRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly trialId: string

    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly status: AccessRequestStatus

    /**
     * 
     * @type {number}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetTrialAccessRequests
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getUserTrialPermissions operation in PermissionsApi.
 * @export
 * @interface PermissionsApiGetUserTrialPermissionsRequest
 */
export interface PermissionsApiGetUserTrialPermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiGetUserTrialPermissions
     */
    readonly trialId: string
}

/**
 * Request parameters for rejectTrialAccessRequest operation in PermissionsApi.
 * @export
 * @interface PermissionsApiRejectTrialAccessRequestRequest
 */
export interface PermissionsApiRejectTrialAccessRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRejectTrialAccessRequest
     */
    readonly trialId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRejectTrialAccessRequest
     */
    readonly teamId: string

    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRejectTrialAccessRequest
     */
    readonly responseMessage: string
}

/**
 * Request parameters for requestAccess operation in PermissionsApi.
 * @export
 * @interface PermissionsApiRequestAccessRequest
 */
export interface PermissionsApiRequestAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiRequestAccess
     */
    readonly trialId: string

    /**
     * 
     * @type {TrialAccessBody}
     * @memberof PermissionsApiRequestAccess
     */
    readonly trialAccessBody: TrialAccessBody
}

/**
 * Request parameters for updatePermissionTimestamp operation in PermissionsApi.
 * @export
 * @interface PermissionsApiUpdatePermissionTimestampRequest
 */
export interface PermissionsApiUpdatePermissionTimestampRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionsApiUpdatePermissionTimestamp
     */
    readonly trialId: string

    /**
     * 
     * @type {object}
     * @memberof PermissionsApiUpdatePermissionTimestamp
     */
    readonly body: object
}

/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
export class PermissionsApi extends BaseAPI {
    /**
     * 
     * @summary Approve a trial request access.
     * @param {PermissionsApiApproveTrialAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public approveTrialAccessRequest(requestParameters: PermissionsApiApproveTrialAccessRequestRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).approveTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.trialAccessApproveBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all trial access requests.
     * @param {PermissionsApiGetAccessRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getAccessRequests(requestParameters: PermissionsApiGetAccessRequestsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getAccessRequests(requestParameters.status, requestParameters.limit, requestParameters.isExistingTrial, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get count of contact permissions for a team. The count can be used to check whether this is the final person with contact details permissions in a team.
     * @param {PermissionsApiGetLocationPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getLocationPermissions(requestParameters: PermissionsApiGetLocationPermissionsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getLocationPermissions(requestParameters.trialId, requestParameters.teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trial access requests for a single trial.
     * @param {PermissionsApiGetTrialAccessRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getTrialAccessRequests(requestParameters: PermissionsApiGetTrialAccessRequestsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getTrialAccessRequests(requestParameters.trialId, requestParameters.status, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get permissions of a user for a trial.
     * @param {PermissionsApiGetUserTrialPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public getUserTrialPermissions(requestParameters: PermissionsApiGetUserTrialPermissionsRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).getUserTrialPermissions(requestParameters.trialId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a trial request access.
     * @param {PermissionsApiRejectTrialAccessRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public rejectTrialAccessRequest(requestParameters: PermissionsApiRejectTrialAccessRequestRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).rejectTrialAccessRequest(requestParameters.trialId, requestParameters.teamId, requestParameters.responseMessage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request access to a trial.
     * @param {PermissionsApiRequestAccessRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public requestAccess(requestParameters: PermissionsApiRequestAccessRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).requestAccess(requestParameters.trialId, requestParameters.trialAccessBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the permission timestamp for a single trial.
     * @param {PermissionsApiUpdatePermissionTimestampRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    public updatePermissionTimestamp(requestParameters: PermissionsApiUpdatePermissionTimestampRequest, options?: RawAxiosRequestConfig) {
        return PermissionsApiFp(this.configuration).updatePermissionTimestamp(requestParameters.trialId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PreferencesApi - axios parameter creator
 * @export
 */
export const PreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {any} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPreferences: async (subscriptionId: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscriptionPreferences', 'subscriptionId', subscriptionId)
            const localVarPath = `/preferences/subscription/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {string} subscriptionId 
         * @param {any} key 
         * @param {SubscriptionPreferencesBody} subscriptionPreferencesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreferences: async (subscriptionId: string, key: any, subscriptionPreferencesBody: SubscriptionPreferencesBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscriptionPreferences', 'subscriptionId', subscriptionId)
            // verify required parameter 'key' is not null or undefined
            assertParamExists('updateSubscriptionPreferences', 'key', key)
            // verify required parameter 'subscriptionPreferencesBody' is not null or undefined
            assertParamExists('updateSubscriptionPreferences', 'subscriptionPreferencesBody', subscriptionPreferencesBody)
            const localVarPath = `/preferences/subscription/{subscriptionId}/key/{key}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscriptionPreferencesBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreferencesApi - functional programming interface
 * @export
 */
export const PreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {any} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionPreferences(subscriptionId: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPreferencesListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionPreferences(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.getSubscriptionPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {string} subscriptionId 
         * @param {any} key 
         * @param {SubscriptionPreferencesBody} subscriptionPreferencesBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionPreferences(subscriptionId: string, key: any, subscriptionPreferencesBody: SubscriptionPreferencesBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPreferenceView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionPreferences(subscriptionId, key, subscriptionPreferencesBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreferencesApi.updateSubscriptionPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PreferencesApi - factory interface
 * @export
 */
export const PreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {PreferencesApiGetSubscriptionPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionPreferences(requestParameters: PreferencesApiGetSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPreferencesListView> {
            return localVarFp.getSubscriptionPreferences(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get preferences of a subscription.
         * @param {PreferencesApiUpdateSubscriptionPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreferences(requestParameters: PreferencesApiUpdateSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPreferenceView> {
            return localVarFp.updateSubscriptionPreferences(requestParameters.subscriptionId, requestParameters.key, requestParameters.subscriptionPreferencesBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getSubscriptionPreferences operation in PreferencesApi.
 * @export
 * @interface PreferencesApiGetSubscriptionPreferencesRequest
 */
export interface PreferencesApiGetSubscriptionPreferencesRequest {
    /**
     * 
     * @type {any}
     * @memberof PreferencesApiGetSubscriptionPreferences
     */
    readonly subscriptionId: any
}

/**
 * Request parameters for updateSubscriptionPreferences operation in PreferencesApi.
 * @export
 * @interface PreferencesApiUpdateSubscriptionPreferencesRequest
 */
export interface PreferencesApiUpdateSubscriptionPreferencesRequest {
    /**
     * 
     * @type {string}
     * @memberof PreferencesApiUpdateSubscriptionPreferences
     */
    readonly subscriptionId: string

    /**
     * 
     * @type {any}
     * @memberof PreferencesApiUpdateSubscriptionPreferences
     */
    readonly key: any

    /**
     * 
     * @type {SubscriptionPreferencesBody}
     * @memberof PreferencesApiUpdateSubscriptionPreferences
     */
    readonly subscriptionPreferencesBody: SubscriptionPreferencesBody
}

/**
 * PreferencesApi - object-oriented interface
 * @export
 * @class PreferencesApi
 * @extends {BaseAPI}
 */
export class PreferencesApi extends BaseAPI {
    /**
     * 
     * @summary get preferences of a subscription.
     * @param {PreferencesApiGetSubscriptionPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public getSubscriptionPreferences(requestParameters: PreferencesApiGetSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).getSubscriptionPreferences(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get preferences of a subscription.
     * @param {PreferencesApiUpdateSubscriptionPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferencesApi
     */
    public updateSubscriptionPreferences(requestParameters: PreferencesApiUpdateSubscriptionPreferencesRequest, options?: RawAxiosRequestConfig) {
        return PreferencesApiFp(this.configuration).updateSubscriptionPreferences(requestParameters.subscriptionId, requestParameters.key, requestParameters.subscriptionPreferencesBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user metadata
         * @param {UpdateMetadataBody} updateMetadataBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata: async (updateMetadataBody: UpdateMetadataBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMetadataBody' is not null or undefined
            assertParamExists('updateMetadata', 'updateMetadataBody', updateMetadataBody)
            const localVarPath = `/profile/metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMetadataBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set new password after validating previous password
         * @param {UpdatePasswordBody} updatePasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword: async (updatePasswordBody: UpdatePasswordBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePasswordBody' is not null or undefined
            assertParamExists('updatePassword', 'updatePasswordBody', updatePasswordBody)
            const localVarPath = `/profile/passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user details
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile: async (updateProfileBody: UpdateProfileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileBody' is not null or undefined
            assertParamExists('updateProfile', 'updateProfileBody', updateProfileBody)
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow admin to update user details
         * @param {string} id 
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileAsAdmin: async (id: string, updateProfileBody: UpdateProfileBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProfileAsAdmin', 'id', id)
            // verify required parameter 'updateProfileBody' is not null or undefined
            assertParamExists('updateProfileAsAdmin', 'updateProfileBody', updateProfileBody)
            const localVarPath = `/profile/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetadataView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.getMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user metadata
         * @param {UpdateMetadataBody} updateMetadataBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMetadata(updateMetadataBody: UpdateMetadataBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMetadata(updateMetadataBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set new password after validating previous password
         * @param {UpdatePasswordBody} updatePasswordBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePassword(updatePasswordBody: UpdatePasswordBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePassword(updatePasswordBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updatePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user details
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfile(updateProfileBody: UpdateProfileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(updateProfileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allow admin to update user details
         * @param {string} id 
         * @param {UpdateProfileBody} updateProfileBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileAsAdmin(id: string, updateProfileBody: UpdateProfileBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileAsAdmin(id, updateProfileBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateProfileAsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user metadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadata(options?: RawAxiosRequestConfig): AxiosPromise<MetadataView> {
            return localVarFp.getMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user metadata
         * @param {ProfileApiUpdateMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMetadata(requestParameters: ProfileApiUpdateMetadataRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMetadata(requestParameters.updateMetadataBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set new password after validating previous password
         * @param {ProfileApiUpdatePasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePassword(requestParameters: ProfileApiUpdatePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoginView> {
            return localVarFp.updatePassword(requestParameters.updatePasswordBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user details
         * @param {ProfileApiUpdateProfileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfile(requestParameters: ProfileApiUpdateProfileRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProfile(requestParameters.updateProfileBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow admin to update user details
         * @param {ProfileApiUpdateProfileAsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileAsAdmin(requestParameters: ProfileApiUpdateProfileAsAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProfileAsAdmin(requestParameters.id, requestParameters.updateProfileBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateMetadata operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateMetadataRequest
 */
export interface ProfileApiUpdateMetadataRequest {
    /**
     * 
     * @type {UpdateMetadataBody}
     * @memberof ProfileApiUpdateMetadata
     */
    readonly updateMetadataBody: UpdateMetadataBody
}

/**
 * Request parameters for updatePassword operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdatePasswordRequest
 */
export interface ProfileApiUpdatePasswordRequest {
    /**
     * 
     * @type {UpdatePasswordBody}
     * @memberof ProfileApiUpdatePassword
     */
    readonly updatePasswordBody: UpdatePasswordBody
}

/**
 * Request parameters for updateProfile operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateProfileRequest
 */
export interface ProfileApiUpdateProfileRequest {
    /**
     * 
     * @type {UpdateProfileBody}
     * @memberof ProfileApiUpdateProfile
     */
    readonly updateProfileBody: UpdateProfileBody
}

/**
 * Request parameters for updateProfileAsAdmin operation in ProfileApi.
 * @export
 * @interface ProfileApiUpdateProfileAsAdminRequest
 */
export interface ProfileApiUpdateProfileAsAdminRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfileApiUpdateProfileAsAdmin
     */
    readonly id: string

    /**
     * 
     * @type {UpdateProfileBody}
     * @memberof ProfileApiUpdateProfileAsAdmin
     */
    readonly updateProfileBody: UpdateProfileBody
}

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @summary Get user metadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public getMetadata(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).getMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user metadata
     * @param {ProfileApiUpdateMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateMetadata(requestParameters: ProfileApiUpdateMetadataRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateMetadata(requestParameters.updateMetadataBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set new password after validating previous password
     * @param {ProfileApiUpdatePasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updatePassword(requestParameters: ProfileApiUpdatePasswordRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updatePassword(requestParameters.updatePasswordBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user details
     * @param {ProfileApiUpdateProfileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateProfile(requestParameters: ProfileApiUpdateProfileRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateProfile(requestParameters.updateProfileBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow admin to update user details
     * @param {ProfileApiUpdateProfileAsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateProfileAsAdmin(requestParameters: ProfileApiUpdateProfileAsAdminRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateProfileAsAdmin(requestParameters.id, requestParameters.updateProfileBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionsApi - axios parameter creator
 * @export
 */
export const QuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a category to a question
         * @param {string} id 
         * @param {AddQuestionCategoryBody} addQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionCategory: async (id: string, addQuestionCategoryBody: AddQuestionCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addQuestionCategory', 'id', id)
            // verify required parameter 'addQuestionCategoryBody' is not null or undefined
            assertParamExists('addQuestionCategory', 'addQuestionCategoryBody', addQuestionCategoryBody)
            const localVarPath = `/questions/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addQuestionCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add an option to a question
         * @param {string} id 
         * @param {QuestionOptionBody} questionOptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionOption: async (id: string, questionOptionBody: QuestionOptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addQuestionOption', 'id', id)
            // verify required parameter 'questionOptionBody' is not null or undefined
            assertParamExists('addQuestionOption', 'questionOptionBody', questionOptionBody)
            const localVarPath = `/questions/{id}/options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionOptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary bulk delete questions
         * @param {QuestionBulkDelete} questionBulkDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteQuestion: async (questionBulkDelete: QuestionBulkDelete, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionBulkDelete' is not null or undefined
            assertParamExists('bulkDeleteQuestion', 'questionBulkDelete', questionBulkDelete)
            const localVarPath = `/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionBulkDelete, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a question, try to avoid using this endpoint by using existing questions
         * @param {QuestionBody} questionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion: async (questionBody: QuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionBody' is not null or undefined
            assertParamExists('createQuestion', 'questionBody', questionBody)
            const localVarPath = `/questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create the dependencies of a question
         * @param {string} id 
         * @param {QuestionDependencyBody} questionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionDependency: async (id: string, questionDependencyBody: QuestionDependencyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createQuestionDependency', 'id', id)
            // verify required parameter 'questionDependencyBody' is not null or undefined
            assertParamExists('createQuestionDependency', 'questionDependencyBody', questionDependencyBody)
            const localVarPath = `/questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionDependencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add translations to a question
         * @param {string} id 
         * @param {QuestionTranslationBody} questionTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionTranslations: async (id: string, questionTranslationBody: QuestionTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createQuestionTranslations', 'id', id)
            // verify required parameter 'questionTranslationBody' is not null or undefined
            assertParamExists('createQuestionTranslations', 'questionTranslationBody', questionTranslationBody)
            const localVarPath = `/questions/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteQuestion', 'id', id)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an option from a question
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionOption: async (questionId: string, optionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('deleteQuestionOption', 'questionId', questionId)
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('deleteQuestionOption', 'optionId', optionId)
            const localVarPath = `/questions/{questionId}/options/{optionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"optionId"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch categories of a question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {CategoryType} [categoryType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {CategoryOrderBy} [orderBy] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCategories: async (id: string, limit?: number | null, offset?: number | null, categoryType?: CategoryType, orderDirection?: OrderDirection, orderBy?: CategoryOrderBy, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionCategories', 'id', id)
            const localVarPath = `/questions/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (categoryType !== undefined) {
                localVarQueryParameter['categoryType'] = categoryType;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the trial (criteria) that the question is linked to
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [diseaseSearchString] 
         * @param {string} [leadSponsorSearchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCriteria: async (id: string, limit?: number | null, offset?: number | null, diseaseSearchString?: string, leadSponsorSearchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionCriteria', 'id', id)
            const localVarPath = `/questions/{id}/criteria`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (diseaseSearchString !== undefined) {
                localVarQueryParameter['diseaseSearchString'] = diseaseSearchString;
            }

            if (leadSponsorSearchString !== undefined) {
                localVarQueryParameter['leadSponsorSearchString'] = leadSponsorSearchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the dependencies of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDependencies: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionDependencies', 'id', id)
            const localVarPath = `/questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionDetails', 'id', id)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the options and their translations the specified question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionOptions: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionOptions', 'id', id)
            const localVarPath = `/questions/{id}/options`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the translations of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getQuestionTranslations', 'id', id)
            const localVarPath = `/questions/{id}/translations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the search string
         * @param {GetQuestionsBody} getQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestions: async (getQuestionsBody: GetQuestionsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getQuestionsBody' is not null or undefined
            assertParamExists('getQuestions', 'getQuestionsBody', getQuestionsBody)
            const localVarPath = `/questions/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getQuestionsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the specified question
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimilarQuestions: async (currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currentVersionOnly' is not null or undefined
            assertParamExists('getSimilarQuestions', 'currentVersionOnly', currentVersionOnly)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSimilarQuestions', 'id', id)
            const localVarPath = `/questions/{id}/similar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (currentVersionOnly !== undefined) {
                localVarQueryParameter['currentVersionOnly'] = currentVersionOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the suggested questions of the specified question
         * @param {number} threshold 
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedQuestions: async (threshold: number, currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threshold' is not null or undefined
            assertParamExists('getSuggestedQuestions', 'threshold', threshold)
            // verify required parameter 'currentVersionOnly' is not null or undefined
            assertParamExists('getSuggestedQuestions', 'currentVersionOnly', currentVersionOnly)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSuggestedQuestions', 'id', id)
            const localVarPath = `/questions/{id}/suggested`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }

            if (currentVersionOnly !== undefined) {
                localVarQueryParameter['currentVersionOnly'] = currentVersionOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Exclude a question from the merge suggestions of the given question
         * @param {string} id 
         * @param {QuestionIgnoreMergeBody} questionIgnoreMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreMerge: async (id: string, questionIgnoreMergeBody: QuestionIgnoreMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('ignoreMerge', 'id', id)
            // verify required parameter 'questionIgnoreMergeBody' is not null or undefined
            assertParamExists('ignoreMerge', 'questionIgnoreMergeBody', questionIgnoreMergeBody)
            const localVarPath = `/questions/{id}/ignore/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionIgnoreMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary merge this question into the specified target question.
         * @param {string} id 
         * @param {QuestionMergeBody} questionMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeQuestions: async (id: string, questionMergeBody: QuestionMergeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('mergeQuestions', 'id', id)
            // verify required parameter 'questionMergeBody' is not null or undefined
            assertParamExists('mergeQuestions', 'questionMergeBody', questionMergeBody)
            const localVarPath = `/questions/{id}/merge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionMergeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a category from a question
         * @param {string} id 
         * @param {RemoveQuestionCategoryBody} removeQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQuestionCategory: async (id: string, removeQuestionCategoryBody: RemoveQuestionCategoryBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeQuestionCategory', 'id', id)
            // verify required parameter 'removeQuestionCategoryBody' is not null or undefined
            assertParamExists('removeQuestionCategory', 'removeQuestionCategoryBody', removeQuestionCategoryBody)
            const localVarPath = `/questions/{id}/categories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeQuestionCategoryBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new chat entry to re-answer a question
         * @param {string} id 
         * @param {RetryQuestionBody} retryQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryQuestion: async (id: string, retryQuestionBody: RetryQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryQuestion', 'id', id)
            // verify required parameter 'retryQuestionBody' is not null or undefined
            assertParamExists('retryQuestion', 'retryQuestionBody', retryQuestionBody)
            const localVarPath = `/questions/{id}/chat/entry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retryQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the details of a question, no relations will be affected by this
         * @param {string} id 
         * @param {QuestionUpdateBody} questionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion: async (id: string, questionUpdateBody: QuestionUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateQuestion', 'id', id)
            // verify required parameter 'questionUpdateBody' is not null or undefined
            assertParamExists('updateQuestion', 'questionUpdateBody', questionUpdateBody)
            const localVarPath = `/questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the translations of an option to a question
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {QuestionOptionTranslationBody} questionOptionTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionOptionTranslations: async (questionId: string, optionId: string, questionOptionTranslationBody: QuestionOptionTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updateQuestionOptionTranslations', 'questionId', questionId)
            // verify required parameter 'optionId' is not null or undefined
            assertParamExists('updateQuestionOptionTranslations', 'optionId', optionId)
            // verify required parameter 'questionOptionTranslationBody' is not null or undefined
            assertParamExists('updateQuestionOptionTranslations', 'questionOptionTranslationBody', questionOptionTranslationBody)
            const localVarPath = `/questions/{questionId}/options/{optionId}`
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)))
                .replace(`{${"optionId"}}`, encodeURIComponent(String(optionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionOptionTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionsApi - functional programming interface
 * @export
 */
export const QuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a category to a question
         * @param {string} id 
         * @param {AddQuestionCategoryBody} addQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addQuestionCategory(id: string, addQuestionCategoryBody: AddQuestionCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addQuestionCategory(id, addQuestionCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.addQuestionCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add an option to a question
         * @param {string} id 
         * @param {QuestionOptionBody} questionOptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addQuestionOption(id: string, questionOptionBody: QuestionOptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionOptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addQuestionOption(id, questionOptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.addQuestionOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary bulk delete questions
         * @param {QuestionBulkDelete} questionBulkDelete 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteQuestion(questionBulkDelete: QuestionBulkDelete, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteQuestion(questionBulkDelete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.bulkDeleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a question, try to avoid using this endpoint by using existing questions
         * @param {QuestionBody} questionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestion(questionBody: QuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestion(questionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create the dependencies of a question
         * @param {string} id 
         * @param {QuestionDependencyBody} questionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestionDependency(id: string, questionDependencyBody: QuestionDependencyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDependencyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestionDependency(id, questionDependencyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestionDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add translations to a question
         * @param {string} id 
         * @param {QuestionTranslationBody} questionTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQuestionTranslations(id: string, questionTranslationBody: QuestionTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQuestionTranslations(id, questionTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.createQuestionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.deleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an option from a question
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteQuestionOption(questionId: string, optionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteQuestionOption(questionId, optionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.deleteQuestionOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch categories of a question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {CategoryType} [categoryType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {CategoryOrderBy} [orderBy] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionCategories(id: string, limit?: number | null, offset?: number | null, categoryType?: CategoryType, orderDirection?: OrderDirection, orderBy?: CategoryOrderBy, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionCategoryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionCategories(id, limit, offset, categoryType, orderDirection, orderBy, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the trial (criteria) that the question is linked to
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [diseaseSearchString] 
         * @param {string} [leadSponsorSearchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionCriteria(id: string, limit?: number | null, offset?: number | null, diseaseSearchString?: string, leadSponsorSearchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionCriteriaListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionCriteria(id, limit, offset, diseaseSearchString, leadSponsorSearchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the dependencies of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionDependencies(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDependencyListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionDependencies(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionDependencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the options and their translations the specified question
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionOptions(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionOptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionOptions(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the translations of a question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the search string
         * @param {GetQuestionsBody} getQuestionsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestions(getQuestionsBody: GetQuestionsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionCountListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestions(getQuestionsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the specified question
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSimilarQuestions(currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSimilarQuestions(currentVersionOnly, id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getSimilarQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the suggested questions of the specified question
         * @param {number} threshold 
         * @param {boolean | null} currentVersionOnly 
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestedQuestions(threshold: number, currentVersionOnly: boolean | null, id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestedQuestions(threshold, currentVersionOnly, id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.getSuggestedQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Exclude a question from the merge suggestions of the given question
         * @param {string} id 
         * @param {QuestionIgnoreMergeBody} questionIgnoreMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreMerge(id: string, questionIgnoreMergeBody: QuestionIgnoreMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreMerge(id, questionIgnoreMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.ignoreMerge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary merge this question into the specified target question.
         * @param {string} id 
         * @param {QuestionMergeBody} questionMergeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeQuestions(id: string, questionMergeBody: QuestionMergeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeQuestions(id, questionMergeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.mergeQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a category from a question
         * @param {string} id 
         * @param {RemoveQuestionCategoryBody} removeQuestionCategoryBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeQuestionCategory(id: string, removeQuestionCategoryBody: RemoveQuestionCategoryBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeQuestionCategory(id, removeQuestionCategoryBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.removeQuestionCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new chat entry to re-answer a question
         * @param {string} id 
         * @param {RetryQuestionBody} retryQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryQuestion(id: string, retryQuestionBody: RetryQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryQuestion(id, retryQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.retryQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the details of a question, no relations will be affected by this
         * @param {string} id 
         * @param {QuestionUpdateBody} questionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestion(id: string, questionUpdateBody: QuestionUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestion(id, questionUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the translations of an option to a question
         * @param {string} questionId 
         * @param {string} optionId 
         * @param {QuestionOptionTranslationBody} questionOptionTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionOptionTranslations(questionId: string, optionId: string, questionOptionTranslationBody: QuestionOptionTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionOptionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionOptionTranslations(questionId, optionId, questionOptionTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionsApi.updateQuestionOptionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionsApi - factory interface
 * @export
 */
export const QuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a category to a question
         * @param {QuestionsApiAddQuestionCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionCategory(requestParameters: QuestionsApiAddQuestionCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addQuestionCategory(requestParameters.id, requestParameters.addQuestionCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add an option to a question
         * @param {QuestionsApiAddQuestionOptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addQuestionOption(requestParameters: QuestionsApiAddQuestionOptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionOptionView> {
            return localVarFp.addQuestionOption(requestParameters.id, requestParameters.questionOptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary bulk delete questions
         * @param {QuestionsApiBulkDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteQuestion(requestParameters: QuestionsApiBulkDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkDeleteQuestion(requestParameters.questionBulkDelete, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a question, try to avoid using this endpoint by using existing questions
         * @param {QuestionsApiCreateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestion(requestParameters: QuestionsApiCreateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionView> {
            return localVarFp.createQuestion(requestParameters.questionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create the dependencies of a question
         * @param {QuestionsApiCreateQuestionDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionDependency(requestParameters: QuestionsApiCreateQuestionDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDependencyView> {
            return localVarFp.createQuestionDependency(requestParameters.id, requestParameters.questionDependencyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add translations to a question
         * @param {QuestionsApiCreateQuestionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQuestionTranslations(requestParameters: QuestionsApiCreateQuestionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionTranslationView> {
            return localVarFp.createQuestionTranslations(requestParameters.id, requestParameters.questionTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete a question
         * @param {QuestionsApiDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestion(requestParameters: QuestionsApiDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuestion(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an option from a question
         * @param {QuestionsApiDeleteQuestionOptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteQuestionOption(requestParameters: QuestionsApiDeleteQuestionOptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteQuestionOption(requestParameters.questionId, requestParameters.optionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch categories of a question
         * @param {QuestionsApiGetQuestionCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCategories(requestParameters: QuestionsApiGetQuestionCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionCategoryView> {
            return localVarFp.getQuestionCategories(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.categoryType, requestParameters.orderDirection, requestParameters.orderBy, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the trial (criteria) that the question is linked to
         * @param {QuestionsApiGetQuestionCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionCriteria(requestParameters: QuestionsApiGetQuestionCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionCriteriaListView> {
            return localVarFp.getQuestionCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.diseaseSearchString, requestParameters.leadSponsorSearchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the dependencies of a question
         * @param {QuestionsApiGetQuestionDependenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDependencies(requestParameters: QuestionsApiGetQuestionDependenciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDependencyListView> {
            return localVarFp.getQuestionDependencies(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a question
         * @param {QuestionsApiGetQuestionDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionDetails(requestParameters: QuestionsApiGetQuestionDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsView> {
            return localVarFp.getQuestionDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the options and their translations the specified question
         * @param {QuestionsApiGetQuestionOptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionOptions(requestParameters: QuestionsApiGetQuestionOptionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionOptionView> {
            return localVarFp.getQuestionOptions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the translations of a question
         * @param {QuestionsApiGetQuestionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionTranslations(requestParameters: QuestionsApiGetQuestionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionTranslationView> {
            return localVarFp.getQuestionTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the search string
         * @param {QuestionsApiGetQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestions(requestParameters: QuestionsApiGetQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionCountListView> {
            return localVarFp.getQuestions(requestParameters.getQuestionsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the nearest neighbor questions of the specified question
         * @param {QuestionsApiGetSimilarQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSimilarQuestions(requestParameters: QuestionsApiGetSimilarQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionView> {
            return localVarFp.getSimilarQuestions(requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the suggested questions of the specified question
         * @param {QuestionsApiGetSuggestedQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestedQuestions(requestParameters: QuestionsApiGetSuggestedQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListQuestionView> {
            return localVarFp.getSuggestedQuestions(requestParameters.threshold, requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Exclude a question from the merge suggestions of the given question
         * @param {QuestionsApiIgnoreMergeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreMerge(requestParameters: QuestionsApiIgnoreMergeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ignoreMerge(requestParameters.id, requestParameters.questionIgnoreMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary merge this question into the specified target question.
         * @param {QuestionsApiMergeQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeQuestions(requestParameters: QuestionsApiMergeQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsView> {
            return localVarFp.mergeQuestions(requestParameters.id, requestParameters.questionMergeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a category from a question
         * @param {QuestionsApiRemoveQuestionCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQuestionCategory(requestParameters: QuestionsApiRemoveQuestionCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeQuestionCategory(requestParameters.id, requestParameters.removeQuestionCategoryBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new chat entry to re-answer a question
         * @param {QuestionsApiRetryQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryQuestion(requestParameters: QuestionsApiRetryQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.retryQuestion(requestParameters.id, requestParameters.retryQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the details of a question, no relations will be affected by this
         * @param {QuestionsApiUpdateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestion(requestParameters: QuestionsApiUpdateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionDetailsView> {
            return localVarFp.updateQuestion(requestParameters.id, requestParameters.questionUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the translations of an option to a question
         * @param {QuestionsApiUpdateQuestionOptionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionOptionTranslations(requestParameters: QuestionsApiUpdateQuestionOptionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionOptionView> {
            return localVarFp.updateQuestionOptionTranslations(requestParameters.questionId, requestParameters.optionId, requestParameters.questionOptionTranslationBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addQuestionCategory operation in QuestionsApi.
 * @export
 * @interface QuestionsApiAddQuestionCategoryRequest
 */
export interface QuestionsApiAddQuestionCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiAddQuestionCategory
     */
    readonly id: string

    /**
     * 
     * @type {AddQuestionCategoryBody}
     * @memberof QuestionsApiAddQuestionCategory
     */
    readonly addQuestionCategoryBody: AddQuestionCategoryBody
}

/**
 * Request parameters for addQuestionOption operation in QuestionsApi.
 * @export
 * @interface QuestionsApiAddQuestionOptionRequest
 */
export interface QuestionsApiAddQuestionOptionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiAddQuestionOption
     */
    readonly id: string

    /**
     * 
     * @type {QuestionOptionBody}
     * @memberof QuestionsApiAddQuestionOption
     */
    readonly questionOptionBody: QuestionOptionBody
}

/**
 * Request parameters for bulkDeleteQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiBulkDeleteQuestionRequest
 */
export interface QuestionsApiBulkDeleteQuestionRequest {
    /**
     * 
     * @type {QuestionBulkDelete}
     * @memberof QuestionsApiBulkDeleteQuestion
     */
    readonly questionBulkDelete: QuestionBulkDelete
}

/**
 * Request parameters for createQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionRequest
 */
export interface QuestionsApiCreateQuestionRequest {
    /**
     * 
     * @type {QuestionBody}
     * @memberof QuestionsApiCreateQuestion
     */
    readonly questionBody: QuestionBody
}

/**
 * Request parameters for createQuestionDependency operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionDependencyRequest
 */
export interface QuestionsApiCreateQuestionDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiCreateQuestionDependency
     */
    readonly id: string

    /**
     * 
     * @type {QuestionDependencyBody}
     * @memberof QuestionsApiCreateQuestionDependency
     */
    readonly questionDependencyBody: QuestionDependencyBody
}

/**
 * Request parameters for createQuestionTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiCreateQuestionTranslationsRequest
 */
export interface QuestionsApiCreateQuestionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiCreateQuestionTranslations
     */
    readonly id: string

    /**
     * 
     * @type {QuestionTranslationBody}
     * @memberof QuestionsApiCreateQuestionTranslations
     */
    readonly questionTranslationBody: QuestionTranslationBody
}

/**
 * Request parameters for deleteQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiDeleteQuestionRequest
 */
export interface QuestionsApiDeleteQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiDeleteQuestion
     */
    readonly id: string
}

/**
 * Request parameters for deleteQuestionOption operation in QuestionsApi.
 * @export
 * @interface QuestionsApiDeleteQuestionOptionRequest
 */
export interface QuestionsApiDeleteQuestionOptionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiDeleteQuestionOption
     */
    readonly questionId: string

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiDeleteQuestionOption
     */
    readonly optionId: string
}

/**
 * Request parameters for getQuestionCategories operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionCategoriesRequest
 */
export interface QuestionsApiGetQuestionCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly offset?: number | null

    /**
     * 
     * @type {CategoryType}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly categoryType?: CategoryType

    /**
     * 
     * @type {OrderDirection}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {CategoryOrderBy}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly orderBy?: CategoryOrderBy

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCategories
     */
    readonly searchString?: string
}

/**
 * Request parameters for getQuestionCriteria operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionCriteriaRequest
 */
export interface QuestionsApiGetQuestionCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly diseaseSearchString?: string

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionCriteria
     */
    readonly leadSponsorSearchString?: string
}

/**
 * Request parameters for getQuestionDependencies operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionDependenciesRequest
 */
export interface QuestionsApiGetQuestionDependenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionDependencies
     */
    readonly id: string
}

/**
 * Request parameters for getQuestionDetails operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionDetailsRequest
 */
export interface QuestionsApiGetQuestionDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionDetails
     */
    readonly id: string
}

/**
 * Request parameters for getQuestionOptions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionOptionsRequest
 */
export interface QuestionsApiGetQuestionOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionOptions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionOptions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetQuestionOptions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getQuestionTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionTranslationsRequest
 */
export interface QuestionsApiGetQuestionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetQuestionTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetQuestionsRequest
 */
export interface QuestionsApiGetQuestionsRequest {
    /**
     * 
     * @type {GetQuestionsBody}
     * @memberof QuestionsApiGetQuestions
     */
    readonly getQuestionsBody: GetQuestionsBody
}

/**
 * Request parameters for getSimilarQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetSimilarQuestionsRequest
 */
export interface QuestionsApiGetSimilarQuestionsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly currentVersionOnly: boolean | null

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSimilarQuestions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getSuggestedQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiGetSuggestedQuestionsRequest
 */
export interface QuestionsApiGetSuggestedQuestionsRequest {
    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly threshold: number

    /**
     * 
     * @type {boolean}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly currentVersionOnly: boolean | null

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof QuestionsApiGetSuggestedQuestions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for ignoreMerge operation in QuestionsApi.
 * @export
 * @interface QuestionsApiIgnoreMergeRequest
 */
export interface QuestionsApiIgnoreMergeRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiIgnoreMerge
     */
    readonly id: string

    /**
     * 
     * @type {QuestionIgnoreMergeBody}
     * @memberof QuestionsApiIgnoreMerge
     */
    readonly questionIgnoreMergeBody: QuestionIgnoreMergeBody
}

/**
 * Request parameters for mergeQuestions operation in QuestionsApi.
 * @export
 * @interface QuestionsApiMergeQuestionsRequest
 */
export interface QuestionsApiMergeQuestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiMergeQuestions
     */
    readonly id: string

    /**
     * 
     * @type {QuestionMergeBody}
     * @memberof QuestionsApiMergeQuestions
     */
    readonly questionMergeBody: QuestionMergeBody
}

/**
 * Request parameters for removeQuestionCategory operation in QuestionsApi.
 * @export
 * @interface QuestionsApiRemoveQuestionCategoryRequest
 */
export interface QuestionsApiRemoveQuestionCategoryRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiRemoveQuestionCategory
     */
    readonly id: string

    /**
     * 
     * @type {RemoveQuestionCategoryBody}
     * @memberof QuestionsApiRemoveQuestionCategory
     */
    readonly removeQuestionCategoryBody: RemoveQuestionCategoryBody
}

/**
 * Request parameters for retryQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiRetryQuestionRequest
 */
export interface QuestionsApiRetryQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiRetryQuestion
     */
    readonly id: string

    /**
     * 
     * @type {RetryQuestionBody}
     * @memberof QuestionsApiRetryQuestion
     */
    readonly retryQuestionBody: RetryQuestionBody
}

/**
 * Request parameters for updateQuestion operation in QuestionsApi.
 * @export
 * @interface QuestionsApiUpdateQuestionRequest
 */
export interface QuestionsApiUpdateQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiUpdateQuestion
     */
    readonly id: string

    /**
     * 
     * @type {QuestionUpdateBody}
     * @memberof QuestionsApiUpdateQuestion
     */
    readonly questionUpdateBody: QuestionUpdateBody
}

/**
 * Request parameters for updateQuestionOptionTranslations operation in QuestionsApi.
 * @export
 * @interface QuestionsApiUpdateQuestionOptionTranslationsRequest
 */
export interface QuestionsApiUpdateQuestionOptionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionsApiUpdateQuestionOptionTranslations
     */
    readonly questionId: string

    /**
     * 
     * @type {string}
     * @memberof QuestionsApiUpdateQuestionOptionTranslations
     */
    readonly optionId: string

    /**
     * 
     * @type {QuestionOptionTranslationBody}
     * @memberof QuestionsApiUpdateQuestionOptionTranslations
     */
    readonly questionOptionTranslationBody: QuestionOptionTranslationBody
}

/**
 * QuestionsApi - object-oriented interface
 * @export
 * @class QuestionsApi
 * @extends {BaseAPI}
 */
export class QuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Add a category to a question
     * @param {QuestionsApiAddQuestionCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public addQuestionCategory(requestParameters: QuestionsApiAddQuestionCategoryRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).addQuestionCategory(requestParameters.id, requestParameters.addQuestionCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add an option to a question
     * @param {QuestionsApiAddQuestionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public addQuestionOption(requestParameters: QuestionsApiAddQuestionOptionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).addQuestionOption(requestParameters.id, requestParameters.questionOptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary bulk delete questions
     * @param {QuestionsApiBulkDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public bulkDeleteQuestion(requestParameters: QuestionsApiBulkDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).bulkDeleteQuestion(requestParameters.questionBulkDelete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a question, try to avoid using this endpoint by using existing questions
     * @param {QuestionsApiCreateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestion(requestParameters: QuestionsApiCreateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestion(requestParameters.questionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create the dependencies of a question
     * @param {QuestionsApiCreateQuestionDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestionDependency(requestParameters: QuestionsApiCreateQuestionDependencyRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestionDependency(requestParameters.id, requestParameters.questionDependencyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add translations to a question
     * @param {QuestionsApiCreateQuestionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public createQuestionTranslations(requestParameters: QuestionsApiCreateQuestionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).createQuestionTranslations(requestParameters.id, requestParameters.questionTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete a question
     * @param {QuestionsApiDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public deleteQuestion(requestParameters: QuestionsApiDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).deleteQuestion(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an option from a question
     * @param {QuestionsApiDeleteQuestionOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public deleteQuestionOption(requestParameters: QuestionsApiDeleteQuestionOptionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).deleteQuestionOption(requestParameters.questionId, requestParameters.optionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch categories of a question
     * @param {QuestionsApiGetQuestionCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionCategories(requestParameters: QuestionsApiGetQuestionCategoriesRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionCategories(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.categoryType, requestParameters.orderDirection, requestParameters.orderBy, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the trial (criteria) that the question is linked to
     * @param {QuestionsApiGetQuestionCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionCriteria(requestParameters: QuestionsApiGetQuestionCriteriaRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.diseaseSearchString, requestParameters.leadSponsorSearchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the dependencies of a question
     * @param {QuestionsApiGetQuestionDependenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionDependencies(requestParameters: QuestionsApiGetQuestionDependenciesRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionDependencies(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a question
     * @param {QuestionsApiGetQuestionDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionDetails(requestParameters: QuestionsApiGetQuestionDetailsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the options and their translations the specified question
     * @param {QuestionsApiGetQuestionOptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionOptions(requestParameters: QuestionsApiGetQuestionOptionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionOptions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the translations of a question
     * @param {QuestionsApiGetQuestionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestionTranslations(requestParameters: QuestionsApiGetQuestionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestionTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the nearest neighbor questions of the search string
     * @param {QuestionsApiGetQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getQuestions(requestParameters: QuestionsApiGetQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getQuestions(requestParameters.getQuestionsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the nearest neighbor questions of the specified question
     * @param {QuestionsApiGetSimilarQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getSimilarQuestions(requestParameters: QuestionsApiGetSimilarQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getSimilarQuestions(requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the suggested questions of the specified question
     * @param {QuestionsApiGetSuggestedQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public getSuggestedQuestions(requestParameters: QuestionsApiGetSuggestedQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).getSuggestedQuestions(requestParameters.threshold, requestParameters.currentVersionOnly, requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Exclude a question from the merge suggestions of the given question
     * @param {QuestionsApiIgnoreMergeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public ignoreMerge(requestParameters: QuestionsApiIgnoreMergeRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).ignoreMerge(requestParameters.id, requestParameters.questionIgnoreMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary merge this question into the specified target question.
     * @param {QuestionsApiMergeQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public mergeQuestions(requestParameters: QuestionsApiMergeQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).mergeQuestions(requestParameters.id, requestParameters.questionMergeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a category from a question
     * @param {QuestionsApiRemoveQuestionCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public removeQuestionCategory(requestParameters: QuestionsApiRemoveQuestionCategoryRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).removeQuestionCategory(requestParameters.id, requestParameters.removeQuestionCategoryBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new chat entry to re-answer a question
     * @param {QuestionsApiRetryQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public retryQuestion(requestParameters: QuestionsApiRetryQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).retryQuestion(requestParameters.id, requestParameters.retryQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the details of a question, no relations will be affected by this
     * @param {QuestionsApiUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestion(requestParameters: QuestionsApiUpdateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestion(requestParameters.id, requestParameters.questionUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the translations of an option to a question
     * @param {QuestionsApiUpdateQuestionOptionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionsApi
     */
    public updateQuestionOptionTranslations(requestParameters: QuestionsApiUpdateQuestionOptionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return QuestionsApiFp(this.configuration).updateQuestionOptionTranslations(requestParameters.questionId, requestParameters.optionId, requestParameters.questionOptionTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyDependencyApi - axios parameter creator
 * @export
 */
export const SurveyDependencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a survey dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyDependency: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSurveyDependency', 'id', id)
            const localVarPath = `/survey-dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing survey dependency
         * @param {string} id 
         * @param {SurveyDependencyUpdateBody} surveyDependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyDependency: async (id: string, surveyDependencyUpdateBody: SurveyDependencyUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSurveyDependency', 'id', id)
            // verify required parameter 'surveyDependencyUpdateBody' is not null or undefined
            assertParamExists('updateSurveyDependency', 'surveyDependencyUpdateBody', surveyDependencyUpdateBody)
            const localVarPath = `/survey-dependency/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyDependencyUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyDependencyApi - functional programming interface
 * @export
 */
export const SurveyDependencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyDependencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a survey dependency
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyDependency(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyDependency(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyDependencyApi.deleteSurveyDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing survey dependency
         * @param {string} id 
         * @param {SurveyDependencyUpdateBody} surveyDependencyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurveyDependency(id: string, surveyDependencyUpdateBody: SurveyDependencyUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurveyDependency(id, surveyDependencyUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyDependencyApi.updateSurveyDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyDependencyApi - factory interface
 * @export
 */
export const SurveyDependencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyDependencyApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a survey dependency
         * @param {SurveyDependencyApiDeleteSurveyDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyDependency(requestParameters: SurveyDependencyApiDeleteSurveyDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurveyDependency(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing survey dependency
         * @param {SurveyDependencyApiUpdateSurveyDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyDependency(requestParameters: SurveyDependencyApiUpdateSurveyDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSurveyDependency(requestParameters.id, requestParameters.surveyDependencyUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteSurveyDependency operation in SurveyDependencyApi.
 * @export
 * @interface SurveyDependencyApiDeleteSurveyDependencyRequest
 */
export interface SurveyDependencyApiDeleteSurveyDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyDependencyApiDeleteSurveyDependency
     */
    readonly id: string
}

/**
 * Request parameters for updateSurveyDependency operation in SurveyDependencyApi.
 * @export
 * @interface SurveyDependencyApiUpdateSurveyDependencyRequest
 */
export interface SurveyDependencyApiUpdateSurveyDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyDependencyApiUpdateSurveyDependency
     */
    readonly id: string

    /**
     * 
     * @type {SurveyDependencyUpdateBody}
     * @memberof SurveyDependencyApiUpdateSurveyDependency
     */
    readonly surveyDependencyUpdateBody: SurveyDependencyUpdateBody
}

/**
 * SurveyDependencyApi - object-oriented interface
 * @export
 * @class SurveyDependencyApi
 * @extends {BaseAPI}
 */
export class SurveyDependencyApi extends BaseAPI {
    /**
     * 
     * @summary Delete a survey dependency
     * @param {SurveyDependencyApiDeleteSurveyDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDependencyApi
     */
    public deleteSurveyDependency(requestParameters: SurveyDependencyApiDeleteSurveyDependencyRequest, options?: RawAxiosRequestConfig) {
        return SurveyDependencyApiFp(this.configuration).deleteSurveyDependency(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing survey dependency
     * @param {SurveyDependencyApiUpdateSurveyDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyDependencyApi
     */
    public updateSurveyDependency(requestParameters: SurveyDependencyApiUpdateSurveyDependencyRequest, options?: RawAxiosRequestConfig) {
        return SurveyDependencyApiFp(this.configuration).updateSurveyDependency(requestParameters.id, requestParameters.surveyDependencyUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyManagementApi - axios parameter creator
 * @export
 */
export const SurveyManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create translations for the description of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDescriptionTranslations: async (id: string, surveyTranslationBody: SurveyTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createDescriptionTranslations', 'id', id)
            // verify required parameter 'surveyTranslationBody' is not null or undefined
            assertParamExists('createDescriptionTranslations', 'surveyTranslationBody', surveyTranslationBody)
            const localVarPath = `/survey-management/{id}/translations:description`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new survey
         * @param {SurveyCreateBody} surveyCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey: async (surveyCreateBody: SurveyCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'surveyCreateBody' is not null or undefined
            assertParamExists('createSurvey', 'surveyCreateBody', surveyCreateBody)
            const localVarPath = `/survey-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a survey question
         * @param {string} id 
         * @param {SurveyQuestionBody} surveyQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestion: async (id: string, surveyQuestionBody: SurveyQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSurveyQuestion', 'id', id)
            // verify required parameter 'surveyQuestionBody' is not null or undefined
            assertParamExists('createSurveyQuestion', 'surveyQuestionBody', surveyQuestionBody)
            const localVarPath = `/survey-management/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create translations for the title of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations: async (id: string, surveyTranslationBody: SurveyTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTitleTranslations', 'id', id)
            // verify required parameter 'surveyTranslationBody' is not null or undefined
            assertParamExists('createTitleTranslations', 'surveyTranslationBody', surveyTranslationBody)
            const localVarPath = `/survey-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSurvey', 'id', id)
            const localVarPath = `/survey-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the paginated list of translations of the description of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDescriptionTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDescriptionTranslations', 'id', id)
            const localVarPath = `/survey-management/{id}/translations:description`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of responses to a specific survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponseOverview: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResponseOverview', 'id', id)
            const localVarPath = `/survey-management/{id}/responses/overview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get survey details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSurveyDetails', 'id', id)
            const localVarPath = `/survey-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get questions for a survey
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestions: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSurveyQuestions', 'id', id)
            const localVarPath = `/survey-management/{id}/questions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of all surveys
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {SurveyStatus} [status] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {SurveyOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys: async (limit?: number | null, offset?: number | null, status?: SurveyStatus, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: SurveyOrderBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/survey-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the paginated list of translations of the title of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTitleTranslations', 'id', id)
            const localVarPath = `/survey-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary refresh the potential count of participants for a specific survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPotentialCount: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refreshPotentialCount', 'id', id)
            const localVarPath = `/survey-management/{id}/refresh-potential-count`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSurvey: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendSurvey', 'id', id)
            const localVarPath = `/survey-management/{id}/send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a survey
         * @param {string} id 
         * @param {SurveyUpdateBody} surveyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey: async (id: string, surveyUpdateBody: SurveyUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSurvey', 'id', id)
            // verify required parameter 'surveyUpdateBody' is not null or undefined
            assertParamExists('updateSurvey', 'surveyUpdateBody', surveyUpdateBody)
            const localVarPath = `/survey-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyManagementApi - functional programming interface
 * @export
 */
export const SurveyManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create translations for the description of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDescriptionTranslations(id: string, surveyTranslationBody: SurveyTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDescriptionTranslations(id, surveyTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createDescriptionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new survey
         * @param {SurveyCreateBody} surveyCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurvey(surveyCreateBody: SurveyCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurvey(surveyCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a survey question
         * @param {string} id 
         * @param {SurveyQuestionBody} surveyQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurveyQuestion(id: string, surveyQuestionBody: SurveyQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurveyQuestion(id, surveyQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create translations for the title of a survey
         * @param {string} id 
         * @param {SurveyTranslationBody} surveyTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTitleTranslations(id: string, surveyTranslationBody: SurveyTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTitleTranslations(id, surveyTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.createTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurvey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurvey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.deleteSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the paginated list of translations of the description of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDescriptionTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDescriptionTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getDescriptionTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of responses to a specific survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResponseOverview(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyResponseOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResponseOverview(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getResponseOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get survey details
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveyDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get questions for a survey
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyQuestions(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyQuestionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyQuestions(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of all surveys
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {SurveyStatus} [status] 
         * @param {string | null} [searchString] 
         * @param {OrderDirection} [orderDirection] 
         * @param {SurveyOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveys(limit?: number | null, offset?: number | null, status?: SurveyStatus, searchString?: string | null, orderDirection?: OrderDirection, orderBy?: SurveyOrderBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveys(limit, offset, status, searchString, orderDirection, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getSurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the paginated list of translations of the title of a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTitleTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListSurveyTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTitleTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.getTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary refresh the potential count of participants for a specific survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshPotentialCount(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyPotentialCountView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshPotentialCount(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.refreshPotentialCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a survey
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSurvey(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSurvey(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.sendSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a survey
         * @param {string} id 
         * @param {SurveyUpdateBody} surveyUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurvey(id: string, surveyUpdateBody: SurveyUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurvey(id, surveyUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyManagementApi.updateSurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyManagementApi - factory interface
 * @export
 */
export const SurveyManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Create translations for the description of a survey
         * @param {SurveyManagementApiCreateDescriptionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDescriptionTranslations(requestParameters: SurveyManagementApiCreateDescriptionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.createDescriptionTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new survey
         * @param {SurveyManagementApiCreateSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurvey(requestParameters: SurveyManagementApiCreateSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyView> {
            return localVarFp.createSurvey(requestParameters.surveyCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a survey question
         * @param {SurveyManagementApiCreateSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestion(requestParameters: SurveyManagementApiCreateSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyQuestionView> {
            return localVarFp.createSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create translations for the title of a survey
         * @param {SurveyManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations(requestParameters: SurveyManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.createTitleTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a survey
         * @param {SurveyManagementApiDeleteSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurvey(requestParameters: SurveyManagementApiDeleteSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurvey(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the paginated list of translations of the description of a survey
         * @param {SurveyManagementApiGetDescriptionTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDescriptionTranslations(requestParameters: SurveyManagementApiGetDescriptionTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.getDescriptionTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of responses to a specific survey
         * @param {SurveyManagementApiGetResponseOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResponseOverview(requestParameters: SurveyManagementApiGetResponseOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyResponseOverviewView> {
            return localVarFp.getResponseOverview(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get survey details
         * @param {SurveyManagementApiGetSurveyDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyDetails(requestParameters: SurveyManagementApiGetSurveyDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyDetailsView> {
            return localVarFp.getSurveyDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get questions for a survey
         * @param {SurveyManagementApiGetSurveyQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestions(requestParameters: SurveyManagementApiGetSurveyQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyQuestionView> {
            return localVarFp.getSurveyQuestions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of all surveys
         * @param {SurveyManagementApiGetSurveysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveys(requestParameters: SurveyManagementApiGetSurveysRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyView> {
            return localVarFp.getSurveys(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the paginated list of translations of the title of a survey
         * @param {SurveyManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations(requestParameters: SurveyManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListSurveyTranslationView> {
            return localVarFp.getTitleTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary refresh the potential count of participants for a specific survey
         * @param {SurveyManagementApiRefreshPotentialCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshPotentialCount(requestParameters: SurveyManagementApiRefreshPotentialCountRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyPotentialCountView> {
            return localVarFp.refreshPotentialCount(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a survey
         * @param {SurveyManagementApiSendSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSurvey(requestParameters: SurveyManagementApiSendSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendSurvey(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a survey
         * @param {SurveyManagementApiUpdateSurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurvey(requestParameters: SurveyManagementApiUpdateSurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSurvey(requestParameters.id, requestParameters.surveyUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createDescriptionTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateDescriptionTranslationsRequest
 */
export interface SurveyManagementApiCreateDescriptionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiCreateDescriptionTranslations
     */
    readonly id: string

    /**
     * 
     * @type {SurveyTranslationBody}
     * @memberof SurveyManagementApiCreateDescriptionTranslations
     */
    readonly surveyTranslationBody: SurveyTranslationBody
}

/**
 * Request parameters for createSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateSurveyRequest
 */
export interface SurveyManagementApiCreateSurveyRequest {
    /**
     * 
     * @type {SurveyCreateBody}
     * @memberof SurveyManagementApiCreateSurvey
     */
    readonly surveyCreateBody: SurveyCreateBody
}

/**
 * Request parameters for createSurveyQuestion operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateSurveyQuestionRequest
 */
export interface SurveyManagementApiCreateSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiCreateSurveyQuestion
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionBody}
     * @memberof SurveyManagementApiCreateSurveyQuestion
     */
    readonly surveyQuestionBody: SurveyQuestionBody
}

/**
 * Request parameters for createTitleTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiCreateTitleTranslationsRequest
 */
export interface SurveyManagementApiCreateTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiCreateTitleTranslations
     */
    readonly id: string

    /**
     * 
     * @type {SurveyTranslationBody}
     * @memberof SurveyManagementApiCreateTitleTranslations
     */
    readonly surveyTranslationBody: SurveyTranslationBody
}

/**
 * Request parameters for deleteSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiDeleteSurveyRequest
 */
export interface SurveyManagementApiDeleteSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiDeleteSurvey
     */
    readonly id: string
}

/**
 * Request parameters for getDescriptionTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetDescriptionTranslationsRequest
 */
export interface SurveyManagementApiGetDescriptionTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetDescriptionTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getResponseOverview operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetResponseOverviewRequest
 */
export interface SurveyManagementApiGetResponseOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetResponseOverview
     */
    readonly id: string
}

/**
 * Request parameters for getSurveyDetails operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetSurveyDetailsRequest
 */
export interface SurveyManagementApiGetSurveyDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetSurveyDetails
     */
    readonly id: string
}

/**
 * Request parameters for getSurveyQuestions operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetSurveyQuestionsRequest
 */
export interface SurveyManagementApiGetSurveyQuestionsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetSurveyQuestions
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveyQuestions
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveyQuestions
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getSurveys operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetSurveysRequest
 */
export interface SurveyManagementApiGetSurveysRequest {
    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly offset?: number | null

    /**
     * 
     * @type {SurveyStatus}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly status?: SurveyStatus

    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly searchString?: string | null

    /**
     * 
     * @type {OrderDirection}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {SurveyOrderBy}
     * @memberof SurveyManagementApiGetSurveys
     */
    readonly orderBy?: SurveyOrderBy
}

/**
 * Request parameters for getTitleTranslations operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiGetTitleTranslationsRequest
 */
export interface SurveyManagementApiGetTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiGetTitleTranslations
     */
    readonly id: string
}

/**
 * Request parameters for refreshPotentialCount operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiRefreshPotentialCountRequest
 */
export interface SurveyManagementApiRefreshPotentialCountRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiRefreshPotentialCount
     */
    readonly id: string
}

/**
 * Request parameters for sendSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiSendSurveyRequest
 */
export interface SurveyManagementApiSendSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiSendSurvey
     */
    readonly id: string
}

/**
 * Request parameters for updateSurvey operation in SurveyManagementApi.
 * @export
 * @interface SurveyManagementApiUpdateSurveyRequest
 */
export interface SurveyManagementApiUpdateSurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyManagementApiUpdateSurvey
     */
    readonly id: string

    /**
     * 
     * @type {SurveyUpdateBody}
     * @memberof SurveyManagementApiUpdateSurvey
     */
    readonly surveyUpdateBody: SurveyUpdateBody
}

/**
 * SurveyManagementApi - object-oriented interface
 * @export
 * @class SurveyManagementApi
 * @extends {BaseAPI}
 */
export class SurveyManagementApi extends BaseAPI {
    /**
     * 
     * @summary Create translations for the description of a survey
     * @param {SurveyManagementApiCreateDescriptionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createDescriptionTranslations(requestParameters: SurveyManagementApiCreateDescriptionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createDescriptionTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new survey
     * @param {SurveyManagementApiCreateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createSurvey(requestParameters: SurveyManagementApiCreateSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createSurvey(requestParameters.surveyCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a survey question
     * @param {SurveyManagementApiCreateSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createSurveyQuestion(requestParameters: SurveyManagementApiCreateSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create translations for the title of a survey
     * @param {SurveyManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public createTitleTranslations(requestParameters: SurveyManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).createTitleTranslations(requestParameters.id, requestParameters.surveyTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a survey
     * @param {SurveyManagementApiDeleteSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public deleteSurvey(requestParameters: SurveyManagementApiDeleteSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).deleteSurvey(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the paginated list of translations of the description of a survey
     * @param {SurveyManagementApiGetDescriptionTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getDescriptionTranslations(requestParameters: SurveyManagementApiGetDescriptionTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getDescriptionTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of responses to a specific survey
     * @param {SurveyManagementApiGetResponseOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getResponseOverview(requestParameters: SurveyManagementApiGetResponseOverviewRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getResponseOverview(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get survey details
     * @param {SurveyManagementApiGetSurveyDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveyDetails(requestParameters: SurveyManagementApiGetSurveyDetailsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveyDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get questions for a survey
     * @param {SurveyManagementApiGetSurveyQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveyQuestions(requestParameters: SurveyManagementApiGetSurveyQuestionsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveyQuestions(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of all surveys
     * @param {SurveyManagementApiGetSurveysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getSurveys(requestParameters: SurveyManagementApiGetSurveysRequest = {}, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getSurveys(requestParameters.limit, requestParameters.offset, requestParameters.status, requestParameters.searchString, requestParameters.orderDirection, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the paginated list of translations of the title of a survey
     * @param {SurveyManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public getTitleTranslations(requestParameters: SurveyManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).getTitleTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary refresh the potential count of participants for a specific survey
     * @param {SurveyManagementApiRefreshPotentialCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public refreshPotentialCount(requestParameters: SurveyManagementApiRefreshPotentialCountRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).refreshPotentialCount(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a survey
     * @param {SurveyManagementApiSendSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public sendSurvey(requestParameters: SurveyManagementApiSendSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).sendSurvey(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a survey
     * @param {SurveyManagementApiUpdateSurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyManagementApi
     */
    public updateSurvey(requestParameters: SurveyManagementApiUpdateSurveyRequest, options?: RawAxiosRequestConfig) {
        return SurveyManagementApiFp(this.configuration).updateSurvey(requestParameters.id, requestParameters.surveyUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SurveyQuestionsApi - axios parameter creator
 * @export
 */
export const SurveyQuestionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create the dependencies of a survey question
         * @param {string} id 
         * @param {SurveyQuestionDependencyBody} surveyQuestionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestionDependency: async (id: string, surveyQuestionDependencyBody: SurveyQuestionDependencyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSurveyQuestionDependency', 'id', id)
            // verify required parameter 'surveyQuestionDependencyBody' is not null or undefined
            assertParamExists('createSurveyQuestionDependency', 'surveyQuestionDependencyBody', surveyQuestionDependencyBody)
            const localVarPath = `/survey-questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionDependencyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyQuestion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSurveyQuestion', 'id', id)
            const localVarPath = `/survey-questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the dependencies of a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestionDependencies: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSurveyQuestionDependencies', 'id', id)
            const localVarPath = `/survey-questions/{id}/dependencies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change the position of a survey question
         * @param {string} id 
         * @param {SurveyQuestionMoveBody} surveyQuestionMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSurveyQuestion: async (id: string, surveyQuestionMoveBody: SurveyQuestionMoveBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('moveSurveyQuestion', 'id', id)
            // verify required parameter 'surveyQuestionMoveBody' is not null or undefined
            assertParamExists('moveSurveyQuestion', 'surveyQuestionMoveBody', surveyQuestionMoveBody)
            const localVarPath = `/survey-questions/{id}/move`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionMoveBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change any of the properties of a survey question
         * @param {string} id 
         * @param {SurveyQuestionUpdateBody} surveyQuestionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyQuestion: async (id: string, surveyQuestionUpdateBody: SurveyQuestionUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSurveyQuestion', 'id', id)
            // verify required parameter 'surveyQuestionUpdateBody' is not null or undefined
            assertParamExists('updateSurveyQuestion', 'surveyQuestionUpdateBody', surveyQuestionUpdateBody)
            const localVarPath = `/survey-questions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(surveyQuestionUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SurveyQuestionsApi - functional programming interface
 * @export
 */
export const SurveyQuestionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SurveyQuestionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create the dependencies of a survey question
         * @param {string} id 
         * @param {SurveyQuestionDependencyBody} surveyQuestionDependencyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSurveyQuestionDependency(id: string, surveyQuestionDependencyBody: SurveyQuestionDependencyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyQuestionDependencyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSurveyQuestionDependency(id, surveyQuestionDependencyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.createSurveyQuestionDependency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSurveyQuestion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSurveyQuestion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.deleteSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the dependencies of a survey question
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveyQuestionDependencies(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveyQuestionDependencyListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveyQuestionDependencies(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.getSurveyQuestionDependencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change the position of a survey question
         * @param {string} id 
         * @param {SurveyQuestionMoveBody} surveyQuestionMoveBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveSurveyQuestion(id: string, surveyQuestionMoveBody: SurveyQuestionMoveBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveSurveyQuestion(id, surveyQuestionMoveBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.moveSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary change any of the properties of a survey question
         * @param {string} id 
         * @param {SurveyQuestionUpdateBody} surveyQuestionUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSurveyQuestion(id: string, surveyQuestionUpdateBody: SurveyQuestionUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSurveyQuestion(id, surveyQuestionUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SurveyQuestionsApi.updateSurveyQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SurveyQuestionsApi - factory interface
 * @export
 */
export const SurveyQuestionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SurveyQuestionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create the dependencies of a survey question
         * @param {SurveyQuestionsApiCreateSurveyQuestionDependencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSurveyQuestionDependency(requestParameters: SurveyQuestionsApiCreateSurveyQuestionDependencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyQuestionDependencyView> {
            return localVarFp.createSurveyQuestionDependency(requestParameters.id, requestParameters.surveyQuestionDependencyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a survey question
         * @param {SurveyQuestionsApiDeleteSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSurveyQuestion(requestParameters: SurveyQuestionsApiDeleteSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSurveyQuestion(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the dependencies of a survey question
         * @param {SurveyQuestionsApiGetSurveyQuestionDependenciesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveyQuestionDependencies(requestParameters: SurveyQuestionsApiGetSurveyQuestionDependenciesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SurveyQuestionDependencyListView> {
            return localVarFp.getSurveyQuestionDependencies(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change the position of a survey question
         * @param {SurveyQuestionsApiMoveSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveSurveyQuestion(requestParameters: SurveyQuestionsApiMoveSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.moveSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionMoveBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change any of the properties of a survey question
         * @param {SurveyQuestionsApiUpdateSurveyQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSurveyQuestion(requestParameters: SurveyQuestionsApiUpdateSurveyQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionUpdateBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createSurveyQuestionDependency operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiCreateSurveyQuestionDependencyRequest
 */
export interface SurveyQuestionsApiCreateSurveyQuestionDependencyRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiCreateSurveyQuestionDependency
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionDependencyBody}
     * @memberof SurveyQuestionsApiCreateSurveyQuestionDependency
     */
    readonly surveyQuestionDependencyBody: SurveyQuestionDependencyBody
}

/**
 * Request parameters for deleteSurveyQuestion operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiDeleteSurveyQuestionRequest
 */
export interface SurveyQuestionsApiDeleteSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiDeleteSurveyQuestion
     */
    readonly id: string
}

/**
 * Request parameters for getSurveyQuestionDependencies operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiGetSurveyQuestionDependenciesRequest
 */
export interface SurveyQuestionsApiGetSurveyQuestionDependenciesRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiGetSurveyQuestionDependencies
     */
    readonly id: string
}

/**
 * Request parameters for moveSurveyQuestion operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiMoveSurveyQuestionRequest
 */
export interface SurveyQuestionsApiMoveSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiMoveSurveyQuestion
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionMoveBody}
     * @memberof SurveyQuestionsApiMoveSurveyQuestion
     */
    readonly surveyQuestionMoveBody: SurveyQuestionMoveBody
}

/**
 * Request parameters for updateSurveyQuestion operation in SurveyQuestionsApi.
 * @export
 * @interface SurveyQuestionsApiUpdateSurveyQuestionRequest
 */
export interface SurveyQuestionsApiUpdateSurveyQuestionRequest {
    /**
     * 
     * @type {string}
     * @memberof SurveyQuestionsApiUpdateSurveyQuestion
     */
    readonly id: string

    /**
     * 
     * @type {SurveyQuestionUpdateBody}
     * @memberof SurveyQuestionsApiUpdateSurveyQuestion
     */
    readonly surveyQuestionUpdateBody: SurveyQuestionUpdateBody
}

/**
 * SurveyQuestionsApi - object-oriented interface
 * @export
 * @class SurveyQuestionsApi
 * @extends {BaseAPI}
 */
export class SurveyQuestionsApi extends BaseAPI {
    /**
     * 
     * @summary Create the dependencies of a survey question
     * @param {SurveyQuestionsApiCreateSurveyQuestionDependencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public createSurveyQuestionDependency(requestParameters: SurveyQuestionsApiCreateSurveyQuestionDependencyRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).createSurveyQuestionDependency(requestParameters.id, requestParameters.surveyQuestionDependencyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a survey question
     * @param {SurveyQuestionsApiDeleteSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public deleteSurveyQuestion(requestParameters: SurveyQuestionsApiDeleteSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).deleteSurveyQuestion(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the dependencies of a survey question
     * @param {SurveyQuestionsApiGetSurveyQuestionDependenciesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public getSurveyQuestionDependencies(requestParameters: SurveyQuestionsApiGetSurveyQuestionDependenciesRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).getSurveyQuestionDependencies(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change the position of a survey question
     * @param {SurveyQuestionsApiMoveSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public moveSurveyQuestion(requestParameters: SurveyQuestionsApiMoveSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).moveSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionMoveBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change any of the properties of a survey question
     * @param {SurveyQuestionsApiUpdateSurveyQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SurveyQuestionsApi
     */
    public updateSurveyQuestion(requestParameters: SurveyQuestionsApiUpdateSurveyQuestionRequest, options?: RawAxiosRequestConfig) {
        return SurveyQuestionsApiFp(this.configuration).updateSurveyQuestion(requestParameters.id, requestParameters.surveyQuestionUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamApi - axios parameter creator
 * @export
 */
export const TeamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a trial to a team
         * @param {string} id 
         * @param {TeamTrialBody} teamTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamTrial: async (id: string, teamTrialBody: TeamTrialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTeamTrial', 'id', id)
            // verify required parameter 'teamTrialBody' is not null or undefined
            assertParamExists('addTeamTrial', 'teamTrialBody', teamTrialBody)
            const localVarPath = `/team/{id}/trials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamTrialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new team
         * @param {TeamBody} teamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (teamBody: TeamBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamBody' is not null or undefined
            assertParamExists('createTeam', 'teamBody', teamBody)
            const localVarPath = `/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start a new Stripe checkout session to start a new subscription
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutSession: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCheckoutSession', 'id', id)
            const localVarPath = `/team/{id}/subscription/checkout`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get url to the Stripe billing portal of the team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalURL: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomerPortalURL', 'id', id)
            const localVarPath = `/team/{id}/subscription/portal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the details of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamDetails', 'id', id)
            const localVarPath = `/team/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the members of a team
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembers: async (id: string, limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamMembers', 'id', id)
            const localVarPath = `/team/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the trials of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamTrials: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeamTrials', 'id', id)
            const localVarPath = `/team/{id}/trials`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all teams
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a team
         * @param {string} id 
         * @param {TeamUpdateBody} teamUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (id: string, teamUpdateBody: TeamUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTeam', 'id', id)
            // verify required parameter 'teamUpdateBody' is not null or undefined
            assertParamExists('updateTeam', 'teamUpdateBody', teamUpdateBody)
            const localVarPath = `/team/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the membership of a user of a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TeamMemberBody} teamMemberBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMembership: async (id: string, userId: string, teamMemberBody: TeamMemberBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTeamMembership', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateTeamMembership', 'userId', userId)
            // verify required parameter 'teamMemberBody' is not null or undefined
            assertParamExists('updateTeamMembership', 'teamMemberBody', teamMemberBody)
            const localVarPath = `/team/{id}/members/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamMemberBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamApi - functional programming interface
 * @export
 */
export const TeamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a trial to a team
         * @param {string} id 
         * @param {TeamTrialBody} teamTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTeamTrial(id: string, teamTrialBody: TeamTrialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTeamTrial(id, teamTrialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.addTeamTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new team
         * @param {TeamBody} teamBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(teamBody: TeamBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(teamBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start a new Stripe checkout session to start a new subscription
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCheckoutSession(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckoutView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCheckoutSession(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get url to the Stripe billing portal of the team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerPortalURL(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPortalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerPortalURL(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getCustomerPortalURL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the details of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the members of a team
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMembers(id: string, limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMembers(id, limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the trials of a team
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamTrials(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTeamTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamTrials(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all teams
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a team
         * @param {string} id 
         * @param {TeamUpdateBody} teamUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(id: string, teamUpdateBody: TeamUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(id, teamUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the membership of a user of a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TeamMemberBody} teamMemberBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMembership(id: string, userId: string, teamMemberBody: TeamMemberBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMemberView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMembership(id, userId, teamMemberBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamApi - factory interface
 * @export
 */
export const TeamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a trial to a team
         * @param {TeamApiAddTeamTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTeamTrial(requestParameters: TeamApiAddTeamTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addTeamTrial(requestParameters.id, requestParameters.teamTrialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new team
         * @param {TeamApiCreateTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(requestParameters: TeamApiCreateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamView> {
            return localVarFp.createTeam(requestParameters.teamBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start a new Stripe checkout session to start a new subscription
         * @param {TeamApiGetCheckoutSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCheckoutSession(requestParameters: TeamApiGetCheckoutSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckoutView> {
            return localVarFp.getCheckoutSession(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get url to the Stripe billing portal of the team
         * @param {TeamApiGetCustomerPortalURLRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPortalURL(requestParameters: TeamApiGetCustomerPortalURLRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomerPortalView> {
            return localVarFp.getCustomerPortalURL(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the details of a team
         * @param {TeamApiGetTeamDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamDetails(requestParameters: TeamApiGetTeamDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamDetailsView> {
            return localVarFp.getTeamDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the members of a team
         * @param {TeamApiGetTeamMembersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembers(requestParameters: TeamApiGetTeamMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberListView> {
            return localVarFp.getTeamMembers(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the trials of a team
         * @param {TeamApiGetTeamTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamTrials(requestParameters: TeamApiGetTeamTrialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTeamTrialView> {
            return localVarFp.getTeamTrials(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all teams
         * @param {TeamApiGetTeamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(requestParameters: TeamApiGetTeamsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<TeamListView> {
            return localVarFp.getTeams(requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a team
         * @param {TeamApiUpdateTeamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(requestParameters: TeamApiUpdateTeamRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamView> {
            return localVarFp.updateTeam(requestParameters.id, requestParameters.teamUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the membership of a user of a trial
         * @param {TeamApiUpdateTeamMembershipRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMembership(requestParameters: TeamApiUpdateTeamMembershipRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMemberView> {
            return localVarFp.updateTeamMembership(requestParameters.id, requestParameters.userId, requestParameters.teamMemberBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addTeamTrial operation in TeamApi.
 * @export
 * @interface TeamApiAddTeamTrialRequest
 */
export interface TeamApiAddTeamTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiAddTeamTrial
     */
    readonly id: string

    /**
     * 
     * @type {TeamTrialBody}
     * @memberof TeamApiAddTeamTrial
     */
    readonly teamTrialBody: TeamTrialBody
}

/**
 * Request parameters for createTeam operation in TeamApi.
 * @export
 * @interface TeamApiCreateTeamRequest
 */
export interface TeamApiCreateTeamRequest {
    /**
     * 
     * @type {TeamBody}
     * @memberof TeamApiCreateTeam
     */
    readonly teamBody: TeamBody
}

/**
 * Request parameters for getCheckoutSession operation in TeamApi.
 * @export
 * @interface TeamApiGetCheckoutSessionRequest
 */
export interface TeamApiGetCheckoutSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetCheckoutSession
     */
    readonly id: string
}

/**
 * Request parameters for getCustomerPortalURL operation in TeamApi.
 * @export
 * @interface TeamApiGetCustomerPortalURLRequest
 */
export interface TeamApiGetCustomerPortalURLRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetCustomerPortalURL
     */
    readonly id: string
}

/**
 * Request parameters for getTeamDetails operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamDetailsRequest
 */
export interface TeamApiGetTeamDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamDetails
     */
    readonly id: string
}

/**
 * Request parameters for getTeamMembers operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamMembersRequest
 */
export interface TeamApiGetTeamMembersRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamMembers
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TeamApiGetTeamMembers
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamMembers
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getTeamTrials operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamTrialsRequest
 */
export interface TeamApiGetTeamTrialsRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeamTrials
     */
    readonly id: string
}

/**
 * Request parameters for getTeams operation in TeamApi.
 * @export
 * @interface TeamApiGetTeamsRequest
 */
export interface TeamApiGetTeamsRequest {
    /**
     * 
     * @type {number}
     * @memberof TeamApiGetTeams
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof TeamApiGetTeams
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for updateTeam operation in TeamApi.
 * @export
 * @interface TeamApiUpdateTeamRequest
 */
export interface TeamApiUpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateTeam
     */
    readonly id: string

    /**
     * 
     * @type {TeamUpdateBody}
     * @memberof TeamApiUpdateTeam
     */
    readonly teamUpdateBody: TeamUpdateBody
}

/**
 * Request parameters for updateTeamMembership operation in TeamApi.
 * @export
 * @interface TeamApiUpdateTeamMembershipRequest
 */
export interface TeamApiUpdateTeamMembershipRequest {
    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateTeamMembership
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TeamApiUpdateTeamMembership
     */
    readonly userId: string

    /**
     * 
     * @type {TeamMemberBody}
     * @memberof TeamApiUpdateTeamMembership
     */
    readonly teamMemberBody: TeamMemberBody
}

/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
export class TeamApi extends BaseAPI {
    /**
     * 
     * @summary Add a trial to a team
     * @param {TeamApiAddTeamTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public addTeamTrial(requestParameters: TeamApiAddTeamTrialRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).addTeamTrial(requestParameters.id, requestParameters.teamTrialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new team
     * @param {TeamApiCreateTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeam(requestParameters: TeamApiCreateTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeam(requestParameters.teamBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start a new Stripe checkout session to start a new subscription
     * @param {TeamApiGetCheckoutSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getCheckoutSession(requestParameters: TeamApiGetCheckoutSessionRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getCheckoutSession(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get url to the Stripe billing portal of the team
     * @param {TeamApiGetCustomerPortalURLRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getCustomerPortalURL(requestParameters: TeamApiGetCustomerPortalURLRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getCustomerPortalURL(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the details of a team
     * @param {TeamApiGetTeamDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamDetails(requestParameters: TeamApiGetTeamDetailsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the members of a team
     * @param {TeamApiGetTeamMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamMembers(requestParameters: TeamApiGetTeamMembersRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamMembers(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the trials of a team
     * @param {TeamApiGetTeamTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamTrials(requestParameters: TeamApiGetTeamTrialsRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamTrials(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all teams
     * @param {TeamApiGetTeamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeams(requestParameters: TeamApiGetTeamsRequest = {}, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeams(requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a team
     * @param {TeamApiUpdateTeamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeam(requestParameters: TeamApiUpdateTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeam(requestParameters.id, requestParameters.teamUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the membership of a user of a trial
     * @param {TeamApiUpdateTeamMembershipRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamMembership(requestParameters: TeamApiUpdateTeamMembershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamMembership(requestParameters.id, requestParameters.userId, requestParameters.teamMemberBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch the data associated with a token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getToken', 'token', token)
            const localVarPath = `/tokens/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary fetch the data associated with a token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TokenApi.getToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * 
         * @summary fetch the data associated with a token
         * @param {TokenApiGetTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken(requestParameters: TokenApiGetTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<TokenView> {
            return localVarFp.getToken(requestParameters.token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getToken operation in TokenApi.
 * @export
 * @interface TokenApiGetTokenRequest
 */
export interface TokenApiGetTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenApiGetToken
     */
    readonly token: string
}

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * 
     * @summary fetch the data associated with a token
     * @param {TokenApiGetTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public getToken(requestParameters: TokenApiGetTokenRequest, options?: RawAxiosRequestConfig) {
        return TokenApiFp(this.configuration).getToken(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TrialManagementApi - axios parameter creator
 * @export
 */
export const TrialManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add CT trial to platform
         * @param {string} id 
         * @param {TrialAddCTBody} trialAddCTBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCT: async (id: string, trialAddCTBody: TrialAddCTBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addCT', 'id', id)
            // verify required parameter 'trialAddCTBody' is not null or undefined
            assertParamExists('addCT', 'trialAddCTBody', trialAddCTBody)
            const localVarPath = `/trial-management/{id}/add-ct`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialAddCTBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
         * @param {string} id 
         * @param {TrialEffectBody} trialEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect: async (id: string, trialEffectBody: TrialEffectBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEffect', 'id', id)
            // verify required parameter 'trialEffectBody' is not null or undefined
            assertParamExists('addEffect', 'trialEffectBody', trialEffectBody)
            const localVarPath = `/trial-management/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialEffectBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary mark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addFavoriteTrial', 'id', id)
            const localVarPath = `/trial-management/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set mandate status to paid
         * @param {string} id 
         * @param {AssignMandateBody} assignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMandate: async (id: string, assignMandateBody: AssignMandateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignMandate', 'id', id)
            // verify required parameter 'assignMandateBody' is not null or undefined
            assertParamExists('assignMandate', 'assignMandateBody', assignMandateBody)
            const localVarPath = `/trial-management/{id}/mandate/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignMandateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary set a trial to the completed status to stop recruitment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('completeTrial', 'id', id)
            const localVarPath = `/trial-management/{id}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a comment to a trial
         * @param {string} id 
         * @param {TrialCommentBody} trialCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment: async (id: string, trialCommentBody: TrialCommentBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createComment', 'id', id)
            // verify required parameter 'trialCommentBody' is not null or undefined
            assertParamExists('createComment', 'trialCommentBody', trialCommentBody)
            const localVarPath = `/trial-management/{id}/comment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCommentBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a contact to a trial
         * @param {string} id 
         * @param {TrialContactBody} trialContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (id: string, trialContactBody: TrialContactBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createContact', 'id', id)
            // verify required parameter 'trialContactBody' is not null or undefined
            assertParamExists('createContact', 'trialContactBody', trialContactBody)
            const localVarPath = `/trial-management/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a criteria
         * @param {string} id 
         * @param {TrialCriteriaBody} trialCriteriaBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCriteria: async (id: string, trialCriteriaBody: TrialCriteriaBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createCriteria', 'id', id)
            // verify required parameter 'trialCriteriaBody' is not null or undefined
            assertParamExists('createCriteria', 'trialCriteriaBody', trialCriteriaBody)
            const localVarPath = `/trial-management/{id}/criteria`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCriteriaBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add a location to a trial
         * @param {string} id 
         * @param {TrialLocationBody} trialLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation: async (id: string, trialLocationBody: TrialLocationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createLocation', 'id', id)
            // verify required parameter 'trialLocationBody' is not null or undefined
            assertParamExists('createLocation', 'trialLocationBody', trialLocationBody)
            const localVarPath = `/trial-management/{id}/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialLocationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryTranslations: async (id: string, trialTranslationBody: TrialTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createSummaryTranslations', 'id', id)
            // verify required parameter 'trialTranslationBody' is not null or undefined
            assertParamExists('createSummaryTranslations', 'trialTranslationBody', trialTranslationBody)
            const localVarPath = `/trial-management/{id}/translations:summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations: async (id: string, trialTranslationBody: TrialTranslationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTitleTranslations', 'id', id)
            // verify required parameter 'trialTranslationBody' is not null or undefined
            assertParamExists('createTitleTranslations', 'trialTranslationBody', trialTranslationBody)
            const localVarPath = `/trial-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialTranslationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a new trial
         * @param {TrialCreateBody} trialCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrial: async (trialCreateBody: TrialCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'trialCreateBody' is not null or undefined
            assertParamExists('createTrial', 'trialCreateBody', trialCreateBody)
            const localVarPath = `/trial-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary unmark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFavoriteTrial', 'id', id)
            const localVarPath = `/trial-management/{id}/favorite`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary soft delete a trial, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTrial', 'id', id)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActivity', 'id', id)
            const localVarPath = `/trial-management/{id}/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getContacts', 'id', id)
            const localVarPath = `/trial-management/{id}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of criteria of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteria: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCriteria', 'id', id)
            const localVarPath = `/trial-management/{id}/criteria`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetails', 'id', id)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get a list of all lead sponsors of the trials
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSponsors: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trial-management/lead-sponsors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [country] 
         * @param {string} [facility] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations: async (id: string, limit?: number | null, offset?: number | null, country?: string, facility?: string, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLocations', 'id', id)
            const localVarPath = `/trial-management/{id}/location`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (facility !== undefined) {
                localVarQueryParameter['facility'] = facility;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of the userIds that fully matched a trial
         * @param {string} id 
         * @param {boolean | null} showDetails 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialVolunteersOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string | null} [locationId] 
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatches: async (id: string, showDetails: boolean | null, limit?: number | null, offset?: number | null, orderBy?: TrialVolunteersOrderBy, orderDirection?: OrderDirection, locationId?: string | null, country?: string, postalCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMatches', 'id', id)
            // verify required parameter 'showDetails' is not null or undefined
            assertParamExists('getMatches', 'showDetails', showDetails)
            const localVarPath = `/trial-management/{id}/volunteers/matches`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (postalCode !== undefined) {
                localVarQueryParameter['postalCode'] = postalCode;
            }

            if (showDetails !== undefined) {
                localVarQueryParameter['showDetails'] = showDetails;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the list of public recruitment locations for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicLocations: async (id: string, limit?: number | null, offset?: number | null, searchString?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPublicLocations', 'id', id)
            const localVarPath = `/trial-management/{id}/location/public`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get public details required for requesting access to a trial.
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTrials: async (limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trial-management/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSummaryTranslations', 'id', id)
            const localVarPath = `/trial-management/{id}/translations:summary`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get information on mandates of a team
         * @param {string} teamId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMandates: async (teamId: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamMandates', 'teamId', teamId)
            const localVarPath = `/trial-management/team-mandates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (teamId !== undefined) {
                localVarQueryParameter['teamId'] = teamId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the teams for a trial
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams: async (id: string, limit?: number, nextPageToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTeams', 'id', id)
            const localVarPath = `/trial-management/{id}/teams`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTitleTranslations', 'id', id)
            const localVarPath = `/trial-management/{id}/translations:title`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of activities on a funnel page
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [researcherId] 
         * @param {string | null} [start] 
         * @param {string | null} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivity: async (id: string, limit?: number | null, offset?: number | null, researcherId?: string | null, start?: string | null, end?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerActivity', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/activity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (researcherId !== undefined) {
                localVarQueryParameter['researcherId'] = researcherId;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the paginated list of the users that can be filtered on in the funnel activity list
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivityUsers: async (id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerActivityUsers', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/activity/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the answers of a volunteer for a specific volunteer
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {OrderDirection} [order] 
         * @param {UserTrialStatus} [status] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerAnswers: async (id: string, limit?: number | null, offset?: number | null, order?: OrderDirection, status?: UserTrialStatus, userId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerAnswers', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/answers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the contact details of a volunteer of a specific trial
         * @param {string} id 
         * @param {string} userId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerContact: async (id: string, userId: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteerContact', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getVolunteerContact', 'userId', userId)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of volunteers of a specific trial
         * @param {string} id 
         * @param {string | null} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteersOverview: async (id: string, locationId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getVolunteersOverview', 'id', id)
            const localVarPath = `/trial-management/{id}/volunteers/overview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Recalculate the cache of a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculate: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('recalculate', 'userId', userId)
            const localVarPath = `/trial-management/user/{userId}/cache`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset the acceptance flow for the trial to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeEffect', 'id', id)
            const localVarPath = `/trial-management/{id}/effect`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request a booster for a trial
         * @param {string} id 
         * @param {TrialBoosterBody} trialBoosterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestBooster: async (id: string, trialBoosterBody: TrialBoosterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestBooster', 'id', id)
            // verify required parameter 'trialBoosterBody' is not null or undefined
            assertParamExists('requestBooster', 'trialBoosterBody', trialBoosterBody)
            const localVarPath = `/trial-management/{id}/booster`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialBoosterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary request a new criteria for a trial
         * @param {string} id 
         * @param {CriteriaRequestBody} criteriaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCriteria: async (id: string, criteriaRequestBody: CriteriaRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('requestCriteria', 'id', id)
            // verify required parameter 'criteriaRequestBody' is not null or undefined
            assertParamExists('requestCriteria', 'criteriaRequestBody', criteriaRequestBody)
            const localVarPath = `/trial-management/{id}/request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(criteriaRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetTrialCache: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resetTrialCache', 'id', id)
            const localVarPath = `/trial-management/{id}/cache`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the status of a user in a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerFeedbackBody} trialVolunteerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToVolunteer: async (id: string, userId: string, trialVolunteerFeedbackBody: TrialVolunteerFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondToVolunteer', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('respondToVolunteer', 'userId', userId)
            // verify required parameter 'trialVolunteerFeedbackBody' is not null or undefined
            assertParamExists('respondToVolunteer', 'trialVolunteerFeedbackBody', trialVolunteerFeedbackBody)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialVolunteerFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary restore a deleted trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTrial: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('restoreTrial', 'id', id)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
         * @param {GetTrialsBody} getTrialsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (getTrialsBody: GetTrialsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getTrialsBody' is not null or undefined
            assertParamExists('search', 'getTrialsBody', getTrialsBody)
            const localVarPath = `/trial-management/query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getTrialsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set mandate status to active (unpaid)
         * @param {string} id 
         * @param {UnassignMandateBody} unassignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMandate: async (id: string, unassignMandateBody: UnassignMandateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unassignMandate', 'id', id)
            // verify required parameter 'unassignMandateBody' is not null or undefined
            assertParamExists('unassignMandate', 'unassignMandateBody', unassignMandateBody)
            const localVarPath = `/trial-management/{id}/mandate/unassign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unassignMandateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update a trial
         * @param {string} id 
         * @param {UpdateTrialBody} updateTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrial: async (id: string, updateTrialBody: UpdateTrialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTrial', 'id', id)
            // verify required parameter 'updateTrialBody' is not null or undefined
            assertParamExists('updateTrial', 'updateTrialBody', updateTrialBody)
            const localVarPath = `/trial-management/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTrialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary indicate the contact date of a  volunteer
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerContactBody} trialVolunteerContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVolunteerContacted: async (id: string, userId: string, trialVolunteerContactBody: TrialVolunteerContactBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateVolunteerContacted', 'id', id)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateVolunteerContacted', 'userId', userId)
            // verify required parameter 'trialVolunteerContactBody' is not null or undefined
            assertParamExists('updateVolunteerContacted', 'trialVolunteerContactBody', trialVolunteerContactBody)
            const localVarPath = `/trial-management/{id}/volunteers/{userId}/contact`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialVolunteerContactBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary validate all properties of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAll: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('validateAll', 'id', id)
            const localVarPath = `/trial-management/{id}/validation`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reach out to eligible patients for a trial
         * @param {string} id 
         * @param {TrialReachOutBody} trialReachOutBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        volunteerReachOut: async (id: string, trialReachOutBody: TrialReachOutBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('volunteerReachOut', 'id', id)
            // verify required parameter 'trialReachOutBody' is not null or undefined
            assertParamExists('volunteerReachOut', 'trialReachOutBody', trialReachOutBody)
            const localVarPath = `/trial-management/{id}/reach-out`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trialReachOutBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TrialManagementApi - functional programming interface
 * @export
 */
export const TrialManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TrialManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add CT trial to platform
         * @param {string} id 
         * @param {TrialAddCTBody} trialAddCTBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCT(id: string, trialAddCTBody: TrialAddCTBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCT(id, trialAddCTBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addCT']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
         * @param {string} id 
         * @param {TrialEffectBody} trialEffectBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEffect(id: string, trialEffectBody: TrialEffectBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEffect(id, trialEffectBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary mark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFavoriteTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFavoriteTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.addFavoriteTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set mandate status to paid
         * @param {string} id 
         * @param {AssignMandateBody} assignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignMandate(id: string, assignMandateBody: AssignMandateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignMandate(id, assignMandateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.assignMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary set a trial to the completed status to stop recruitment
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.completeTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a comment to a trial
         * @param {string} id 
         * @param {TrialCommentBody} trialCommentBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createComment(id: string, trialCommentBody: TrialCommentBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createComment(id, trialCommentBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a contact to a trial
         * @param {string} id 
         * @param {TrialContactBody} trialContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(id: string, trialContactBody: TrialContactBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(id, trialContactBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a criteria
         * @param {string} id 
         * @param {TrialCriteriaBody} trialCriteriaBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCriteria(id: string, trialCriteriaBody: TrialCriteriaBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCriteria(id, trialCriteriaBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add a location to a trial
         * @param {string} id 
         * @param {TrialLocationBody} trialLocationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLocation(id: string, trialLocationBody: TrialLocationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLocation(id, trialLocationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createLocation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSummaryTranslations(id: string, trialTranslationBody: TrialTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSummaryTranslations(id, trialTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createSummaryTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {TrialTranslationBody} trialTranslationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTitleTranslations(id: string, trialTranslationBody: TrialTranslationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTitleTranslations(id, trialTranslationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create a new trial
         * @param {TrialCreateBody} trialCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTrial(trialCreateBody: TrialCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTrial(trialCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.createTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary unmark a trial as favorite
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFavoriteTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFavoriteTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.deleteFavoriteTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary soft delete a trial, it will be restorable for 30 days
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.deleteTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContacts(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialContactView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContacts(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of criteria of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCriteria(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialCriteriaView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCriteria(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetails(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialDetailsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get a list of all lead sponsors of the trials
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLeadSponsors(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLeadSponsorView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLeadSponsors(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getLeadSponsors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [country] 
         * @param {string} [facility] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocations(id: string, limit?: number | null, offset?: number | null, country?: string, facility?: string, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocations(id, limit, offset, country, facility, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of the userIds that fully matched a trial
         * @param {string} id 
         * @param {boolean | null} showDetails 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {TrialVolunteersOrderBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string | null} [locationId] 
         * @param {string} [country] 
         * @param {string} [postalCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatches(id: string, showDetails: boolean | null, limit?: number | null, offset?: number | null, orderBy?: TrialVolunteersOrderBy, orderDirection?: OrderDirection, locationId?: string | null, country?: string, postalCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialMatchView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatches(id, showDetails, limit, offset, orderBy, orderDirection, locationId, country, postalCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getMatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the list of public recruitment locations for a trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicLocations(id: string, limit?: number | null, offset?: number | null, searchString?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListPublicLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicLocations(id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getPublicLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get public details required for requesting access to a trial.
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicTrials(limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialPublicView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicTrials(limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getPublicTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getSummaryTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get information on mandates of a team
         * @param {string} teamId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMandates(teamId: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TeamMandatesListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMandates(teamId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getTeamMandates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the teams for a trial
         * @param {string} id 
         * @param {number} [limit] 
         * @param {string} [nextPageToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeams(id: string, limit?: number, nextPageToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialTeamListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeams(id, limit, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTitleTranslations(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialTranslationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTitleTranslations(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getTitleTranslations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of activities on a funnel page
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [researcherId] 
         * @param {string | null} [start] 
         * @param {string | null} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerActivity(id: string, limit?: number | null, offset?: number | null, researcherId?: string | null, start?: string | null, end?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialVolunteerActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerActivity(id, limit, offset, researcherId, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the paginated list of the users that can be filtered on in the funnel activity list
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerActivityUsers(id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialVolunteerActivityUsersView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerActivityUsers(id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerActivityUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the answers of a volunteer for a specific volunteer
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {OrderDirection} [order] 
         * @param {UserTrialStatus} [status] 
         * @param {string | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerAnswers(id: string, limit?: number | null, offset?: number | null, order?: OrderDirection, status?: UserTrialStatus, userId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialVolunteerAnswersListView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerAnswers(id, limit, offset, order, status, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerAnswers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the contact details of a volunteer of a specific trial
         * @param {string} id 
         * @param {string} userId 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteerContact(id: string, userId: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialVolunteerContactView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteerContact(id, userId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteerContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of volunteers of a specific trial
         * @param {string} id 
         * @param {string | null} [locationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVolunteersOverview(id: string, locationId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialVolunteersOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVolunteersOverview(id, locationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.getVolunteersOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Recalculate the cache of a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recalculate(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recalculate(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.recalculate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reset the acceptance flow for the trial to the default
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEffect(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEffect(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.removeEffect']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary request a booster for a trial
         * @param {string} id 
         * @param {TrialBoosterBody} trialBoosterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestBooster(id: string, trialBoosterBody: TrialBoosterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestBooster(id, trialBoosterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.requestBooster']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary request a new criteria for a trial
         * @param {string} id 
         * @param {CriteriaRequestBody} criteriaRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestCriteria(id: string, criteriaRequestBody: CriteriaRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestCriteria(id, criteriaRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.requestCriteria']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetTrialCache(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetTrialCache(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.resetTrialCache']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update the status of a user in a trial
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerFeedbackBody} trialVolunteerFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToVolunteer(id: string, userId: string, trialVolunteerFeedbackBody: TrialVolunteerFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToVolunteer(id, userId, trialVolunteerFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.respondToVolunteer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary restore a deleted trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreTrial(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreTrial(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.restoreTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
         * @param {GetTrialsBody} getTrialsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(getTrialsBody: GetTrialsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(getTrialsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set mandate status to active (unpaid)
         * @param {string} id 
         * @param {UnassignMandateBody} unassignMandateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignMandate(id: string, unassignMandateBody: UnassignMandateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignMandate(id, unassignMandateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.unassignMandate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update a trial
         * @param {string} id 
         * @param {UpdateTrialBody} updateTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTrial(id: string, updateTrialBody: UpdateTrialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTrial(id, updateTrialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.updateTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary indicate the contact date of a  volunteer
         * @param {string} id 
         * @param {string} userId 
         * @param {TrialVolunteerContactBody} trialVolunteerContactBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVolunteerContacted(id: string, userId: string, trialVolunteerContactBody: TrialVolunteerContactBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVolunteerContacted(id, userId, trialVolunteerContactBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.updateVolunteerContacted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary validate all properties of a trial
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAll(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAll(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.validateAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reach out to eligible patients for a trial
         * @param {string} id 
         * @param {TrialReachOutBody} trialReachOutBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async volunteerReachOut(id: string, trialReachOutBody: TrialReachOutBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialReachOutView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.volunteerReachOut(id, trialReachOutBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TrialManagementApi.volunteerReachOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TrialManagementApi - factory interface
 * @export
 */
export const TrialManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TrialManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary add CT trial to platform
         * @param {TrialManagementApiAddCTRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCT(requestParameters: TrialManagementApiAddCTRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addCT(requestParameters.id, requestParameters.trialAddCTBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
         * @param {TrialManagementApiAddEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEffect(requestParameters: TrialManagementApiAddEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addEffect(requestParameters.id, requestParameters.trialEffectBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary mark a trial as favorite
         * @param {TrialManagementApiAddFavoriteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteTrial(requestParameters: TrialManagementApiAddFavoriteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addFavoriteTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set mandate status to paid
         * @param {TrialManagementApiAssignMandateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMandate(requestParameters: TrialManagementApiAssignMandateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignMandate(requestParameters.id, requestParameters.assignMandateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary set a trial to the completed status to stop recruitment
         * @param {TrialManagementApiCompleteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeTrial(requestParameters: TrialManagementApiCompleteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.completeTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a comment to a trial
         * @param {TrialManagementApiCreateCommentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createComment(requestParameters: TrialManagementApiCreateCommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createComment(requestParameters.id, requestParameters.trialCommentBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a contact to a trial
         * @param {TrialManagementApiCreateContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(requestParameters: TrialManagementApiCreateContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createContact(requestParameters.id, requestParameters.trialContactBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a criteria
         * @param {TrialManagementApiCreateCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCriteria(requestParameters: TrialManagementApiCreateCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCriteria(requestParameters.id, requestParameters.trialCriteriaBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add a location to a trial
         * @param {TrialManagementApiCreateLocationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLocation(requestParameters: TrialManagementApiCreateLocationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LocationView> {
            return localVarFp.createLocation(requestParameters.id, requestParameters.trialLocationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {TrialManagementApiCreateSummaryTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryTranslations(requestParameters: TrialManagementApiCreateSummaryTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.createSummaryTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {TrialManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTitleTranslations(requestParameters: TrialManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.createTitleTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a new trial
         * @param {TrialManagementApiCreateTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTrial(requestParameters: TrialManagementApiCreateTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialView> {
            return localVarFp.createTrial(requestParameters.trialCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary unmark a trial as favorite
         * @param {TrialManagementApiDeleteFavoriteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavoriteTrial(requestParameters: TrialManagementApiDeleteFavoriteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteFavoriteTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary soft delete a trial, it will be restorable for 30 days
         * @param {TrialManagementApiDeleteTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTrial(requestParameters: TrialManagementApiDeleteTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary fetch paginated activity log of a criteria
         * @param {TrialManagementApiGetActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(requestParameters: TrialManagementApiGetActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialActivityView> {
            return localVarFp.getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {TrialManagementApiGetContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContacts(requestParameters: TrialManagementApiGetContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialContactView> {
            return localVarFp.getContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of criteria of a specific trial
         * @param {TrialManagementApiGetCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCriteria(requestParameters: TrialManagementApiGetCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialCriteriaView> {
            return localVarFp.getCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {TrialManagementApiGetDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetails(requestParameters: TrialManagementApiGetDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialDetailsView> {
            return localVarFp.getDetails(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get a list of all lead sponsors of the trials
         * @param {TrialManagementApiGetLeadSponsorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSponsors(requestParameters: TrialManagementApiGetLeadSponsorsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListLeadSponsorView> {
            return localVarFp.getLeadSponsors(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the details of a specific trial
         * @param {TrialManagementApiGetLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocations(requestParameters: TrialManagementApiGetLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialLocationView> {
            return localVarFp.getLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.country, requestParameters.facility, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of the userIds that fully matched a trial
         * @param {TrialManagementApiGetMatchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatches(requestParameters: TrialManagementApiGetMatchesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialMatchView> {
            return localVarFp.getMatches(requestParameters.id, requestParameters.showDetails, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.country, requestParameters.postalCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the list of public recruitment locations for a trial
         * @param {TrialManagementApiGetPublicLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicLocations(requestParameters: TrialManagementApiGetPublicLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListPublicLocationView> {
            return localVarFp.getPublicLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get public details required for requesting access to a trial.
         * @param {TrialManagementApiGetPublicTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicTrials(requestParameters: TrialManagementApiGetPublicTrialsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialPublicView> {
            return localVarFp.getPublicTrials(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the summary of a trial
         * @param {TrialManagementApiGetSummaryTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryTranslations(requestParameters: TrialManagementApiGetSummaryTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.getSummaryTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get information on mandates of a team
         * @param {TrialManagementApiGetTeamMandatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMandates(requestParameters: TrialManagementApiGetTeamMandatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<TeamMandatesListView> {
            return localVarFp.getTeamMandates(requestParameters.teamId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the teams for a trial
         * @param {TrialManagementApiGetTeamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeams(requestParameters: TrialManagementApiGetTeamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialTeamListView> {
            return localVarFp.getTeams(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of translations of the title of a trial
         * @param {TrialManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleTranslations(requestParameters: TrialManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialTranslationView> {
            return localVarFp.getTitleTranslations(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of activities on a funnel page
         * @param {TrialManagementApiGetVolunteerActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivity(requestParameters: TrialManagementApiGetVolunteerActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialVolunteerActivityView> {
            return localVarFp.getVolunteerActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.researcherId, requestParameters.start, requestParameters.end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the paginated list of the users that can be filtered on in the funnel activity list
         * @param {TrialManagementApiGetVolunteerActivityUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerActivityUsers(requestParameters: TrialManagementApiGetVolunteerActivityUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialVolunteerActivityUsersView> {
            return localVarFp.getVolunteerActivityUsers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the answers of a volunteer for a specific volunteer
         * @param {TrialManagementApiGetVolunteerAnswersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerAnswers(requestParameters: TrialManagementApiGetVolunteerAnswersRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialVolunteerAnswersListView> {
            return localVarFp.getVolunteerAnswers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.status, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the contact details of a volunteer of a specific trial
         * @param {TrialManagementApiGetVolunteerContactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteerContact(requestParameters: TrialManagementApiGetVolunteerContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialVolunteerContactView> {
            return localVarFp.getVolunteerContact(requestParameters.id, requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of volunteers of a specific trial
         * @param {TrialManagementApiGetVolunteersOverviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVolunteersOverview(requestParameters: TrialManagementApiGetVolunteersOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialVolunteersOverviewView> {
            return localVarFp.getVolunteersOverview(requestParameters.id, requestParameters.locationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Recalculate the cache of a user
         * @param {TrialManagementApiRecalculateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recalculate(requestParameters: TrialManagementApiRecalculateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recalculate(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reset the acceptance flow for the trial to the default
         * @param {TrialManagementApiRemoveEffectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEffect(requestParameters: TrialManagementApiRemoveEffectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeEffect(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request a booster for a trial
         * @param {TrialManagementApiRequestBoosterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestBooster(requestParameters: TrialManagementApiRequestBoosterRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestBooster(requestParameters.id, requestParameters.trialBoosterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary request a new criteria for a trial
         * @param {TrialManagementApiRequestCriteriaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestCriteria(requestParameters: TrialManagementApiRequestCriteriaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.requestCriteria(requestParameters.id, requestParameters.criteriaRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
         * @param {TrialManagementApiResetTrialCacheRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetTrialCache(requestParameters: TrialManagementApiResetTrialCacheRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetTrialCache(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the status of a user in a trial
         * @param {TrialManagementApiRespondToVolunteerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToVolunteer(requestParameters: TrialManagementApiRespondToVolunteerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.respondToVolunteer(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary restore a deleted trial
         * @param {TrialManagementApiRestoreTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreTrial(requestParameters: TrialManagementApiRestoreTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreTrial(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
         * @param {TrialManagementApiSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(requestParameters: TrialManagementApiSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListTrialView> {
            return localVarFp.search(requestParameters.getTrialsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set mandate status to active (unpaid)
         * @param {TrialManagementApiUnassignMandateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignMandate(requestParameters: TrialManagementApiUnassignMandateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignMandate(requestParameters.id, requestParameters.unassignMandateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update a trial
         * @param {TrialManagementApiUpdateTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTrial(requestParameters: TrialManagementApiUpdateTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateTrial(requestParameters.id, requestParameters.updateTrialBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary indicate the contact date of a  volunteer
         * @param {TrialManagementApiUpdateVolunteerContactedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVolunteerContacted(requestParameters: TrialManagementApiUpdateVolunteerContactedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateVolunteerContacted(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerContactBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary validate all properties of a trial
         * @param {TrialManagementApiValidateAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAll(requestParameters: TrialManagementApiValidateAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.validateAll(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reach out to eligible patients for a trial
         * @param {TrialManagementApiVolunteerReachOutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        volunteerReachOut(requestParameters: TrialManagementApiVolunteerReachOutRequest, options?: RawAxiosRequestConfig): AxiosPromise<TrialReachOutView> {
            return localVarFp.volunteerReachOut(requestParameters.id, requestParameters.trialReachOutBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addCT operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddCTRequest
 */
export interface TrialManagementApiAddCTRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddCT
     */
    readonly id: string

    /**
     * 
     * @type {TrialAddCTBody}
     * @memberof TrialManagementApiAddCT
     */
    readonly trialAddCTBody: TrialAddCTBody
}

/**
 * Request parameters for addEffect operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddEffectRequest
 */
export interface TrialManagementApiAddEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddEffect
     */
    readonly id: string

    /**
     * 
     * @type {TrialEffectBody}
     * @memberof TrialManagementApiAddEffect
     */
    readonly trialEffectBody: TrialEffectBody
}

/**
 * Request parameters for addFavoriteTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAddFavoriteTrialRequest
 */
export interface TrialManagementApiAddFavoriteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAddFavoriteTrial
     */
    readonly id: string
}

/**
 * Request parameters for assignMandate operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiAssignMandateRequest
 */
export interface TrialManagementApiAssignMandateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiAssignMandate
     */
    readonly id: string

    /**
     * 
     * @type {AssignMandateBody}
     * @memberof TrialManagementApiAssignMandate
     */
    readonly assignMandateBody: AssignMandateBody
}

/**
 * Request parameters for completeTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCompleteTrialRequest
 */
export interface TrialManagementApiCompleteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCompleteTrial
     */
    readonly id: string
}

/**
 * Request parameters for createComment operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateCommentRequest
 */
export interface TrialManagementApiCreateCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateComment
     */
    readonly id: string

    /**
     * 
     * @type {TrialCommentBody}
     * @memberof TrialManagementApiCreateComment
     */
    readonly trialCommentBody: TrialCommentBody
}

/**
 * Request parameters for createContact operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateContactRequest
 */
export interface TrialManagementApiCreateContactRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateContact
     */
    readonly id: string

    /**
     * 
     * @type {TrialContactBody}
     * @memberof TrialManagementApiCreateContact
     */
    readonly trialContactBody: TrialContactBody
}

/**
 * Request parameters for createCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateCriteriaRequest
 */
export interface TrialManagementApiCreateCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateCriteria
     */
    readonly id: string

    /**
     * 
     * @type {TrialCriteriaBody}
     * @memberof TrialManagementApiCreateCriteria
     */
    readonly trialCriteriaBody: TrialCriteriaBody
}

/**
 * Request parameters for createLocation operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateLocationRequest
 */
export interface TrialManagementApiCreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateLocation
     */
    readonly id: string

    /**
     * 
     * @type {TrialLocationBody}
     * @memberof TrialManagementApiCreateLocation
     */
    readonly trialLocationBody: TrialLocationBody
}

/**
 * Request parameters for createSummaryTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateSummaryTranslationsRequest
 */
export interface TrialManagementApiCreateSummaryTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateSummaryTranslations
     */
    readonly id: string

    /**
     * 
     * @type {TrialTranslationBody}
     * @memberof TrialManagementApiCreateSummaryTranslations
     */
    readonly trialTranslationBody: TrialTranslationBody
}

/**
 * Request parameters for createTitleTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateTitleTranslationsRequest
 */
export interface TrialManagementApiCreateTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiCreateTitleTranslations
     */
    readonly id: string

    /**
     * 
     * @type {TrialTranslationBody}
     * @memberof TrialManagementApiCreateTitleTranslations
     */
    readonly trialTranslationBody: TrialTranslationBody
}

/**
 * Request parameters for createTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiCreateTrialRequest
 */
export interface TrialManagementApiCreateTrialRequest {
    /**
     * 
     * @type {TrialCreateBody}
     * @memberof TrialManagementApiCreateTrial
     */
    readonly trialCreateBody: TrialCreateBody
}

/**
 * Request parameters for deleteFavoriteTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiDeleteFavoriteTrialRequest
 */
export interface TrialManagementApiDeleteFavoriteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiDeleteFavoriteTrial
     */
    readonly id: string
}

/**
 * Request parameters for deleteTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiDeleteTrialRequest
 */
export interface TrialManagementApiDeleteTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiDeleteTrial
     */
    readonly id: string
}

/**
 * Request parameters for getActivity operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetActivityRequest
 */
export interface TrialManagementApiGetActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetActivity
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetActivity
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetActivity
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getContacts operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetContactsRequest
 */
export interface TrialManagementApiGetContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetContacts
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetContacts
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetContacts
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetCriteriaRequest
 */
export interface TrialManagementApiGetCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetCriteria
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetCriteria
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetCriteria
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getDetails operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetDetailsRequest
 */
export interface TrialManagementApiGetDetailsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetDetails
     */
    readonly id: string
}

/**
 * Request parameters for getLeadSponsors operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetLeadSponsorsRequest
 */
export interface TrialManagementApiGetLeadSponsorsRequest {
    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLeadSponsors
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLeadSponsors
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLeadSponsors
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getLocations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetLocationsRequest
 */
export interface TrialManagementApiGetLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly country?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly facility?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetLocations
     */
    readonly searchString?: string
}

/**
 * Request parameters for getMatches operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetMatchesRequest
 */
export interface TrialManagementApiGetMatchesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly id: string

    /**
     * 
     * @type {boolean}
     * @memberof TrialManagementApiGetMatches
     */
    readonly showDetails: boolean | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetMatches
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetMatches
     */
    readonly offset?: number | null

    /**
     * 
     * @type {TrialVolunteersOrderBy}
     * @memberof TrialManagementApiGetMatches
     */
    readonly orderBy?: TrialVolunteersOrderBy

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetMatches
     */
    readonly orderDirection?: OrderDirection

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly locationId?: string | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly country?: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetMatches
     */
    readonly postalCode?: string
}

/**
 * Request parameters for getPublicLocations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetPublicLocationsRequest
 */
export interface TrialManagementApiGetPublicLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPublicLocations
     */
    readonly searchString?: string
}

/**
 * Request parameters for getPublicTrials operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetPublicTrialsRequest
 */
export interface TrialManagementApiGetPublicTrialsRequest {
    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetPublicTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetPublicTrials
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getSummaryTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetSummaryTranslationsRequest
 */
export interface TrialManagementApiGetSummaryTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetSummaryTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getTeamMandates operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetTeamMandatesRequest
 */
export interface TrialManagementApiGetTeamMandatesRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTeamMandates
     */
    readonly teamId: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetTeamMandates
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetTeamMandates
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getTeams operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetTeamsRequest
 */
export interface TrialManagementApiGetTeamsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTeams
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetTeams
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTeams
     */
    readonly nextPageToken?: string
}

/**
 * Request parameters for getTitleTranslations operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetTitleTranslationsRequest
 */
export interface TrialManagementApiGetTitleTranslationsRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetTitleTranslations
     */
    readonly id: string
}

/**
 * Request parameters for getVolunteerActivity operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerActivityRequest
 */
export interface TrialManagementApiGetVolunteerActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly researcherId?: string | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly start?: string | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivity
     */
    readonly end?: string | null
}

/**
 * Request parameters for getVolunteerActivityUsers operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerActivityUsersRequest
 */
export interface TrialManagementApiGetVolunteerActivityUsersRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerActivityUsers
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getVolunteerAnswers operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerAnswersRequest
 */
export interface TrialManagementApiGetVolunteerAnswersRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly offset?: number | null

    /**
     * 
     * @type {OrderDirection}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly order?: OrderDirection

    /**
     * 
     * @type {UserTrialStatus}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly status?: UserTrialStatus

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerAnswers
     */
    readonly userId?: string | null
}

/**
 * Request parameters for getVolunteerContact operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteerContactRequest
 */
export interface TrialManagementApiGetVolunteerContactRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof TrialManagementApiGetVolunteerContact
     */
    readonly offset?: number | null
}

/**
 * Request parameters for getVolunteersOverview operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiGetVolunteersOverviewRequest
 */
export interface TrialManagementApiGetVolunteersOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteersOverview
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiGetVolunteersOverview
     */
    readonly locationId?: string | null
}

/**
 * Request parameters for recalculate operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRecalculateRequest
 */
export interface TrialManagementApiRecalculateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRecalculate
     */
    readonly userId: string
}

/**
 * Request parameters for removeEffect operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRemoveEffectRequest
 */
export interface TrialManagementApiRemoveEffectRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRemoveEffect
     */
    readonly id: string
}

/**
 * Request parameters for requestBooster operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRequestBoosterRequest
 */
export interface TrialManagementApiRequestBoosterRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRequestBooster
     */
    readonly id: string

    /**
     * 
     * @type {TrialBoosterBody}
     * @memberof TrialManagementApiRequestBooster
     */
    readonly trialBoosterBody: TrialBoosterBody
}

/**
 * Request parameters for requestCriteria operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRequestCriteriaRequest
 */
export interface TrialManagementApiRequestCriteriaRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRequestCriteria
     */
    readonly id: string

    /**
     * 
     * @type {CriteriaRequestBody}
     * @memberof TrialManagementApiRequestCriteria
     */
    readonly criteriaRequestBody: CriteriaRequestBody
}

/**
 * Request parameters for resetTrialCache operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiResetTrialCacheRequest
 */
export interface TrialManagementApiResetTrialCacheRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiResetTrialCache
     */
    readonly id: string
}

/**
 * Request parameters for respondToVolunteer operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRespondToVolunteerRequest
 */
export interface TrialManagementApiRespondToVolunteerRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRespondToVolunteer
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRespondToVolunteer
     */
    readonly userId: string

    /**
     * 
     * @type {TrialVolunteerFeedbackBody}
     * @memberof TrialManagementApiRespondToVolunteer
     */
    readonly trialVolunteerFeedbackBody: TrialVolunteerFeedbackBody
}

/**
 * Request parameters for restoreTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiRestoreTrialRequest
 */
export interface TrialManagementApiRestoreTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiRestoreTrial
     */
    readonly id: string
}

/**
 * Request parameters for search operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiSearchRequest
 */
export interface TrialManagementApiSearchRequest {
    /**
     * 
     * @type {GetTrialsBody}
     * @memberof TrialManagementApiSearch
     */
    readonly getTrialsBody: GetTrialsBody
}

/**
 * Request parameters for unassignMandate operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUnassignMandateRequest
 */
export interface TrialManagementApiUnassignMandateRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUnassignMandate
     */
    readonly id: string

    /**
     * 
     * @type {UnassignMandateBody}
     * @memberof TrialManagementApiUnassignMandate
     */
    readonly unassignMandateBody: UnassignMandateBody
}

/**
 * Request parameters for updateTrial operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUpdateTrialRequest
 */
export interface TrialManagementApiUpdateTrialRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateTrial
     */
    readonly id: string

    /**
     * 
     * @type {UpdateTrialBody}
     * @memberof TrialManagementApiUpdateTrial
     */
    readonly updateTrialBody: UpdateTrialBody
}

/**
 * Request parameters for updateVolunteerContacted operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiUpdateVolunteerContactedRequest
 */
export interface TrialManagementApiUpdateVolunteerContactedRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateVolunteerContacted
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiUpdateVolunteerContacted
     */
    readonly userId: string

    /**
     * 
     * @type {TrialVolunteerContactBody}
     * @memberof TrialManagementApiUpdateVolunteerContacted
     */
    readonly trialVolunteerContactBody: TrialVolunteerContactBody
}

/**
 * Request parameters for validateAll operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiValidateAllRequest
 */
export interface TrialManagementApiValidateAllRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiValidateAll
     */
    readonly id: string
}

/**
 * Request parameters for volunteerReachOut operation in TrialManagementApi.
 * @export
 * @interface TrialManagementApiVolunteerReachOutRequest
 */
export interface TrialManagementApiVolunteerReachOutRequest {
    /**
     * 
     * @type {string}
     * @memberof TrialManagementApiVolunteerReachOut
     */
    readonly id: string

    /**
     * 
     * @type {TrialReachOutBody}
     * @memberof TrialManagementApiVolunteerReachOut
     */
    readonly trialReachOutBody: TrialReachOutBody
}

/**
 * TrialManagementApi - object-oriented interface
 * @export
 * @class TrialManagementApi
 * @extends {BaseAPI}
 */
export class TrialManagementApi extends BaseAPI {
    /**
     * 
     * @summary add CT trial to platform
     * @param {TrialManagementApiAddCTRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addCT(requestParameters: TrialManagementApiAddCTRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addCT(requestParameters.id, requestParameters.trialAddCTBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set the acceptance flow for a trial (all locations). A trial can have 1 effect and each of its locations can have 1 effect.
     * @param {TrialManagementApiAddEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addEffect(requestParameters: TrialManagementApiAddEffectRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addEffect(requestParameters.id, requestParameters.trialEffectBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary mark a trial as favorite
     * @param {TrialManagementApiAddFavoriteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public addFavoriteTrial(requestParameters: TrialManagementApiAddFavoriteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).addFavoriteTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set mandate status to paid
     * @param {TrialManagementApiAssignMandateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public assignMandate(requestParameters: TrialManagementApiAssignMandateRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).assignMandate(requestParameters.id, requestParameters.assignMandateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary set a trial to the completed status to stop recruitment
     * @param {TrialManagementApiCompleteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public completeTrial(requestParameters: TrialManagementApiCompleteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).completeTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a comment to a trial
     * @param {TrialManagementApiCreateCommentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createComment(requestParameters: TrialManagementApiCreateCommentRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createComment(requestParameters.id, requestParameters.trialCommentBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a contact to a trial
     * @param {TrialManagementApiCreateContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createContact(requestParameters: TrialManagementApiCreateContactRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createContact(requestParameters.id, requestParameters.trialContactBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a criteria
     * @param {TrialManagementApiCreateCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createCriteria(requestParameters: TrialManagementApiCreateCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createCriteria(requestParameters.id, requestParameters.trialCriteriaBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add a location to a trial
     * @param {TrialManagementApiCreateLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createLocation(requestParameters: TrialManagementApiCreateLocationRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createLocation(requestParameters.id, requestParameters.trialLocationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the summary of a trial
     * @param {TrialManagementApiCreateSummaryTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createSummaryTranslations(requestParameters: TrialManagementApiCreateSummaryTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createSummaryTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the title of a trial
     * @param {TrialManagementApiCreateTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createTitleTranslations(requestParameters: TrialManagementApiCreateTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createTitleTranslations(requestParameters.id, requestParameters.trialTranslationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create a new trial
     * @param {TrialManagementApiCreateTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public createTrial(requestParameters: TrialManagementApiCreateTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).createTrial(requestParameters.trialCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary unmark a trial as favorite
     * @param {TrialManagementApiDeleteFavoriteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public deleteFavoriteTrial(requestParameters: TrialManagementApiDeleteFavoriteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).deleteFavoriteTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary soft delete a trial, it will be restorable for 30 days
     * @param {TrialManagementApiDeleteTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public deleteTrial(requestParameters: TrialManagementApiDeleteTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).deleteTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary fetch paginated activity log of a criteria
     * @param {TrialManagementApiGetActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getActivity(requestParameters: TrialManagementApiGetActivityRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a specific trial
     * @param {TrialManagementApiGetContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getContacts(requestParameters: TrialManagementApiGetContactsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of criteria of a specific trial
     * @param {TrialManagementApiGetCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getCriteria(requestParameters: TrialManagementApiGetCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getCriteria(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a specific trial
     * @param {TrialManagementApiGetDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getDetails(requestParameters: TrialManagementApiGetDetailsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getDetails(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get a list of all lead sponsors of the trials
     * @param {TrialManagementApiGetLeadSponsorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getLeadSponsors(requestParameters: TrialManagementApiGetLeadSponsorsRequest = {}, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getLeadSponsors(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the details of a specific trial
     * @param {TrialManagementApiGetLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getLocations(requestParameters: TrialManagementApiGetLocationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.country, requestParameters.facility, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of the userIds that fully matched a trial
     * @param {TrialManagementApiGetMatchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getMatches(requestParameters: TrialManagementApiGetMatchesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getMatches(requestParameters.id, requestParameters.showDetails, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, requestParameters.orderDirection, requestParameters.locationId, requestParameters.country, requestParameters.postalCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the list of public recruitment locations for a trial
     * @param {TrialManagementApiGetPublicLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getPublicLocations(requestParameters: TrialManagementApiGetPublicLocationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getPublicLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get public details required for requesting access to a trial.
     * @param {TrialManagementApiGetPublicTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getPublicTrials(requestParameters: TrialManagementApiGetPublicTrialsRequest = {}, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getPublicTrials(requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the summary of a trial
     * @param {TrialManagementApiGetSummaryTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getSummaryTranslations(requestParameters: TrialManagementApiGetSummaryTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getSummaryTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get information on mandates of a team
     * @param {TrialManagementApiGetTeamMandatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getTeamMandates(requestParameters: TrialManagementApiGetTeamMandatesRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getTeamMandates(requestParameters.teamId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the teams for a trial
     * @param {TrialManagementApiGetTeamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getTeams(requestParameters: TrialManagementApiGetTeamsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getTeams(requestParameters.id, requestParameters.limit, requestParameters.nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of translations of the title of a trial
     * @param {TrialManagementApiGetTitleTranslationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getTitleTranslations(requestParameters: TrialManagementApiGetTitleTranslationsRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getTitleTranslations(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of activities on a funnel page
     * @param {TrialManagementApiGetVolunteerActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerActivity(requestParameters: TrialManagementApiGetVolunteerActivityRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerActivity(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.researcherId, requestParameters.start, requestParameters.end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the paginated list of the users that can be filtered on in the funnel activity list
     * @param {TrialManagementApiGetVolunteerActivityUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerActivityUsers(requestParameters: TrialManagementApiGetVolunteerActivityUsersRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerActivityUsers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the answers of a volunteer for a specific volunteer
     * @param {TrialManagementApiGetVolunteerAnswersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerAnswers(requestParameters: TrialManagementApiGetVolunteerAnswersRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerAnswers(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.order, requestParameters.status, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the contact details of a volunteer of a specific trial
     * @param {TrialManagementApiGetVolunteerContactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteerContact(requestParameters: TrialManagementApiGetVolunteerContactRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteerContact(requestParameters.id, requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of volunteers of a specific trial
     * @param {TrialManagementApiGetVolunteersOverviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public getVolunteersOverview(requestParameters: TrialManagementApiGetVolunteersOverviewRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).getVolunteersOverview(requestParameters.id, requestParameters.locationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Recalculate the cache of a user
     * @param {TrialManagementApiRecalculateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public recalculate(requestParameters: TrialManagementApiRecalculateRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).recalculate(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reset the acceptance flow for the trial to the default
     * @param {TrialManagementApiRemoveEffectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public removeEffect(requestParameters: TrialManagementApiRemoveEffectRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).removeEffect(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request a booster for a trial
     * @param {TrialManagementApiRequestBoosterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public requestBooster(requestParameters: TrialManagementApiRequestBoosterRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).requestBooster(requestParameters.id, requestParameters.trialBoosterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary request a new criteria for a trial
     * @param {TrialManagementApiRequestCriteriaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public requestCriteria(requestParameters: TrialManagementApiRequestCriteriaRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).requestCriteria(requestParameters.id, requestParameters.criteriaRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Regenerate user trial cache. After changes are made to a trial this endpoint makes sure that the user cache is updated.
     * @param {TrialManagementApiResetTrialCacheRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public resetTrialCache(requestParameters: TrialManagementApiResetTrialCacheRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).resetTrialCache(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the status of a user in a trial
     * @param {TrialManagementApiRespondToVolunteerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public respondToVolunteer(requestParameters: TrialManagementApiRespondToVolunteerRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).respondToVolunteer(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary restore a deleted trial
     * @param {TrialManagementApiRestoreTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public restoreTrial(requestParameters: TrialManagementApiRestoreTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).restoreTrial(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get all trials, paginated, searchable. If a user can only see a limited number of trials, then only those are returned.
     * @param {TrialManagementApiSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public search(requestParameters: TrialManagementApiSearchRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).search(requestParameters.getTrialsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set mandate status to active (unpaid)
     * @param {TrialManagementApiUnassignMandateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public unassignMandate(requestParameters: TrialManagementApiUnassignMandateRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).unassignMandate(requestParameters.id, requestParameters.unassignMandateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update a trial
     * @param {TrialManagementApiUpdateTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public updateTrial(requestParameters: TrialManagementApiUpdateTrialRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).updateTrial(requestParameters.id, requestParameters.updateTrialBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary indicate the contact date of a  volunteer
     * @param {TrialManagementApiUpdateVolunteerContactedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public updateVolunteerContacted(requestParameters: TrialManagementApiUpdateVolunteerContactedRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).updateVolunteerContacted(requestParameters.id, requestParameters.userId, requestParameters.trialVolunteerContactBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary validate all properties of a trial
     * @param {TrialManagementApiValidateAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public validateAll(requestParameters: TrialManagementApiValidateAllRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).validateAll(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reach out to eligible patients for a trial
     * @param {TrialManagementApiVolunteerReachOutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TrialManagementApi
     */
    public volunteerReachOut(requestParameters: TrialManagementApiVolunteerReachOutRequest, options?: RawAxiosRequestConfig) {
        return TrialManagementApiFp(this.configuration).volunteerReachOut(requestParameters.id, requestParameters.trialReachOutBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Allow user to delete themselves.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Allow admin to delete any user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get overview of admins and reviewers on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/overview/admins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Allow user to delete themselves.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Allow admin to delete any user
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get overview of admins and reviewers on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListAdminOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getAdminOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Allow user to delete themselves.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Allow admin to delete any user
         * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: UserApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get overview of admins and reviewers on the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOverview(options?: RawAxiosRequestConfig): AxiosPromise<ListAdminOverviewView> {
            return localVarFp.getAdminOverview(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteUser operation in UserApi.
 * @export
 * @interface UserApiDeleteUserRequest
 */
export interface UserApiDeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserApiDeleteUser
     */
    readonly id: string
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Allow user to delete themselves.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteCurrentUser(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Allow admin to delete any user
     * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(requestParameters: UserApiDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get overview of admins and reviewers on the platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getAdminOverview(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getAdminOverview(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserSurveysApi - axios parameter creator
 * @export
 */
export const UserSurveysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get survey detail for one of the users surveys
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveyDetail: async (language: Language, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMySurveyDetail', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMySurveyDetail', 'id', id)
            const localVarPath = `/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of my surveys
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveys: async (status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getMySurveys', 'status', status)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMySurveys', 'language', language)
            const localVarPath = `/surveys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of a patient\'s surveys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveysOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/surveys/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject a survey
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMySurvey: async (id: string, body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectMySurvey', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rejectMySurvey', 'body', body)
            const localVarPath = `/surveys/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or stop the my surveys flow
         * @param {string} id 
         * @param {UpdateMySurveyBody} updateMySurveyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMySurveyFlow: async (id: string, updateMySurveyBody: UpdateMySurveyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMySurveyFlow', 'id', id)
            // verify required parameter 'updateMySurveyBody' is not null or undefined
            assertParamExists('updateMySurveyFlow', 'updateMySurveyBody', updateMySurveyBody)
            const localVarPath = `/surveys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMySurveyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserSurveysApi - functional programming interface
 * @export
 */
export const UserSurveysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserSurveysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get survey detail for one of the users surveys
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySurveyDetail(language: Language, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSurveyDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySurveyDetail(language, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.getMySurveyDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of my surveys
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMySurveys(status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserSurveyView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMySurveys(status, language, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.getMySurveys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of a patient\'s surveys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSurveysOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SurveysOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSurveysOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.getSurveysOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reject a survey
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectMySurvey(id: string, body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectMySurvey(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.rejectMySurvey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start or stop the my surveys flow
         * @param {string} id 
         * @param {UpdateMySurveyBody} updateMySurveyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMySurveyFlow(id: string, updateMySurveyBody: UpdateMySurveyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMySurveyFlow(id, updateMySurveyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserSurveysApi.updateMySurveyFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserSurveysApi - factory interface
 * @export
 */
export const UserSurveysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserSurveysApiFp(configuration)
    return {
        /**
         * 
         * @summary Get survey detail for one of the users surveys
         * @param {UserSurveysApiGetMySurveyDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveyDetail(requestParameters: UserSurveysApiGetMySurveyDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSurveyDetailView> {
            return localVarFp.getMySurveyDetail(requestParameters.language, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of my surveys
         * @param {UserSurveysApiGetMySurveysRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMySurveys(requestParameters: UserSurveysApiGetMySurveysRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListUserSurveyView> {
            return localVarFp.getMySurveys(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of a patient\'s surveys
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSurveysOverview(options?: RawAxiosRequestConfig): AxiosPromise<SurveysOverviewView> {
            return localVarFp.getSurveysOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject a survey
         * @param {UserSurveysApiRejectMySurveyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectMySurvey(requestParameters: UserSurveysApiRejectMySurveyRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectMySurvey(requestParameters.id, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or stop the my surveys flow
         * @param {UserSurveysApiUpdateMySurveyFlowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMySurveyFlow(requestParameters: UserSurveysApiUpdateMySurveyFlowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMySurveyFlow(requestParameters.id, requestParameters.updateMySurveyBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMySurveyDetail operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiGetMySurveyDetailRequest
 */
export interface UserSurveysApiGetMySurveyDetailRequest {
    /**
     * 
     * @type {Language}
     * @memberof UserSurveysApiGetMySurveyDetail
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof UserSurveysApiGetMySurveyDetail
     */
    readonly id: string
}

/**
 * Request parameters for getMySurveys operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiGetMySurveysRequest
 */
export interface UserSurveysApiGetMySurveysRequest {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly status: UserTrialStatus

    /**
     * 
     * @type {Language}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserSurveysApiGetMySurveys
     */
    readonly offset?: number | null
}

/**
 * Request parameters for rejectMySurvey operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiRejectMySurveyRequest
 */
export interface UserSurveysApiRejectMySurveyRequest {
    /**
     * 
     * @type {string}
     * @memberof UserSurveysApiRejectMySurvey
     */
    readonly id: string

    /**
     * 
     * @type {object}
     * @memberof UserSurveysApiRejectMySurvey
     */
    readonly body: object
}

/**
 * Request parameters for updateMySurveyFlow operation in UserSurveysApi.
 * @export
 * @interface UserSurveysApiUpdateMySurveyFlowRequest
 */
export interface UserSurveysApiUpdateMySurveyFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof UserSurveysApiUpdateMySurveyFlow
     */
    readonly id: string

    /**
     * 
     * @type {UpdateMySurveyBody}
     * @memberof UserSurveysApiUpdateMySurveyFlow
     */
    readonly updateMySurveyBody: UpdateMySurveyBody
}

/**
 * UserSurveysApi - object-oriented interface
 * @export
 * @class UserSurveysApi
 * @extends {BaseAPI}
 */
export class UserSurveysApi extends BaseAPI {
    /**
     * 
     * @summary Get survey detail for one of the users surveys
     * @param {UserSurveysApiGetMySurveyDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public getMySurveyDetail(requestParameters: UserSurveysApiGetMySurveyDetailRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).getMySurveyDetail(requestParameters.language, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of my surveys
     * @param {UserSurveysApiGetMySurveysRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public getMySurveys(requestParameters: UserSurveysApiGetMySurveysRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).getMySurveys(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of a patient\'s surveys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public getSurveysOverview(options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).getSurveysOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject a survey
     * @param {UserSurveysApiRejectMySurveyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public rejectMySurvey(requestParameters: UserSurveysApiRejectMySurveyRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).rejectMySurvey(requestParameters.id, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or stop the my surveys flow
     * @param {UserSurveysApiUpdateMySurveyFlowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserSurveysApi
     */
    public updateMySurveyFlow(requestParameters: UserSurveysApiUpdateMySurveyFlowRequest, options?: RawAxiosRequestConfig) {
        return UserSurveysApiFp(this.configuration).updateMySurveyFlow(requestParameters.id, requestParameters.updateMySurveyBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserTrialsApi - axios parameter creator
 * @export
 */
export const UserTrialsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentFlow: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trials/current-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trial detail for one of the users trials
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialDetail: async (language: Language, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMyTrialDetail', 'language', language)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyTrialDetail', 'id', id)
            const localVarPath = `/trials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of locations for a Trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialLocations: async (id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyTrialLocations', 'id', id)
            const localVarPath = `/trials/{id}/locations`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of my trials
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {GetUserTrialsOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrials: async (status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, orderBy?: GetUserTrialsOrderBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('getMyTrials', 'status', status)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getMyTrials', 'language', language)
            const localVarPath = `/trials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of my contacts
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialContacts: async (id: string, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTrialContacts', 'id', id)
            const localVarPath = `/trials/{id}/contacts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get the overview of a patient\'s trials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialsOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/trials/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
         * @param {string} id 
         * @param {UserTrialFeedbackBody} userTrialFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondWithFeedback: async (id: string, userTrialFeedbackBody: UserTrialFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('respondWithFeedback', 'id', id)
            // verify required parameter 'userTrialFeedbackBody' is not null or undefined
            assertParamExists('respondWithFeedback', 'userTrialFeedbackBody', userTrialFeedbackBody)
            const localVarPath = `/trials/{id}/feedback`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTrialFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start or stop the my trials flow
         * @param {string} id 
         * @param {UpdateMyTrialBody} updateMyTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyTrialFlow: async (id: string, updateMyTrialBody: UpdateMyTrialBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMyTrialFlow', 'id', id)
            // verify required parameter 'updateMyTrialBody' is not null or undefined
            assertParamExists('updateMyTrialFlow', 'updateMyTrialBody', updateMyTrialBody)
            const localVarPath = `/trials/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyTrialBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserTrialsApi - functional programming interface
 * @export
 */
export const UserTrialsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserTrialsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentFlow(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentFlowView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentFlow(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getCurrentFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get trial detail for one of the users trials
         * @param {Language} language 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTrialDetail(language: Language, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTrialDetailView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTrialDetail(language, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMyTrialDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of locations for a Trial
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {string | null} [searchString] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTrialLocations(id: string, limit?: number | null, offset?: number | null, searchString?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListLocationView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTrialLocations(id, limit, offset, searchString, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMyTrialLocations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of my trials
         * @param {UserTrialStatus} status 
         * @param {Language} language 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {GetUserTrialsOrderBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyTrials(status: UserTrialStatus, language: Language, limit?: number | null, offset?: number | null, orderBy?: GetUserTrialsOrderBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListUserTrialView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyTrials(status, language, limit, offset, orderBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getMyTrials']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of my contacts
         * @param {string} id 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialContacts(id: string, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListContactView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialContacts(id, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getTrialContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get the overview of a patient\'s trials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTrialsOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrialsOverviewView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTrialsOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.getTrialsOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
         * @param {string} id 
         * @param {UserTrialFeedbackBody} userTrialFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondWithFeedback(id: string, userTrialFeedbackBody: UserTrialFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserTrialFeedBackView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondWithFeedback(id, userTrialFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.respondWithFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Start or stop the my trials flow
         * @param {string} id 
         * @param {UpdateMyTrialBody} updateMyTrialBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMyTrialFlow(id: string, updateMyTrialBody: UpdateMyTrialBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMyTrialFlow(id, updateMyTrialBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserTrialsApi.updateMyTrialFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserTrialsApi - factory interface
 * @export
 */
export const UserTrialsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserTrialsApiFp(configuration)
    return {
        /**
         * 
         * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentFlow(options?: RawAxiosRequestConfig): AxiosPromise<CurrentFlowView> {
            return localVarFp.getCurrentFlow(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trial detail for one of the users trials
         * @param {UserTrialsApiGetMyTrialDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialDetail(requestParameters: UserTrialsApiGetMyTrialDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserTrialDetailView> {
            return localVarFp.getMyTrialDetail(requestParameters.language, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of locations for a Trial
         * @param {UserTrialsApiGetMyTrialLocationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrialLocations(requestParameters: UserTrialsApiGetMyTrialLocationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListLocationView> {
            return localVarFp.getMyTrialLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of my trials
         * @param {UserTrialsApiGetMyTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyTrials(requestParameters: UserTrialsApiGetMyTrialsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListUserTrialView> {
            return localVarFp.getMyTrials(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of my contacts
         * @param {UserTrialsApiGetTrialContactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialContacts(requestParameters: UserTrialsApiGetTrialContactsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListContactView> {
            return localVarFp.getTrialContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get the overview of a patient\'s trials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTrialsOverview(options?: RawAxiosRequestConfig): AxiosPromise<TrialsOverviewView> {
            return localVarFp.getTrialsOverview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
         * @param {UserTrialsApiRespondWithFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondWithFeedback(requestParameters: UserTrialsApiRespondWithFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserTrialFeedBackView> {
            return localVarFp.respondWithFeedback(requestParameters.id, requestParameters.userTrialFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start or stop the my trials flow
         * @param {UserTrialsApiUpdateMyTrialFlowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMyTrialFlow(requestParameters: UserTrialsApiUpdateMyTrialFlowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateMyTrialFlow(requestParameters.id, requestParameters.updateMyTrialBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getMyTrialDetail operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMyTrialDetailRequest
 */
export interface UserTrialsApiGetMyTrialDetailRequest {
    /**
     * 
     * @type {Language}
     * @memberof UserTrialsApiGetMyTrialDetail
     */
    readonly language: Language

    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMyTrialDetail
     */
    readonly id: string
}

/**
 * Request parameters for getMyTrialLocations operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMyTrialLocationsRequest
 */
export interface UserTrialsApiGetMyTrialLocationsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly offset?: number | null

    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetMyTrialLocations
     */
    readonly searchString?: string | null
}

/**
 * Request parameters for getMyTrials operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetMyTrialsRequest
 */
export interface UserTrialsApiGetMyTrialsRequest {
    /**
     * 
     * @type {UserTrialStatus}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly status: UserTrialStatus

    /**
     * 
     * @type {Language}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly language: Language

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly offset?: number | null

    /**
     * 
     * @type {GetUserTrialsOrderBy}
     * @memberof UserTrialsApiGetMyTrials
     */
    readonly orderBy?: GetUserTrialsOrderBy
}

/**
 * Request parameters for getTrialContacts operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiGetTrialContactsRequest
 */
export interface UserTrialsApiGetTrialContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiGetTrialContacts
     */
    readonly id: string

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetTrialContacts
     */
    readonly limit?: number | null

    /**
     * 
     * @type {number}
     * @memberof UserTrialsApiGetTrialContacts
     */
    readonly offset?: number | null
}

/**
 * Request parameters for respondWithFeedback operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiRespondWithFeedbackRequest
 */
export interface UserTrialsApiRespondWithFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiRespondWithFeedback
     */
    readonly id: string

    /**
     * 
     * @type {UserTrialFeedbackBody}
     * @memberof UserTrialsApiRespondWithFeedback
     */
    readonly userTrialFeedbackBody: UserTrialFeedbackBody
}

/**
 * Request parameters for updateMyTrialFlow operation in UserTrialsApi.
 * @export
 * @interface UserTrialsApiUpdateMyTrialFlowRequest
 */
export interface UserTrialsApiUpdateMyTrialFlowRequest {
    /**
     * 
     * @type {string}
     * @memberof UserTrialsApiUpdateMyTrialFlow
     */
    readonly id: string

    /**
     * 
     * @type {UpdateMyTrialBody}
     * @memberof UserTrialsApiUpdateMyTrialFlow
     */
    readonly updateMyTrialBody: UpdateMyTrialBody
}

/**
 * UserTrialsApi - object-oriented interface
 * @export
 * @class UserTrialsApi
 * @extends {BaseAPI}
 */
export class UserTrialsApi extends BaseAPI {
    /**
     * 
     * @summary return the trial (or research entity) that the patient is currently following the myTrial flow for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getCurrentFlow(options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getCurrentFlow(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trial detail for one of the users trials
     * @param {UserTrialsApiGetMyTrialDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMyTrialDetail(requestParameters: UserTrialsApiGetMyTrialDetailRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMyTrialDetail(requestParameters.language, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of locations for a Trial
     * @param {UserTrialsApiGetMyTrialLocationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMyTrialLocations(requestParameters: UserTrialsApiGetMyTrialLocationsRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMyTrialLocations(requestParameters.id, requestParameters.limit, requestParameters.offset, requestParameters.searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of my trials
     * @param {UserTrialsApiGetMyTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getMyTrials(requestParameters: UserTrialsApiGetMyTrialsRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getMyTrials(requestParameters.status, requestParameters.language, requestParameters.limit, requestParameters.offset, requestParameters.orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of my contacts
     * @param {UserTrialsApiGetTrialContactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getTrialContacts(requestParameters: UserTrialsApiGetTrialContactsRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getTrialContacts(requestParameters.id, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get the overview of a patient\'s trials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public getTrialsOverview(options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).getTrialsOverview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Respond to a trial that\'s eligible or active. (Active can only be rejected)
     * @param {UserTrialsApiRespondWithFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public respondWithFeedback(requestParameters: UserTrialsApiRespondWithFeedbackRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).respondWithFeedback(requestParameters.id, requestParameters.userTrialFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start or stop the my trials flow
     * @param {UserTrialsApiUpdateMyTrialFlowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTrialsApi
     */
    public updateMyTrialFlow(requestParameters: UserTrialsApiUpdateMyTrialFlowRequest, options?: RawAxiosRequestConfig) {
        return UserTrialsApiFp(this.configuration).updateMyTrialFlow(requestParameters.id, requestParameters.updateMyTrialBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WebhookApi - axios parameter creator
 * @export
 */
export const WebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Process a submission from jotform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processJotSubmission: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webhooks/jot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebhookApi - functional programming interface
 * @export
 */
export const WebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Process a submission from jotform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processJotSubmission(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processJotSubmission(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WebhookApi.processJotSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WebhookApi - factory interface
 * @export
 */
export const WebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WebhookApiFp(configuration)
    return {
        /**
         * 
         * @summary Process a submission from jotform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processJotSubmission(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.processJotSubmission(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WebhookApi - object-oriented interface
 * @export
 * @class WebhookApi
 * @extends {BaseAPI}
 */
export class WebhookApi extends BaseAPI {
    /**
     * 
     * @summary Process a submission from jotform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebhookApi
     */
    public processJotSubmission(options?: RawAxiosRequestConfig) {
        return WebhookApiFp(this.configuration).processJotSubmission(options).then((request) => request(this.axios, this.basePath));
    }
}



